var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __require = /* @__PURE__ */ ((x2) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x2, {
  get: (a2, b3) => (typeof require !== "undefined" ? require : a2)[b3]
}) : x2)(function(x2) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x2 + '" is not supported');
});
var __esm = (fn2, res) => function __init() {
  return fn2 && (res = (0, fn2[__getOwnPropNames(fn2)[0]])(fn2 = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// ../../node_modules/.pnpm/@magic-sdk+types@24.8.0/node_modules/@magic-sdk/types/dist/es/index.mjs
var p, m, d, _, u, v, f, g, E, x, A, I, y, R, N, T, h, O, b, S, k, F, L, w, U, D, V, C, G, H, q, W, J, Y;
var init_es = __esm({
  "../../node_modules/.pnpm/@magic-sdk+types@24.8.0/node_modules/@magic-sdk/types/dist/es/index.mjs"() {
    "use strict";
    p = ((a2) => (a2.MissingApiKey = "MISSING_API_KEY", a2.ModalNotReady = "MODAL_NOT_READY", a2.MalformedResponse = "MALFORMED_RESPONSE", a2.InvalidArgument = "INVALID_ARGUMENT", a2.ExtensionNotInitialized = "EXTENSION_NOT_INITIALIZED", a2.IncompatibleExtensions = "INCOMPATIBLE_EXTENSIONS", a2))(p || {});
    m = ((o) => (o.SyncWeb3Method = "SYNC_WEB3_METHOD", o.DuplicateIframe = "DUPLICATE_IFRAME", o.ReactNativeEndpointConfiguration = "REACT_NATIVE_ENDPOINT_CONFIGURATION", o.DeprecationNotice = "DEPRECATION_NOTICE", o.ProductAnnouncement = "ANNOUNCEMENT", o))(m || {});
    d = ((i) => (i[i.ParseError = -32700] = "ParseError", i[i.InvalidRequest = -32600] = "InvalidRequest", i[i.MethodNotFound = -32601] = "MethodNotFound", i[i.InvalidParams = -32602] = "InvalidParams", i[i.InternalError = -32603] = "InternalError", i[i.MagicLinkFailedVerification = -1e4] = "MagicLinkFailedVerification", i[i.MagicLinkExpired = -10001] = "MagicLinkExpired", i[i.MagicLinkRateLimited = -10002] = "MagicLinkRateLimited", i[i.MagicLinkInvalidRedirectURL = -10006] = "MagicLinkInvalidRedirectURL", i[i.UserAlreadyLoggedIn = -10003] = "UserAlreadyLoggedIn", i[i.UpdateEmailFailed = -10004] = "UpdateEmailFailed", i[i.UserRequestEditEmail = -10005] = "UserRequestEditEmail", i[i.InactiveRecipient = -10010] = "InactiveRecipient", i[i.AccessDeniedToUser = -10011] = "AccessDeniedToUser", i[i.RedirectLoginComplete = -10015] = "RedirectLoginComplete", i))(d || {});
    _ = ((s) => (s.MetaMask = "metamask", s.CoinbaseWallet = "coinbase_wallet", s))(_ || {});
    u = ((t) => (t.WalletSelected = "wallet_selected", t.WalletConnected = "wallet_connected", t.WalletRejected = "wallet_rejected", t))(u || {});
    v = ((e) => (e.LoginWithSms = "magic_auth_login_with_sms", e.LoginWithEmailOTP = "magic_auth_login_with_email_otp", e.LoginWithMagicLink = "magic_auth_login_with_magic_link", e.LoginWithCredential = "magic_auth_login_with_credential", e.SetAuthorizationToken = "magic_auth_set_authorization_token", e.GetIdToken = "magic_auth_get_id_token", e.GenerateIdToken = "magic_auth_generate_id_token", e.GetMetadata = "magic_auth_get_metadata", e.IsLoggedIn = "magic_is_logged_in", e.Logout = "magic_auth_logout", e.UpdateEmail = "magic_auth_update_email", e.UserSettings = "magic_auth_settings", e.UserSettingsTestMode = "magic_auth_settings_testing_mode", e.LoginWithSmsTestMode = "magic_auth_login_with_sms_testing_mode", e.LoginWithEmailOTPTestMode = "magic_auth_login_with_email_otp_testing_mode", e.LoginWithMagicLinkTestMode = "magic_login_with_magic_link_testing_mode", e.LoginWithCredentialTestMode = "magic_auth_login_with_credential_testing_mode", e.GetIdTokenTestMode = "magic_auth_get_id_token_testing_mode", e.GenerateIdTokenTestMode = "magic_auth_generate_id_token_testing_mode", e.GetMetadataTestMode = "magic_auth_get_metadata_testing_mode", e.IsLoggedInTestMode = "magic_auth_is_logged_in_testing_mode", e.LogoutTestMode = "magic_auth_logout_testing_mode", e.UpdateEmailTestMode = "magic_auth_update_email_testing_mode", e.IntermediaryEvent = "magic_intermediary_event", e.RequestAccounts = "eth_requestAccounts", e.GetInfo = "magic_get_info", e.ShowUI = "magic_wallet", e.NFTPurchase = "magic_nft_purchase", e.NFTCheckout = "magic_nft_checkout", e.NFTTransfer = "magic_nft_transfer", e.RequestUserInfoWithUI = "mc_request_user_info", e.Disconnect = "mc_disconnect", e.RecoverAccount = "magic_auth_recover_account", e.RecoverAccountTestMode = "magic_auth_recover_account_testing_mode", e.MagicBoxHeartBeat = "magic_box_heart_beat", e.AutoConnect = "mc_auto_connect", e.Login = "mc_login", e.EncryptV1 = "magic_auth_encrypt_v1", e.DecryptV1 = "magic_auth_decrypt_v1", e.ShowNFTs = "magic_show_nfts", e.ShowOnRamp = "magic_show_fiat_onramp", e.ShowSendTokensUI = "magic_show_send_tokens_ui", e.ShowAddress = "magic_show_address", e.ShowBalances = "magic_show_balances", e.SendGaslessTransaction = "eth_sendGaslessTransaction", e.RevealPK = "magic_reveal_key", e.EnableMFA = "magic_auth_enable_mfa_flow", e.DisableMFA = "magic_auth_disable_mfa_flow", e))(v || {});
    f = ((l) => (l.MAGIC_HANDLE_RESPONSE = "MAGIC_HANDLE_RESPONSE", l.MAGIC_OVERLAY_READY = "MAGIC_OVERLAY_READY", l.MAGIC_SHOW_OVERLAY = "MAGIC_SHOW_OVERLAY", l.MAGIC_HIDE_OVERLAY = "MAGIC_HIDE_OVERLAY", l.MAGIC_HANDLE_EVENT = "MAGIC_HANDLE_EVENT", l.MAGIC_MG_BOX_SEND_RECEIPT = "MAGIC_MG_BOX_SEND_RECEIPT", l.MAGIC_SEND_PRODUCT_ANNOUNCEMENT = "MAGIC_SEND_PRODUCT_ANNOUNCEMENT", l))(f || {});
    g = ((n) => (n.MAGIC_HANDLE_REQUEST = "MAGIC_HANDLE_REQUEST", n))(g || {});
    E = ((t) => (t.UpdateEmail = "update-email", t.MFA = "mfa", t.Recovery = "recovery", t))(E || {});
    x = ((n) => (n.Retry = "retry", n))(x || {});
    A = ((s) => (s.EmailSent = "email-sent", s.EmailNotDeliverable = "email-not-deliverable", s))(A || {});
    I = ((t) => (t.VerifyEmailOtp = "verify-email-otp", t.VerifyMFACode = "verify-mfa-code", t.Cancel = "cancel", t))(I || {});
    y = ((t) => (t.VerifySmsOtp = "verify-sms-otp", t.Cancel = "cancel", t.Retry = "retry", t))(y || {});
    R = ((t) => (t.SmsOTPSent = "sms-otp-sent", t.InvalidSmsOtp = "invalid-sms-otp", t.ExpiredSmsOtp = "expired-sms-otp", t))(R || {});
    N = ((o) => (o.EmailOTPSent = "email-otp-sent", o.InvalidEmailOtp = "invalid-email-otp", o.InvalidMfaOtp = "invalid-mfa-otp", o.ExpiredEmailOtp = "expired-email-otp", o.MfaSentHandle = "mfa-sent-handle", o))(N || {});
    T = ((n) => (n.Retry = "device-retry", n))(T || {});
    h = ((r) => (r.DeviceApproved = "device-approved", r.DeviceNeedsApproval = "device-needs-approval", r.DeviceVerificationLinkExpired = "device-verification-link-expired", r.DeviceVerificationEmailSent = "device-verification-email-sent", r))(h || {});
    O = ((r) => (r.Retry = "Recency/auth-factor-retry", r.Cancel = "Recency/auth-factor-verification-cancel", r.VerifyEmailOtp = "Recency/auth-factor-verify-email-otp", r.VerifyMFACode = "Recency/verify-mfa-code", r))(O || {});
    b = ((a2) => (a2.PrimaryAuthFactorNeedsVerification = "Recency/auth-factor-needs-verification", a2.PrimaryAuthFactorVerified = "Recency/auth-factor-verified", a2.InvalidEmailOtp = "Recency/auth-factor-invalid-email-otp", a2.EmailExpired = "Recency/auth-factor-verification-email-expired", a2.EmailSent = "Recency/auth-factor-verification-email-sent", a2.EmailNotDeliverable = "Recency/auth-factor-verification-email-not-deliverable", a2))(b || {});
    S = ((t) => (t.RetryWithNewEmail = "UpdateEmail/retry-with-new-email", t.Cancel = "UpdateEmail/new-email-verification-cancel", t.VerifyEmailOtp = "UpdateEmail/new-email-verify-otp", t))(S || {});
    k = ((c2) => (c2.NewAuthFactorNeedsVerification = "UpdateEmail/new-email-needs-verification", c2.EmailUpdated = "UpdateEmail/email-updated", c2.InvalidEmailOtp = "UpdateEmail/new-email-invalid-email-otp", c2.EmailExpired = "UpdateEmail/new-email-verification-email-expired", c2.EmailSent = "UpdateEmail/new-email-verification-email-sent", c2.EmailNotDeliverable = "UpdateEmail/new-email-verification-email-not-deliverable", c2.InvalidEmail = "UpdateEmail/new-email-invalid", c2.EmailAlreadyExists = "UpdateEmail/new-email-already-exists", c2))(k || {});
    F = ((n) => (n.IDTokenCreated = "Auth/id-token-created", n))(F || {});
    L = ((n) => (n.SuccessSignIn = "Farcaster/success_sign_in", n))(L || {});
    w = ((t) => (t.MFASecretGenerated = "mfa-secret-generated", t.InvalidMFAOtp = "invalid-mfa-otp", t.MFARecoveryCodes = "mfa-recovery-codes", t))(w || {});
    U = ((s) => (s.VerifyMFACode = "verify-mfa-code", s.Cancel = "cancel-mfa-setup", s))(U || {});
    D = ((t) => (t.MFACodeRequested = "mfa-code-requested", t.InvalidMFAOtp = "invalid-mfa-otp", t.InvalidRecoveryCode = "invalid-recovery-code", t))(D || {});
    V = ((t) => (t.VerifyMFACode = "verify-mfa-code", t.LostDevice = "lost-device", t.Cancel = "cancel-mfa-disable", t))(V || {});
    C = ((n) => (n.Harmony = "HARMONY", n))(C || {});
    G = ((n) => (n.ClosedByUser = "closed-by-user", n))(G || {});
    H = ((n) => (n.ClosedByUser = "closed-by-user-on-received", n))(H || {});
    q = ((n) => (n.PhoneNumber = "phone_number", n))(q || {});
    W = ((r) => (r.Success = "nft-checkout-success", r.Failure = "nft-checkout-failure", r.Initiated = "nft-checkout-initiated", r.Disconnect = "disconnect", r))(W || {});
    J = ((n) => (n.WalletInfoFetched = "Wallet/wallet-info-fetched", n))(J || {});
    Y = ((n) => (n.CloseMagicWindow = "close-magic-window", n))(Y || {});
  }
});

// ../../node_modules/.pnpm/@magic-sdk+provider@28.6.0_localforage@1.10.0/node_modules/@magic-sdk/provider/dist/es/index.mjs
function tn(n) {
  let t = { exports: {} };
  return n(t, t.exports), t.exports;
}
function Dn(n) {
  return String.fromCharCode(parseInt(n.slice(1), 16));
}
function Un(n) {
  return `%${`00${n.charCodeAt(0).toString(16)}`.slice(-2)}`;
}
function Wn(n) {
  return btoa(encodeURIComponent(n).replace(/%[0-9A-F]{2}/g, Dn));
}
function Fn(n) {
  return decodeURIComponent(Array.from(atob(n), Un).join(""));
}
function fe(n) {
  return Wn(JSON.stringify(n));
}
function dt(n) {
  return JSON.parse(Fn(n));
}
function O2(n) {
  return typeof n == "undefined";
}
function Kn(n) {
  return n === null;
}
function Ee(n) {
  return Kn(n) || O2(n);
}
function ut(n) {
  return Ee(n) ? false : !O2(n.jsonrpc) && !O2(n.id) && (!O2(n.result) || !O2(n.error));
}
function pt(n) {
  return Ee(n) ? false : typeof n == "number" && Object.values(d).includes(n);
}
function se(n) {
  if (!n) return true;
  for (let t in n) if (Object.hasOwnProperty.call(n, t)) return false;
  return true;
}
function jn(n, t) {
  return Object.assign(h2, t), n;
}
function mt() {
  return new S2(p.MissingApiKey, "Please provide an API key that you acquired from the Magic developer dashboard.");
}
function ft() {
  return new S2(p.ModalNotReady, "Modal is not ready.");
}
function Et() {
  return new S2(p.MalformedResponse, "Response from the Magic iframe is malformed.");
}
function yt(n) {
  return new S2(p.ExtensionNotInitialized, `Extensions must be initialized with a Magic SDK instance before \`Extension.${n}\` can be accessed. Do not invoke \`Extension.${n}\` inside an extension constructor.`);
}
function gt(n) {
  let t = `Some extensions are incompatible with \`${h2.sdkName}@${h2.version}\`:`;
  return n.filter((e) => typeof e.compat != "undefined" && e.compat !== null).forEach((e) => {
    let r = e.compat[h2.sdkName];
    typeof r == "string" ? t += `
  - Extension \`${e.name}\` supports version(s) \`${r}\`` : r || (t += `
  - Extension \`${e.name}\` does not support ${h2.platform} environments.`);
  }), new S2(p.IncompatibleExtensions, t);
}
function Rt(n) {
  let t = (e) => {
    let r = e + 1, o = r % 10, s = r % 100;
    return o === 1 && s !== 11 ? `${r}st` : o === 2 && s !== 12 ? `${r}nd` : o === 3 && s !== 13 ? `${r}rd` : `${r}th`;
  };
  return new S2(p.InvalidArgument, `Invalid ${t(n.argument)} argument given to \`${n.procedure}\`.
  Expected: \`${n.expected}\`
  Received: \`${n.received}\``);
}
function Wr() {
  return new U2(m.DuplicateIframe, "Duplicate iframes found.");
}
function vt() {
  return new U2(m.SyncWeb3Method, "Non-async web3 methods are deprecated in web3 > 1.0 and are not supported by the Magic web3 provider. Please use an async method instead.");
}
function Tt() {
  return new U2(m.ReactNativeEndpointConfiguration, `CUSTOM DOMAINS ARE NOT SUPPORTED WHEN USING MAGIC SDK WITH REACT NATIVE! The \`endpoint\` parameter SHOULD NOT be provided. The Magic \`<iframe>\` is automatically wrapped by a WebView pointed at \`${h2.defaultEndpoint}\`. Changing this default behavior will lead to unexpected results and potentially security-threatening bugs.`);
}
function W2(n) {
  let { method: t, removalVersions: e, useInstead: r } = n, o = e[h2.sdkName], s = r ? ` Use \`${r}\` instead.` : "", i = `\`${t}\` will be removed from \`${h2.sdkName}\` in version \`${o}\`.${s}`;
  return new U2(m.DeprecationNotice, i);
}
function* Vn() {
  let n = 0;
  for (; ; ) n < Number.MAX_SAFE_INTEGER ? yield ++n : n = 0;
}
function Le() {
  return Hn.next().value;
}
function bt(n) {
  return Object.defineProperty(n, It, { value: true, enumerable: false }), n;
}
function Xn(n) {
  return !!n[It];
}
function K(n) {
  var t, e, r;
  return Xn(n) || (n.jsonrpc = (t = n.jsonrpc) != null ? t : "2.0", n.id = Le(), n.method = (e = n.method) != null ? e : "noop", n.params = (r = n.params) != null ? r : [], bt(n)), n;
}
function u2(n, t = []) {
  return bt({ params: t, method: n, jsonrpc: "2.0", id: Le() });
}
function Re() {
  let n = new _e();
  return { emitter: n, createChainingEmitterMethod: (r, o) => (...s) => (n[r].apply(n, s), o), createBoundEmitterMethod: (r) => (...o) => n[r].apply(n, o) };
}
function Ct(n) {
  return !!n[xt];
}
function k2(n) {
  let t = ke(n), { createBoundEmitterMethod: e, createChainingEmitterMethod: r } = Re(), o = Symbol("Promise.then"), s = Symbol("Promise.catch"), i = Symbol("Promise.finally"), a2 = (d2, p2) => (...x2) => {
    let v2 = p2[d2].apply(p2, x2);
    return c2(v2);
  }, c2 = (d2) => Object.assign(d2, { [xt]: true, [o]: d2[o] || d2.then, [s]: d2[s] || d2.catch, [i]: d2[i] || d2.finally, then: a2(o, d2), catch: a2(s, d2), finally: a2(i, d2), on: r("on", d2), once: r("once", d2), addListener: r("addListener", d2), off: r("off", d2), removeListener: r("removeListener", d2), removeAllListeners: r("removeAllListeners", d2), emit: e("emit"), eventNames: e("eventNames"), listeners: e("listeners"), listenerCount: e("listenerCount") }), l = c2(t.then((d2) => (l.emit("done", d2), l.emit("settled"), d2), (d2) => {
    throw l.emit("error", d2), l.emit("settled"), d2;
  }));
  return l.on(H.ClosedByUser, () => {
    l.emit(G.ClosedByUser);
  }), l;
}
function ke(n) {
  return new Promise((t, e) => {
    let r = n(t, e);
    Promise.resolve(r).catch(e);
  });
}
function Nt(n, t) {
  let [e] = n.split(".").map(Number);
  return e >= t;
}
function G2(n) {
  return (...t) => m2(this, null, function* () {
    return Ie || (Ie = yield h2.configureStorage()), yield Ie.ready(), Ie[n](...t);
  });
}
function St() {
  let n = window.crypto.getRandomValues(new Uint8Array(16));
  n[6] = n[6] & 15 | 64, n[8] = n[8] & 191 | 128;
  let t = "";
  return t += n[0].toString(16), t += n[1].toString(16), t += n[2].toString(16), t += n[3].toString(16), t += "-", t += n[4].toString(16), t += n[5].toString(16), t += "-", t += n[6].toString(16), t += n[7].toString(16), t += "-", t += n[8].toString(16), t += n[9].toString(16), t += "-", t += n[10].toString(16), t += n[11].toString(16), t += n[12].toString(16), t += n[13].toString(16), t += n[14].toString(16), t += n[15].toString(16), t;
}
function ce() {
  let n = typeof window != "undefined" && !!window.crypto, t = n && !!window.crypto.subtle;
  return n && t;
}
function Ot() {
  return m2(this, null, function* () {
    let n = yield lr();
    if (!n) {
      console.info("unable to create public key or webcrypto is unsupported");
      return;
    }
    let { subtle: t } = window.crypto, e = yield y2(De);
    if (!e || !t) {
      console.info("unable to find private key or webcrypto unsupported");
      return;
    }
    let r = { iat: Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3), jti: St() }, o = { typ: "dpop+jwt", alg: "ES256", jwk: n }, s = { protected: $t(JSON.stringify(o)), claims: $t(JSON.stringify(r)) }, i = ur(`${s.protected}.${s.claims}`), a2 = { name: Lt, hash: { name: "SHA-256" } }, c2 = hr(new Uint8Array(yield t.sign(a2, e, i)));
    return `${s.protected}.${s.claims}.${c2}`;
  });
}
function lr() {
  return m2(this, null, function* () {
    if (!ce()) {
      console.info("webcrypto is not supported");
      return;
    }
    return (yield y2(be)) || (yield dr()), y2(be);
  });
}
function dr() {
  return m2(this, null, function* () {
    let { subtle: n } = window.crypto, t = yield n.generateKey(cr, false, ["sign"]), e = yield n.exportKey("jwk", t.publicKey);
    yield M(De, t.privateKey), yield M(be, e);
  });
}
function $t(n) {
  return _t(pr(n));
}
function ur(n) {
  return new TextEncoder().encode(n);
}
function _t(n) {
  return btoa(n).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+/g, "");
}
function pr(n) {
  return encodeURIComponent(n).replace(/%([0-9A-F]{2})/g, (e, r) => String.fromCharCode(parseInt(r, 16)));
}
function hr(n) {
  let t = "";
  return n.forEach((e) => {
    t += String.fromCharCode(e);
  }), _t(t);
}
function Z() {
  return m2(this, null, function* () {
    let n = [];
    yield qe((t, e, r) => {
      e.startsWith(`${Ue}_`) && n.push(e);
    });
    for (let t of n) yield C2(t);
  });
}
function kt(n) {
  let t = "", e = new Uint8Array(n), r = e.byteLength;
  for (let o = 0; o < r; o++) t += String.fromCharCode(e[o]);
  return window.btoa(t);
}
function qt(n) {
  let t = window.atob(n), e = t.length, r = new Uint8Array(e);
  for (let o = 0; o < e; o++) r[o] = t.charCodeAt(o);
  return r.buffer;
}
function fr() {
  return m2(this, null, function* () {
    if (!ce()) {
      console.info("webcrypto is not supported");
      return;
    }
    let { crypto: n } = window, t = yield y2(Fe);
    return t || n.getRandomValues(new Uint8Array(12));
  });
}
function Er() {
  return m2(this, null, function* () {
    if (!ce()) {
      console.info("webcrypto is not supported");
      return;
    }
    let { subtle: n } = window.crypto, t = yield y2(We);
    return t || (yield n.generateKey({ name: Je, length: mr }, false, ["encrypt", "decrypt"]));
  });
}
function Dt(n, t) {
  return m2(this, null, function* () {
    let e = yield fr(), r = yield Er();
    if (!e || !r || !n) return;
    let o = qt(n), { subtle: s } = window.crypto, i = yield s.encrypt({ name: Je, iv: e }, r, o), a2 = kt(i);
    yield M(`${Ue}_${t}`, a2), yield M(We, r), yield M(Fe, e);
  });
}
function Ut(n) {
  return m2(this, null, function* () {
    let t = yield y2(`${Ue}_${n}`), e = yield y2(Fe), r = yield y2(We);
    if (!e || !t || !r || !ce()) return;
    let { subtle: o } = window.crypto, s = yield o.decrypt({ name: Je, iv: e }, r, qt(t));
    return kt(s);
  });
}
function Ge(n, t) {
  return t ? new URL(n, t) : new URL(n);
}
function gr(n) {
  let t = Object.getPrototypeOf(n), e = [t];
  for (; t !== P.prototype; ) t = Object.getPrototypeOf(t), e.push(t);
  return e;
}
function Jt(n) {
  return n.compat && n.compat[h2.sdkName] != null ? typeof n.compat[h2.sdkName] == "string" ? ct(lt(h2.version), n.compat[h2.sdkName]) : !!n.compat[h2.sdkName] : true;
}
function Rr(n, t, e) {
  return !t && !e ? `${n}_eth_mainnet` : e ? `${n}_${JSON.stringify(e)}` : t ? typeof t == "string" ? `${n}_eth_${t}` : `${n}_${t.rpcUrl}_${t.chainId}_${t.chainType}` : `${n}_unknown`;
}
function vr(n) {
  var o;
  let t = (o = n == null ? void 0 : n.extensions) != null ? o : [], e = {}, r = [];
  if (Array.isArray(t) ? t.forEach((s) => {
    Jt(s) ? (s.init(this), (s.name || s.name !== q2.Anonymous) && (this[s.name] = s), s instanceof q2.Internal && (se(s.config) || (e[s.name] = s.config))) : r.push(s);
  }) : Object.keys(t).forEach((s) => {
    if (Jt(t[s])) {
      t[s].init(this);
      let i = t[s];
      this[s] = i, i instanceof q2.Internal && (se(i.config) || (e[t[s].name] = i.config));
    } else r.push(t[s]);
  }), r.length) throw gt(r);
  return e;
}
function Ir(n, t) {
  return t && Array.isArray(n) ? n.find((e) => e.id === t) : n;
}
function br(n, t) {
  var o;
  let e = (o = t.data.response) == null ? void 0 : o.id, r = Ir(n, e);
  if (e && r) {
    let s = new F2(r).applyResult(t.data.response.result).applyError(t.data.response.error);
    return { id: e, response: s };
  }
  return {};
}
function wr(n, t, e) {
  return m2(this, null, function* () {
    var a2;
    let r = yield y2("rt"), o;
    if (h2.platform === "web") try {
      o = (a2 = yield y2("jwt")) != null ? a2 : yield Ot();
    } catch (c2) {
      console.error("webcrypto error", c2);
    }
    let s = { msgType: n, payload: t };
    o && (s.jwt = o), o && r && (s.rt = r);
    let i = yield Ut(e);
    return i && (s.deviceShare = i), s;
  });
}
function Pr(n) {
  return m2(this, null, function* () {
    !n.data.rt || (yield M("rt", n.data.rt));
  });
}
var Kt, ue, jt, Bt, Vt, Ht, Xe, Xt, Ye, zt, ze, B, V2, Yt, Qt, Zt, en, m2, Pt, nn, $e, rn, f2, re, Qe, at, sn, on, Ze, pe, et, tt, te, E2, an, H2, cn, ln, dn, un, pn, hn, mn, fn, En, yn, gn, Rn, vn, Se, ne, D2, nt, rt, L2, T2, R2, Tn, In, bn, st, wn, b2, Pn, Mn, xn, Cn, Nn, An, Sn, $n, Ln, On, ct, _n, ot, it, kn, qn, he, me, lt, h2, ht, S2, _2, U2, X, oe, Hn, It, F2, Mt, _e, xt, P, j, Te, ae, Ie, y2, M, C2, rr, sr, or, ir, qe, De, be, Lt, ar, cr, Ue, We, Fe, Je, mr, we, Pe, Me, ee, xe, Ft, Ce, je, q2, Ne, le, Ae, Ve;
var init_es2 = __esm({
  "../../node_modules/.pnpm/@magic-sdk+provider@28.6.0_localforage@1.10.0/node_modules/@magic-sdk/provider/dist/es/index.mjs"() {
    "use strict";
    init_es();
    init_es();
    init_es();
    init_es();
    init_es();
    init_es();
    init_es();
    init_es();
    init_es();
    init_es();
    Kt = Object.create;
    ue = Object.defineProperty;
    jt = Object.defineProperties;
    Bt = Object.getOwnPropertyDescriptor;
    Vt = Object.getOwnPropertyDescriptors;
    Ht = Object.getOwnPropertyNames;
    Xe = Object.getOwnPropertySymbols;
    Xt = Object.getPrototypeOf;
    Ye = Object.prototype.hasOwnProperty;
    zt = Object.prototype.propertyIsEnumerable;
    ze = (n, t, e) => t in n ? ue(n, t, { enumerable: true, configurable: true, writable: true, value: e }) : n[t] = e;
    B = (n, t) => {
      for (var e in t || (t = {})) Ye.call(t, e) && ze(n, e, t[e]);
      if (Xe) for (var e of Xe(t)) zt.call(t, e) && ze(n, e, t[e]);
      return n;
    };
    V2 = (n, t) => jt(n, Vt(t));
    Yt = (n, t) => () => (t || n((t = { exports: {} }).exports, t), t.exports);
    Qt = (n, t) => {
      for (var e in t) ue(n, e, { get: t[e], enumerable: true });
    };
    Zt = (n, t, e, r) => {
      if (t && typeof t == "object" || typeof t == "function") for (let o of Ht(t)) !Ye.call(n, o) && o !== e && ue(n, o, { get: () => t[o], enumerable: !(r = Bt(t, o)) || r.enumerable });
      return n;
    };
    en = (n, t, e) => (e = n != null ? Kt(Xt(n)) : {}, Zt(t || !n || !n.__esModule ? ue(e, "default", { value: n, enumerable: true }) : e, n));
    m2 = (n, t, e) => new Promise((r, o) => {
      var s = (c2) => {
        try {
          a2(e.next(c2));
        } catch (l) {
          o(l);
        }
      }, i = (c2) => {
        try {
          a2(e.throw(c2));
        } catch (l) {
          o(l);
        }
      }, a2 = (c2) => c2.done ? r(c2.value) : Promise.resolve(c2.value).then(s, i);
      a2((e = e.apply(n, t)).next());
    });
    Pt = Yt((Br, Oe) => {
      "use strict";
      var zn = Object.prototype.hasOwnProperty, w2 = "~";
      function ie() {
      }
      Object.create && (ie.prototype = /* @__PURE__ */ Object.create(null), new ie().__proto__ || (w2 = false));
      function Yn(n, t, e) {
        this.fn = n, this.context = t, this.once = e || false;
      }
      function wt(n, t, e, r, o) {
        if (typeof e != "function") throw new TypeError("The listener must be a function");
        var s = new Yn(e, r || n, o), i = w2 ? w2 + t : t;
        return n._events[i] ? n._events[i].fn ? n._events[i] = [n._events[i], s] : n._events[i].push(s) : (n._events[i] = s, n._eventsCount++), n;
      }
      function ge2(n, t) {
        --n._eventsCount === 0 ? n._events = new ie() : delete n._events[t];
      }
      function I2() {
        this._events = new ie(), this._eventsCount = 0;
      }
      I2.prototype.eventNames = function() {
        var t = [], e, r;
        if (this._eventsCount === 0) return t;
        for (r in e = this._events) zn.call(e, r) && t.push(w2 ? r.slice(1) : r);
        return Object.getOwnPropertySymbols ? t.concat(Object.getOwnPropertySymbols(e)) : t;
      };
      I2.prototype.listeners = function(t) {
        var e = w2 ? w2 + t : t, r = this._events[e];
        if (!r) return [];
        if (r.fn) return [r.fn];
        for (var o = 0, s = r.length, i = new Array(s); o < s; o++) i[o] = r[o].fn;
        return i;
      };
      I2.prototype.listenerCount = function(t) {
        var e = w2 ? w2 + t : t, r = this._events[e];
        return r ? r.fn ? 1 : r.length : 0;
      };
      I2.prototype.emit = function(t, e, r, o, s, i) {
        var a2 = w2 ? w2 + t : t;
        if (!this._events[a2]) return false;
        var c2 = this._events[a2], l = arguments.length, d2, p2;
        if (c2.fn) {
          switch (c2.once && this.removeListener(t, c2.fn, void 0, true), l) {
            case 1:
              return c2.fn.call(c2.context), true;
            case 2:
              return c2.fn.call(c2.context, e), true;
            case 3:
              return c2.fn.call(c2.context, e, r), true;
            case 4:
              return c2.fn.call(c2.context, e, r, o), true;
            case 5:
              return c2.fn.call(c2.context, e, r, o, s), true;
            case 6:
              return c2.fn.call(c2.context, e, r, o, s, i), true;
          }
          for (p2 = 1, d2 = new Array(l - 1); p2 < l; p2++) d2[p2 - 1] = arguments[p2];
          c2.fn.apply(c2.context, d2);
        } else {
          var x2 = c2.length, v2;
          for (p2 = 0; p2 < x2; p2++) switch (c2[p2].once && this.removeListener(t, c2[p2].fn, void 0, true), l) {
            case 1:
              c2[p2].fn.call(c2[p2].context);
              break;
            case 2:
              c2[p2].fn.call(c2[p2].context, e);
              break;
            case 3:
              c2[p2].fn.call(c2[p2].context, e, r);
              break;
            case 4:
              c2[p2].fn.call(c2[p2].context, e, r, o);
              break;
            default:
              if (!d2) for (v2 = 1, d2 = new Array(l - 1); v2 < l; v2++) d2[v2 - 1] = arguments[v2];
              c2[p2].fn.apply(c2[p2].context, d2);
          }
        }
        return true;
      };
      I2.prototype.on = function(t, e, r) {
        return wt(this, t, e, r, false);
      };
      I2.prototype.once = function(t, e, r) {
        return wt(this, t, e, r, true);
      };
      I2.prototype.removeListener = function(t, e, r, o) {
        var s = w2 ? w2 + t : t;
        if (!this._events[s]) return this;
        if (!e) return ge2(this, s), this;
        var i = this._events[s];
        if (i.fn) i.fn === e && (!o || i.once) && (!r || i.context === r) && ge2(this, s);
        else {
          for (var a2 = 0, c2 = [], l = i.length; a2 < l; a2++) (i[a2].fn !== e || o && !i[a2].once || r && i[a2].context !== r) && c2.push(i[a2]);
          c2.length ? this._events[s] = c2.length === 1 ? c2[0] : c2 : ge2(this, s);
        }
        return this;
      };
      I2.prototype.removeAllListeners = function(t) {
        var e;
        return t ? (e = w2 ? w2 + t : t, this._events[e] && ge2(this, e)) : (this._events = new ie(), this._eventsCount = 0), this;
      };
      I2.prototype.off = I2.prototype.removeListener;
      I2.prototype.addListener = I2.prototype.on;
      I2.prefixed = w2;
      I2.EventEmitter = I2;
      typeof Oe < "u" && (Oe.exports = I2);
    });
    nn = Number.MAX_SAFE_INTEGER || 9007199254740991;
    $e = { SEMVER_SPEC_VERSION: "2.0.0", MAX_LENGTH: 256, MAX_SAFE_INTEGER: nn, MAX_SAFE_COMPONENT_LENGTH: 16 };
    rn = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...n) => console.error("SEMVER", ...n) : () => {
    };
    f2 = rn;
    re = tn(function(n, t) {
      let { MAX_SAFE_COMPONENT_LENGTH: e } = $e, r = (t = n.exports = {}).re = [], o = t.src = [], s = t.t = {}, i = 0, a2 = (c2, l, d2) => {
        let p2 = i++;
        f2(p2, l), s[c2] = p2, o[p2] = l, r[p2] = new RegExp(l, d2 ? "g" : void 0);
      };
      a2("NUMERICIDENTIFIER", "0|[1-9]\\d*"), a2("NUMERICIDENTIFIERLOOSE", "[0-9]+"), a2("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), a2("MAINVERSION", `(${o[s.NUMERICIDENTIFIER]})\\.(${o[s.NUMERICIDENTIFIER]})\\.(${o[s.NUMERICIDENTIFIER]})`), a2("MAINVERSIONLOOSE", `(${o[s.NUMERICIDENTIFIERLOOSE]})\\.(${o[s.NUMERICIDENTIFIERLOOSE]})\\.(${o[s.NUMERICIDENTIFIERLOOSE]})`), a2("PRERELEASEIDENTIFIER", `(?:${o[s.NUMERICIDENTIFIER]}|${o[s.NONNUMERICIDENTIFIER]})`), a2("PRERELEASEIDENTIFIERLOOSE", `(?:${o[s.NUMERICIDENTIFIERLOOSE]}|${o[s.NONNUMERICIDENTIFIER]})`), a2("PRERELEASE", `(?:-(${o[s.PRERELEASEIDENTIFIER]}(?:\\.${o[s.PRERELEASEIDENTIFIER]})*))`), a2("PRERELEASELOOSE", `(?:-?(${o[s.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${o[s.PRERELEASEIDENTIFIERLOOSE]})*))`), a2("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), a2("BUILD", `(?:\\+(${o[s.BUILDIDENTIFIER]}(?:\\.${o[s.BUILDIDENTIFIER]})*))`), a2("FULLPLAIN", `v?${o[s.MAINVERSION]}${o[s.PRERELEASE]}?${o[s.BUILD]}?`), a2("FULL", `^${o[s.FULLPLAIN]}$`), a2("LOOSEPLAIN", `[v=\\s]*${o[s.MAINVERSIONLOOSE]}${o[s.PRERELEASELOOSE]}?${o[s.BUILD]}?`), a2("LOOSE", `^${o[s.LOOSEPLAIN]}$`), a2("GTLT", "((?:<|>)?=?)"), a2("XRANGEIDENTIFIERLOOSE", `${o[s.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), a2("XRANGEIDENTIFIER", `${o[s.NUMERICIDENTIFIER]}|x|X|\\*`), a2("XRANGEPLAIN", `[v=\\s]*(${o[s.XRANGEIDENTIFIER]})(?:\\.(${o[s.XRANGEIDENTIFIER]})(?:\\.(${o[s.XRANGEIDENTIFIER]})(?:${o[s.PRERELEASE]})?${o[s.BUILD]}?)?)?`), a2("XRANGEPLAINLOOSE", `[v=\\s]*(${o[s.XRANGEIDENTIFIERLOOSE]})(?:\\.(${o[s.XRANGEIDENTIFIERLOOSE]})(?:\\.(${o[s.XRANGEIDENTIFIERLOOSE]})(?:${o[s.PRERELEASELOOSE]})?${o[s.BUILD]}?)?)?`), a2("XRANGE", `^${o[s.GTLT]}\\s*${o[s.XRANGEPLAIN]}$`), a2("XRANGELOOSE", `^${o[s.GTLT]}\\s*${o[s.XRANGEPLAINLOOSE]}$`), a2("COERCE", `(^|[^\\d])(\\d{1,${e}})(?:\\.(\\d{1,${e}}))?(?:\\.(\\d{1,${e}}))?(?:$|[^\\d])`), a2("COERCERTL", o[s.COERCE], true), a2("LONETILDE", "(?:~>?)"), a2("TILDETRIM", `(\\s*)${o[s.LONETILDE]}\\s+`, true), t.tildeTrimReplace = "$1~", a2("TILDE", `^${o[s.LONETILDE]}${o[s.XRANGEPLAIN]}$`), a2("TILDELOOSE", `^${o[s.LONETILDE]}${o[s.XRANGEPLAINLOOSE]}$`), a2("LONECARET", "(?:\\^)"), a2("CARETTRIM", `(\\s*)${o[s.LONECARET]}\\s+`, true), t.caretTrimReplace = "$1^", a2("CARET", `^${o[s.LONECARET]}${o[s.XRANGEPLAIN]}$`), a2("CARETLOOSE", `^${o[s.LONECARET]}${o[s.XRANGEPLAINLOOSE]}$`), a2("COMPARATORLOOSE", `^${o[s.GTLT]}\\s*(${o[s.LOOSEPLAIN]})$|^$`), a2("COMPARATOR", `^${o[s.GTLT]}\\s*(${o[s.FULLPLAIN]})$|^$`), a2("COMPARATORTRIM", `(\\s*)${o[s.GTLT]}\\s*(${o[s.LOOSEPLAIN]}|${o[s.XRANGEPLAIN]})`, true), t.comparatorTrimReplace = "$1$2$3", a2("HYPHENRANGE", `^\\s*(${o[s.XRANGEPLAIN]})\\s+-\\s+(${o[s.XRANGEPLAIN]})\\s*$`), a2("HYPHENRANGELOOSE", `^\\s*(${o[s.XRANGEPLAINLOOSE]})\\s+-\\s+(${o[s.XRANGEPLAINLOOSE]})\\s*$`), a2("STAR", "(<|>)?=?\\s*\\*"), a2("GTE0", "^\\s*>=\\s*0.0.0\\s*$"), a2("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");
    });
    Qe = /^[0-9]+$/;
    at = (n, t) => {
      let e = Qe.test(n), r = Qe.test(t);
      return e && r && (n = +n, t = +t), n === t ? 0 : e && !r ? -1 : r && !e ? 1 : n < t ? -1 : 1;
    };
    sn = (n, t) => at(t, n);
    on = { compareIdentifiers: at, rcompareIdentifiers: sn };
    ({ MAX_LENGTH: Ze, MAX_SAFE_INTEGER: pe } = $e);
    ({ re: et, t: tt } = re);
    ({ compareIdentifiers: te } = on);
    E2 = class {
      constructor(t, e) {
        if (e && typeof e == "object" || (e = { loose: !!e, includePrerelease: false }), t instanceof E2) {
          if (t.loose === !!e.loose && t.includePrerelease === !!e.includePrerelease) return t;
          t = t.version;
        } else if (typeof t != "string") throw new TypeError(`Invalid Version: ${t}`);
        if (t.length > Ze) throw new TypeError(`version is longer than ${Ze} characters`);
        f2("SemVer", t, e), this.options = e, this.loose = !!e.loose, this.includePrerelease = !!e.includePrerelease;
        let r = t.trim().match(e.loose ? et[tt.LOOSE] : et[tt.FULL]);
        if (!r) throw new TypeError(`Invalid Version: ${t}`);
        if (this.raw = t, this.major = +r[1], this.minor = +r[2], this.patch = +r[3], this.major > pe || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > pe || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > pe || this.patch < 0) throw new TypeError("Invalid patch version");
        r[4] ? this.prerelease = r[4].split(".").map((o) => {
          if (/^[0-9]+$/.test(o)) {
            let s = +o;
            if (s >= 0 && s < pe) return s;
          }
          return o;
        }) : this.prerelease = [], this.build = r[5] ? r[5].split(".") : [], this.format();
      }
      format() {
        return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
      }
      toString() {
        return this.version;
      }
      compare(t) {
        if (f2("SemVer.compare", this.version, this.options, t), !(t instanceof E2)) {
          if (typeof t == "string" && t === this.version) return 0;
          t = new E2(t, this.options);
        }
        return t.version === this.version ? 0 : this.compareMain(t) || this.comparePre(t);
      }
      compareMain(t) {
        return t instanceof E2 || (t = new E2(t, this.options)), te(this.major, t.major) || te(this.minor, t.minor) || te(this.patch, t.patch);
      }
      comparePre(t) {
        if (t instanceof E2 || (t = new E2(t, this.options)), this.prerelease.length && !t.prerelease.length) return -1;
        if (!this.prerelease.length && t.prerelease.length) return 1;
        if (!this.prerelease.length && !t.prerelease.length) return 0;
        let e = 0;
        do {
          let r = this.prerelease[e], o = t.prerelease[e];
          if (f2("prerelease compare", e, r, o), r === void 0 && o === void 0) return 0;
          if (o === void 0) return 1;
          if (r === void 0) return -1;
          if (r !== o) return te(r, o);
        } while (++e);
      }
      compareBuild(t) {
        t instanceof E2 || (t = new E2(t, this.options));
        let e = 0;
        do {
          let r = this.build[e], o = t.build[e];
          if (f2("prerelease compare", e, r, o), r === void 0 && o === void 0) return 0;
          if (o === void 0) return 1;
          if (r === void 0) return -1;
          if (r !== o) return te(r, o);
        } while (++e);
      }
      inc(t, e) {
        switch (t) {
          case "premajor":
            this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", e);
            break;
          case "preminor":
            this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", e);
            break;
          case "prepatch":
            this.prerelease.length = 0, this.inc("patch", e), this.inc("pre", e);
            break;
          case "prerelease":
            this.prerelease.length === 0 && this.inc("patch", e), this.inc("pre", e);
            break;
          case "major":
            this.minor === 0 && this.patch === 0 && this.prerelease.length !== 0 || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
            break;
          case "minor":
            this.patch === 0 && this.prerelease.length !== 0 || this.minor++, this.patch = 0, this.prerelease = [];
            break;
          case "patch":
            this.prerelease.length === 0 && this.patch++, this.prerelease = [];
            break;
          case "pre":
            if (this.prerelease.length === 0) this.prerelease = [0];
            else {
              let r = this.prerelease.length;
              for (; --r >= 0; ) typeof this.prerelease[r] == "number" && (this.prerelease[r]++, r = -2);
              r === -1 && this.prerelease.push(0);
            }
            e && (this.prerelease[0] === e ? isNaN(this.prerelease[1]) && (this.prerelease = [e, 0]) : this.prerelease = [e, 0]);
            break;
          default:
            throw new Error(`invalid increment argument: ${t}`);
        }
        return this.format(), this.raw = this.version, this;
      }
    };
    an = (n, t, e) => new E2(n, e).compare(new E2(t, e));
    H2 = an;
    cn = (n, t, e) => H2(n, t, e) === 0;
    ln = cn;
    dn = (n, t, e) => H2(n, t, e) !== 0;
    un = dn;
    pn = (n, t, e) => H2(n, t, e) > 0;
    hn = pn;
    mn = (n, t, e) => H2(n, t, e) >= 0;
    fn = mn;
    En = (n, t, e) => H2(n, t, e) < 0;
    yn = En;
    gn = (n, t, e) => H2(n, t, e) <= 0;
    Rn = gn;
    vn = (n, t, e, r) => {
      switch (t) {
        case "===":
          return typeof n == "object" && (n = n.version), typeof e == "object" && (e = e.version), n === e;
        case "!==":
          return typeof n == "object" && (n = n.version), typeof e == "object" && (e = e.version), n !== e;
        case "":
        case "=":
        case "==":
          return ln(n, e, r);
        case "!=":
          return un(n, e, r);
        case ">":
          return hn(n, e, r);
        case ">=":
          return fn(n, e, r);
        case "<":
          return yn(n, e, r);
        case "<=":
          return Rn(n, e, r);
        default:
          throw new TypeError(`Invalid operator: ${t}`);
      }
    };
    Se = vn;
    ne = Symbol("SemVer ANY");
    D2 = class {
      static get ANY() {
        return ne;
      }
      constructor(t, e) {
        if (e && typeof e == "object" || (e = { loose: !!e, includePrerelease: false }), t instanceof D2) {
          if (t.loose === !!e.loose) return t;
          t = t.value;
        }
        f2("comparator", t, e), this.options = e, this.loose = !!e.loose, this.parse(t), this.semver === ne ? this.value = "" : this.value = this.operator + this.semver.version, f2("comp", this);
      }
      parse(t) {
        let e = this.options.loose ? nt[rt.COMPARATORLOOSE] : nt[rt.COMPARATOR], r = t.match(e);
        if (!r) throw new TypeError(`Invalid comparator: ${t}`);
        this.operator = r[1] !== void 0 ? r[1] : "", this.operator === "=" && (this.operator = ""), r[2] ? this.semver = new E2(r[2], this.options.loose) : this.semver = ne;
      }
      toString() {
        return this.value;
      }
      test(t) {
        if (f2("Comparator.test", t, this.options.loose), this.semver === ne || t === ne) return true;
        if (typeof t == "string") try {
          t = new E2(t, this.options);
        } catch (e) {
          return false;
        }
        return Se(t, this.operator, this.semver, this.options);
      }
      intersects(t, e) {
        if (!(t instanceof D2)) throw new TypeError("a Comparator is required");
        if (e && typeof e == "object" || (e = { loose: !!e, includePrerelease: false }), this.operator === "") return this.value === "" || new L2(t.value, e).test(this.value);
        if (t.operator === "") return t.value === "" || new L2(this.value, e).test(t.semver);
        let r = !(this.operator !== ">=" && this.operator !== ">" || t.operator !== ">=" && t.operator !== ">"), o = !(this.operator !== "<=" && this.operator !== "<" || t.operator !== "<=" && t.operator !== "<"), s = this.semver.version === t.semver.version, i = !(this.operator !== ">=" && this.operator !== "<=" || t.operator !== ">=" && t.operator !== "<="), a2 = Se(this.semver, "<", t.semver, e) && (this.operator === ">=" || this.operator === ">") && (t.operator === "<=" || t.operator === "<"), c2 = Se(this.semver, ">", t.semver, e) && (this.operator === "<=" || this.operator === "<") && (t.operator === ">=" || t.operator === ">");
        return r || o || s && i || a2 || c2;
      }
    };
    ({ re: nt, t: rt } = re);
    L2 = class {
      constructor(t, e) {
        if (e && typeof e == "object" || (e = { loose: !!e, includePrerelease: false }), t instanceof L2) return t.loose === !!e.loose && t.includePrerelease === !!e.includePrerelease ? t : new L2(t.raw, e);
        if (t instanceof D2) return this.raw = t.value, this.set = [[t]], this.format(), this;
        if (this.options = e, this.loose = !!e.loose, this.includePrerelease = !!e.includePrerelease, this.raw = t, this.set = t.split(/\s*\|\|\s*/).map((r) => this.parseRange(r.trim())).filter((r) => r.length), !this.set.length) throw new TypeError(`Invalid SemVer Range: ${t}`);
        this.format();
      }
      format() {
        return this.range = this.set.map((t) => t.join(" ").trim()).join("||").trim(), this.range;
      }
      toString() {
        return this.range;
      }
      parseRange(t) {
        let { loose: e } = this.options;
        t = t.trim();
        let r = e ? T2[R2.HYPHENRANGELOOSE] : T2[R2.HYPHENRANGE];
        t = t.replace(r, Ln(this.options.includePrerelease)), f2("hyphen replace", t), t = t.replace(T2[R2.COMPARATORTRIM], Tn), f2("comparator trim", t, T2[R2.COMPARATORTRIM]), t = (t = (t = t.replace(T2[R2.TILDETRIM], In)).replace(T2[R2.CARETTRIM], bn)).split(/\s+/).join(" ");
        let o = e ? T2[R2.COMPARATORLOOSE] : T2[R2.COMPARATOR];
        return t.split(" ").map((s) => wn(s, this.options)).join(" ").split(/\s+/).map((s) => $n(s, this.options)).filter(this.options.loose ? (s) => !!s.match(o) : () => true).map((s) => new D2(s, this.options));
      }
      intersects(t, e) {
        if (!(t instanceof L2)) throw new TypeError("a Range is required");
        return this.set.some((r) => st(r, e) && t.set.some((o) => st(o, e) && r.every((s) => o.every((i) => s.intersects(i, e)))));
      }
      test(t) {
        if (!t) return false;
        if (typeof t == "string") try {
          t = new E2(t, this.options);
        } catch (e) {
          return false;
        }
        for (let e = 0; e < this.set.length; e++) if (On(this.set[e], t, this.options)) return true;
        return false;
      }
    };
    ({ re: T2, t: R2, comparatorTrimReplace: Tn, tildeTrimReplace: In, caretTrimReplace: bn } = re);
    st = (n, t) => {
      let e = true, r = n.slice(), o = r.pop();
      for (; e && r.length; ) e = r.every((s) => o.intersects(s, t)), o = r.pop();
      return e;
    };
    wn = (n, t) => (f2("comp", n, t), n = xn(n, t), f2("caret", n), n = Pn(n, t), f2("tildes", n), n = Nn(n, t), f2("xrange", n), n = Sn(n, t), f2("stars", n), n);
    b2 = (n) => !n || n.toLowerCase() === "x" || n === "*";
    Pn = (n, t) => n.trim().split(/\s+/).map((e) => Mn(e, t)).join(" ");
    Mn = (n, t) => {
      let e = t.loose ? T2[R2.TILDELOOSE] : T2[R2.TILDE];
      return n.replace(e, (r, o, s, i, a2) => {
        let c2;
        return f2("tilde", n, r, o, s, i, a2), b2(o) ? c2 = "" : b2(s) ? c2 = `>=${o}.0.0 <${+o + 1}.0.0-0` : b2(i) ? c2 = `>=${o}.${s}.0 <${o}.${+s + 1}.0-0` : a2 ? (f2("replaceTilde pr", a2), c2 = `>=${o}.${s}.${i}-${a2} <${o}.${+s + 1}.0-0`) : c2 = `>=${o}.${s}.${i} <${o}.${+s + 1}.0-0`, f2("tilde return", c2), c2;
      });
    };
    xn = (n, t) => n.trim().split(/\s+/).map((e) => Cn(e, t)).join(" ");
    Cn = (n, t) => {
      f2("caret", n, t);
      let e = t.loose ? T2[R2.CARETLOOSE] : T2[R2.CARET], r = t.includePrerelease ? "-0" : "";
      return n.replace(e, (o, s, i, a2, c2) => {
        let l;
        return f2("caret", n, o, s, i, a2, c2), b2(s) ? l = "" : b2(i) ? l = `>=${s}.0.0${r} <${+s + 1}.0.0-0` : b2(a2) ? l = s === "0" ? `>=${s}.${i}.0${r} <${s}.${+i + 1}.0-0` : `>=${s}.${i}.0${r} <${+s + 1}.0.0-0` : c2 ? (f2("replaceCaret pr", c2), l = s === "0" ? i === "0" ? `>=${s}.${i}.${a2}-${c2} <${s}.${i}.${+a2 + 1}-0` : `>=${s}.${i}.${a2}-${c2} <${s}.${+i + 1}.0-0` : `>=${s}.${i}.${a2}-${c2} <${+s + 1}.0.0-0`) : (f2("no pr"), l = s === "0" ? i === "0" ? `>=${s}.${i}.${a2}${r} <${s}.${i}.${+a2 + 1}-0` : `>=${s}.${i}.${a2}${r} <${s}.${+i + 1}.0-0` : `>=${s}.${i}.${a2} <${+s + 1}.0.0-0`), f2("caret return", l), l;
      });
    };
    Nn = (n, t) => (f2("replaceXRanges", n, t), n.split(/\s+/).map((e) => An(e, t)).join(" "));
    An = (n, t) => {
      n = n.trim();
      let e = t.loose ? T2[R2.XRANGELOOSE] : T2[R2.XRANGE];
      return n.replace(e, (r, o, s, i, a2, c2) => {
        f2("xRange", n, r, o, s, i, a2, c2);
        let l = b2(s), d2 = l || b2(i), p2 = d2 || b2(a2), x2 = p2;
        return o === "=" && x2 && (o = ""), c2 = t.includePrerelease ? "-0" : "", l ? r = o === ">" || o === "<" ? "<0.0.0-0" : "*" : o && x2 ? (d2 && (i = 0), a2 = 0, o === ">" ? (o = ">=", d2 ? (s = +s + 1, i = 0, a2 = 0) : (i = +i + 1, a2 = 0)) : o === "<=" && (o = "<", d2 ? s = +s + 1 : i = +i + 1), o === "<" && (c2 = "-0"), r = `${o + s}.${i}.${a2}${c2}`) : d2 ? r = `>=${s}.0.0${c2} <${+s + 1}.0.0-0` : p2 && (r = `>=${s}.${i}.0${c2} <${s}.${+i + 1}.0-0`), f2("xRange return", r), r;
      });
    };
    Sn = (n, t) => (f2("replaceStars", n, t), n.trim().replace(T2[R2.STAR], ""));
    $n = (n, t) => (f2("replaceGTE0", n, t), n.trim().replace(T2[t.includePrerelease ? R2.GTE0PRE : R2.GTE0], ""));
    Ln = (n) => (t, e, r, o, s, i, a2, c2, l, d2, p2, x2, v2) => `${e = b2(r) ? "" : b2(o) ? `>=${r}.0.0${n ? "-0" : ""}` : b2(s) ? `>=${r}.${o}.0${n ? "-0" : ""}` : i ? `>=${e}` : `>=${e}${n ? "-0" : ""}`} ${c2 = b2(l) ? "" : b2(d2) ? `<${+l + 1}.0.0-0` : b2(p2) ? `<${l}.${+d2 + 1}.0-0` : x2 ? `<=${l}.${d2}.${p2}-${x2}` : n ? `<${l}.${d2}.${+p2 + 1}-0` : `<=${c2}`}`.trim();
    On = (n, t, e) => {
      for (let r = 0; r < n.length; r++) if (!n[r].test(t)) return false;
      if (t.prerelease.length && !e.includePrerelease) {
        for (let r = 0; r < n.length; r++) if (f2(n[r].semver), n[r].semver !== D2.ANY && n[r].semver.prerelease.length > 0) {
          let o = n[r].semver;
          if (o.major === t.major && o.minor === t.minor && o.patch === t.patch) return true;
        }
        return false;
      }
      return true;
    };
    ct = (n, t, e) => {
      try {
        t = new L2(t, e);
      } catch (r) {
        return false;
      }
      return t.test(n);
    };
    ({ MAX_LENGTH: _n } = $e);
    ({ re: ot, t: it } = re);
    kn = (n, t) => {
      if (t && typeof t == "object" || (t = { loose: !!t, includePrerelease: false }), n instanceof E2) return n;
      if (typeof n != "string" || n.length > _n || !(t.loose ? ot[it.LOOSE] : ot[it.FULL]).test(n)) return null;
      try {
        return new E2(n, t);
      } catch (e) {
        return null;
      }
    };
    qn = kn;
    ({ re: he, t: me } = re);
    lt = (n, t) => {
      if (n instanceof E2) return n;
      if (typeof n == "number" && (n = String(n)), typeof n != "string") return null;
      let e = null;
      if ((t = t || {}).rtl) {
        let r;
        for (; (r = he[me.COERCERTL].exec(n)) && (!e || e.index + e[0].length !== n.length); ) e && r.index + r[0].length === e.index + e[0].length || (e = r), he[me.COERCERTL].lastIndex = r.index + r[1].length + r[2].length;
        he[me.COERCERTL].lastIndex = -1;
      } else e = n.match(he[me.COERCE]);
      return e === null ? null : qn(`${e[2]}.${e[3] || "0"}.${e[4] || "0"}`, t);
    };
    h2 = {};
    ht = { "magic-sdk": "magic-sdk", "@magic-sdk/react-native": "magic-sdk-rn", "@magic-sdk/react-native-bare": "magic-sdk-rn-bare", "@magic-sdk/react-native-expo": "magic-sdk-rn-expo" };
    S2 = class extends Error {
      constructor(e, r) {
        super(`Magic SDK Error: [${e}] ${r}`);
        this.code = e;
        this.rawMessage = r;
        this.__proto__ = Error;
        Object.setPrototypeOf(this, S2.prototype);
      }
    };
    _2 = class extends Error {
      constructor(e) {
        super();
        this.__proto__ = Error;
        let r = Number(e == null ? void 0 : e.code);
        this.rawMessage = (e == null ? void 0 : e.message) || "Internal error", this.code = pt(r) ? r : d.InternalError, this.message = `Magic RPC Error: [${this.code}] ${this.rawMessage}`, this.data = (e == null ? void 0 : e.data) || void 0, Object.setPrototypeOf(this, _2.prototype);
      }
    };
    U2 = class {
      constructor(t, e) {
        this.code = t;
        this.rawMessage = e;
        this.message = `Magic SDK Warning: [${t}] ${e}`;
      }
      log() {
        console.warn(this.message);
      }
    };
    X = class extends Error {
      constructor(e, r, o, s) {
        super(`Magic Extension Error (${e.name}): [${r}] ${o}`);
        this.code = r;
        this.rawMessage = o;
        this.data = s;
        this.__proto__ = Error;
        Object.setPrototypeOf(this, X.prototype);
      }
    };
    oe = class {
      constructor(t, e, r) {
        this.code = e;
        this.rawMessage = r;
        this.message = `Magic Extension Warning (${t.name}): [${e}] ${r}`;
      }
      log() {
        console.warn(this.message);
      }
    };
    Hn = Vn();
    It = Symbol("Payload pre-processed by Magic SDK");
    F2 = class {
      constructor(t) {
        t instanceof F2 ? (this._jsonrpc = t.payload.jsonrpc, this._id = t.payload.id, this._result = t.payload.result, this._error = t.payload.error) : ut(t) ? (this._jsonrpc = t.jsonrpc, this._id = t.id, this._result = t.result, this._error = t.error) : (this._jsonrpc = t.jsonrpc, this._id = t.id, this._result = void 0, this._error = void 0);
      }
      applyError(t) {
        return this._error = t, this;
      }
      applyResult(t) {
        return this._result = t, this;
      }
      get hasError() {
        return typeof this._error != "undefined" && this._error !== null;
      }
      get hasResult() {
        return typeof this._result != "undefined";
      }
      get payload() {
        return { jsonrpc: this._jsonrpc, id: this._id, result: this._result, error: this._error };
      }
    };
    Mt = en(Pt());
    _e = class extends Mt.default {
    };
    xt = Symbol("isPromiEvent");
    P = class {
      constructor(t) {
        this.sdk = t;
      }
      get overlay() {
        return this.sdk.overlay;
      }
      request(t) {
        let e = this.overlay.post(g.MAGIC_HANDLE_REQUEST, K(t)), r = k2((s, i) => {
          e.then((a2) => {
            if (o(), a2.hasError) i(new _2(a2.payload.error));
            else if (a2.hasResult) s(a2.payload.result);
            else throw Et();
          }).catch((a2) => {
            o(), i(a2);
          });
        }), o = this.overlay.on(f.MAGIC_HANDLE_EVENT, (s) => {
          var a2;
          let { response: i } = s.data;
          if (i.id === t.id && ((a2 = i.result) == null ? void 0 : a2.event)) {
            let { event: c2, params: l = [] } = i.result;
            r.emit(c2, ...l);
          }
        });
        return r;
      }
      createIntermediaryEvent(t, e) {
        return (o) => {
          let s = u2(v.IntermediaryEvent, [{ payloadId: e, eventType: t, args: o }]);
          this.request(s);
        };
      }
    };
    j = { "magic-sdk": "v18.0.0", "@magic-sdk/react-native": "v14.0.0", "@magic-sdk/react-native-bare": "v19.0.0", "@magic-sdk/react-native-expo": "v19.0.0" };
    Te = class extends P {
      loginWithMagicLink(t) {
        let e = h2.sdkName === "@magic-sdk/react-native" || h2.sdkName === "@magic-sdk/react-native-bare" || h2.sdkName === "@magic-sdk/react-native-expo";
        if (e && Nt(h2.version, 19)) throw new Error("loginWithMagicLink() is deprecated for this package, please utlize a passcode method like loginWithSMS or loginWithEmailOTP instead.");
        e && W2({ method: "auth.loginWithMagicLink()", removalVersions: j, useInstead: "auth.loginWithEmailOTP()" }).log();
        let { email: r, showUI: o = true, redirectURI: s, overrides: i, lifespan: a2 } = t, c2 = u2(this.sdk.testMode ? v.LoginWithMagicLinkTestMode : v.LoginWithMagicLink, [{ email: r, showUI: o, redirectURI: s, overrides: i, lifespan: a2 }]);
        return this.request(c2);
      }
      loginWithSMS(t) {
        let { phoneNumber: e, showUI: r = true, lifespan: o } = t, s = u2(this.sdk.testMode ? v.LoginWithSmsTestMode : v.LoginWithSms, [{ phoneNumber: e, showUI: r, lifespan: o }]), i = this.request(s);
        return !r && i && (i.on(y.VerifySmsOtp, (a2) => {
          this.createIntermediaryEvent(y.VerifySmsOtp, s.id)(a2);
        }), i.on(y.Cancel, () => {
          this.createIntermediaryEvent(y.Cancel, s.id)();
        })), i;
      }
      loginWithEmailOTP(t) {
        let { email: e, showUI: r, deviceCheckUI: o, overrides: s, lifespan: i } = t, a2 = u2(this.sdk.testMode ? v.LoginWithEmailOTPTestMode : v.LoginWithEmailOTP, [{ email: e, showUI: r, deviceCheckUI: o, overrides: s, lifespan: i }]), c2 = this.request(a2);
        return !o && c2 && c2.on(T.Retry, () => {
          this.createIntermediaryEvent(T.Retry, a2.id)();
        }), !r && c2 && (c2.on(I.VerifyEmailOtp, (l) => {
          this.createIntermediaryEvent(I.VerifyEmailOtp, a2.id)(l);
        }), c2.on(I.VerifyMFACode, (l) => {
          this.createIntermediaryEvent(I.VerifyMFACode, a2.id)(l);
        }), c2.on(I.Cancel, () => {
          this.createIntermediaryEvent(I.Cancel, a2.id)();
        })), c2;
      }
      loginWithCredential(t) {
        let { credentialOrQueryString: e, lifespan: r } = t || {}, o = e != null ? e : "";
        if (!e && h2.platform === "web") {
          o = window.location.search;
          let i = window.location.origin + window.location.pathname;
          window.history.replaceState(null, "", i);
        }
        let s = u2(this.sdk.testMode ? v.LoginWithCredentialTestMode : v.LoginWithCredential, [o, r]);
        return this.request(s);
      }
      setAuthorizationToken(t) {
        let e = u2(v.SetAuthorizationToken, [{ jwt: t }]);
        return this.request(e);
      }
      updateEmailWithUI(t) {
        let { email: e, showUI: r = true } = t, o = u2(this.sdk.testMode ? v.UpdateEmailTestMode : v.UpdateEmail, [{ email: e, showUI: r }]), s = this.request(o);
        return r || (s.on(O.Retry, () => {
          this.createIntermediaryEvent(O.Retry, o.id)();
        }), s.on(O.Cancel, () => {
          this.createIntermediaryEvent(O.Cancel, o.id)();
        }), s.on(O.VerifyEmailOtp, (i) => {
          this.createIntermediaryEvent(O.VerifyEmailOtp, o.id)(i);
        }), s.on(O.VerifyMFACode, (i) => {
          this.createIntermediaryEvent(O.VerifyMFACode, o.id)(i);
        }), s.on(S.RetryWithNewEmail, (i) => {
          this.createIntermediaryEvent(S.RetryWithNewEmail, o.id)(i);
        }), s.on(S.Cancel, () => {
          this.createIntermediaryEvent(S.Cancel, o.id)();
        }), s.on(S.VerifyEmailOtp, (i) => {
          this.createIntermediaryEvent(S.VerifyEmailOtp, o.id)(i);
        })), s;
      }
    };
    ae = {};
    Qt(ae, { clear: () => rr, getItem: () => y2, iterate: () => qe, key: () => or, keys: () => ir, length: () => sr, removeItem: () => C2, setItem: () => M });
    y2 = G2("getItem");
    M = G2("setItem");
    C2 = G2("removeItem");
    rr = G2("clear");
    sr = G2("length");
    or = G2("key");
    ir = G2("keys");
    qe = G2("iterate");
    De = "STORE_KEY_PRIVATE_KEY";
    be = "STORE_KEY_PUBLIC_JWK";
    Lt = "ECDSA";
    ar = "P-256";
    cr = { name: Lt, namedCurve: ar };
    Ue = "ds";
    We = "ek";
    Fe = "iv";
    Je = "AES-GCM";
    mr = 256;
    we = class extends P {
      constructor() {
        super(...arguments);
        this.localForageKey = "mc_active_wallet";
        this.localForageIsLoggedInKey = "magic_auth_is_logged_in";
        this.userLoggedOutCallbacks = [];
      }
      getIdToken(e) {
        let r = u2(this.sdk.testMode ? v.GetIdTokenTestMode : v.GetIdToken, [e]);
        return this.request(r);
      }
      generateIdToken(e) {
        let r = u2(this.sdk.testMode ? v.GenerateIdTokenTestMode : v.GenerateIdToken, [e]);
        return this.request(r);
      }
      getInfo() {
        return m2(this, null, function* () {
          let e = yield y2(this.localForageKey), r = u2(v.GetInfo, [{ walletType: e }]);
          return this.request(r);
        });
      }
      isLoggedIn() {
        return k2((e, r) => m2(this, null, function* () {
          try {
            let o = false;
            this.sdk.useStorageCache && (o = (yield y2(this.localForageIsLoggedInKey)) === "true", o && e(true));
            let s = u2(this.sdk.testMode ? v.IsLoggedInTestMode : v.IsLoggedIn), i = yield this.request(s);
            this.sdk.useStorageCache && (i ? M(this.localForageIsLoggedInKey, true) : C2(this.localForageIsLoggedInKey), o && !i && this.emitUserLoggedOut(true)), e(i);
          } catch (o) {
            r(o);
          }
        }));
      }
      logout() {
        return C2(this.localForageKey), C2(this.localForageIsLoggedInKey), Z(), k2((e, r) => m2(this, null, function* () {
          try {
            let o = u2(this.sdk.testMode ? v.LogoutTestMode : v.Logout), s = yield this.request(o);
            this.sdk.useStorageCache && this.emitUserLoggedOut(s), e(s);
          } catch (o) {
            r(o);
          }
        }));
      }
      requestInfoWithUI(e) {
        let r = u2(v.RequestUserInfoWithUI, e ? [e] : []);
        return this.request(r);
      }
      showSettings(e) {
        let r = u2(this.sdk.testMode ? v.UserSettingsTestMode : v.UserSettings, [e]);
        return this.request(r);
      }
      recoverAccount(e) {
        let r = u2(this.sdk.testMode ? v.RecoverAccountTestMode : v.RecoverAccount, [e]);
        return this.request(r);
      }
      revealPrivateKey() {
        let e = u2(v.RevealPK);
        return this.request(e);
      }
      getMetadata() {
        W2({ method: "user.getMetadata()", removalVersions: j, useInstead: "user.getInfo()" }).log();
        let e = u2(this.sdk.testMode ? v.GetMetadataTestMode : v.GetMetadata);
        return this.request(e);
      }
      onUserLoggedOut(e) {
        this.userLoggedOutCallbacks.push(e);
      }
      enableMFA() {
        let e = u2(v.EnableMFA);
        return this.request(e);
      }
      disableMFA() {
        let e = u2(v.DisableMFA);
        return this.request(e);
      }
      emitUserLoggedOut(e) {
        this.userLoggedOutCallbacks.forEach((r) => {
          r(e);
        });
      }
    };
    Pe = class extends P {
      constructor() {
        super(...arguments);
        this.localForageKey = "mc_active_wallet";
      }
      connectWithUI() {
        let e = k2((r, o) => m2(this, null, function* () {
          try {
            if (this.isMetaMaskBrowser() && (yield this.isWalletEnabled(_.MetaMask))) {
              let l = yield this.autoConnectIfWalletBrowser(_.MetaMask);
              r(l);
              return;
            }
            if (this.isCoinbaseWalletBrowser() && (yield this.isWalletEnabled(_.CoinbaseWallet))) {
              let l = yield this.autoConnectIfWalletBrowser(_.CoinbaseWallet);
              r(l);
              return;
            }
            let s = this.getUserEnv(), i = u2(v.Login, [s]), a2 = this.request(i);
            a2.on(u.WalletSelected, (l) => this.handleWalletSelected(V2(B({}, l), { payloadId: i.id }))), a2.on("id-token-created", (l) => {
              e.emit("id-token-created", l);
            });
            let c2 = yield a2;
            c2.error && o(c2), r(c2);
          } catch (s) {
            o(s);
          }
        }));
        return e;
      }
      showUI(e) {
        return this.request(u2(v.ShowUI, [e]));
      }
      showAddress() {
        return this.request(u2(v.ShowAddress));
      }
      showSendTokensUI() {
        return this.request(u2(v.ShowSendTokensUI));
      }
      showOnRamp() {
        return this.request(u2(v.ShowOnRamp));
      }
      showNFTs() {
        return this.request(u2(v.ShowNFTs));
      }
      showBalances() {
        return this.request(u2(v.ShowBalances));
      }
      sendGaslessTransaction(e, r) {
        return this.request(u2(v.SendGaslessTransaction, [e, r]));
      }
      getInfo() {
        return m2(this, null, function* () {
          W2({ method: "wallet.getInfo()", removalVersions: j, useInstead: "user.getInfo()" }).log();
          let e = yield y2(this.localForageKey), r = u2(v.GetInfo, [{ walletType: e }]);
          return this.request(r);
        });
      }
      disconnect() {
        W2({ method: "wallet.disconnect()", removalVersions: j, useInstead: "user.logout()" }).log(), C2(this.localForageKey), Z();
        let e = u2(v.Disconnect);
        return this.request(e);
      }
      requestUserInfoWithUI(e) {
        W2({ method: "wallet.requestUserInfoWithUI()", removalVersions: j, useInstead: "user.requestUserInfoWithUI()" }).log();
        let r = u2(v.RequestUserInfoWithUI, e ? [e] : []);
        return this.request(r);
      }
      getProvider() {
        return m2(this, null, function* () {
          switch (yield y2(this.localForageKey)) {
            case _.MetaMask:
              return this.getMetaMaskProvider();
            case _.CoinbaseWallet:
              return this.getCoinbaseProvider();
            default:
              return this.sdk.rpcProvider;
          }
        });
      }
      isMetaMaskInstalled() {
        var e, r, o;
        return ((e = window.ethereum) == null ? void 0 : e.isMetaMask) || !!((o = (r = window.ethereum) == null ? void 0 : r.providers) != null && o.find((s) => s == null ? void 0 : s.isMetaMask));
      }
      isMetaMaskBrowser() {
        return this.isMobile() && this.isMetaMaskInstalled();
      }
      getMetaMaskProvider() {
        var e, r;
        return ((r = (e = window.ethereum) == null ? void 0 : e.providers) == null ? void 0 : r.find((o) => o == null ? void 0 : o.isMetaMask)) || window.ethereum;
      }
      connectToMetaMask() {
        if (this.isMobile() && !this.isMetaMaskInstalled()) {
          let e = `https://metamask.app.link/dapp/${window.location.href.replace(/(^\w+:|^)\/\//, "")}`;
          window.location.href = e;
        }
        return this.getMetaMaskProvider().request({ method: "eth_requestAccounts" });
      }
      isCoinbaseWalletInstalled() {
        var e, r, o;
        return ((e = window.ethereum) == null ? void 0 : e.isCoinbaseWallet) || !!((o = (r = window.ethereum) == null ? void 0 : r.providers) != null && o.find((s) => s == null ? void 0 : s.isCoinbaseWallet));
      }
      isCoinbaseWalletBrowser() {
        var e;
        return !!((e = window.ethereum) != null && e.isCoinbaseBrowser);
      }
      getCoinbaseProvider() {
        var e, r;
        return ((r = (e = window.ethereum) == null ? void 0 : e.providers) == null ? void 0 : r.find((o) => o == null ? void 0 : o.isCoinbaseWallet)) || window.ethereum;
      }
      connectToCoinbaseWallet() {
        if (this.isMobile() && !this.isCoinbaseWalletBrowser()) {
          let r = `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(window.location.href)}`;
          window.location.href = r;
        }
        return this.getCoinbaseProvider().request({ method: "eth_requestAccounts" });
      }
      isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Silk|Opera Mini/i.test(navigator.userAgent);
      }
      getUserEnv() {
        return { env: { isMetaMaskInstalled: this.isMetaMaskInstalled(), isCoinbaseWalletInstalled: this.isCoinbaseWalletInstalled() } };
      }
      connectToThirdPartyWallet(e) {
        switch (e) {
          case _.MetaMask:
            return this.connectToMetaMask();
          case _.CoinbaseWallet:
            return this.connectToCoinbaseWallet();
          default:
            throw new Error(`Invalid provider: ${e}. Must be one of "metamask" or "coinbase_wallet".`);
        }
      }
      isWalletEnabled(e) {
        let r = u2("mc_is_wallet_enabled", [{ wallet: e }]);
        return this.request(r);
      }
      handleWalletSelected(e) {
        return m2(this, null, function* () {
          try {
            let r = yield this.connectToThirdPartyWallet(e.wallet);
            yield M(this.localForageKey, e.wallet), this.createIntermediaryEvent(u.WalletConnected, e.payloadId)(r);
          } catch (r) {
            console.error(r), this.createIntermediaryEvent(u.WalletRejected, e.payloadId)();
          }
        });
      }
      autoConnectIfWalletBrowser(e) {
        return m2(this, null, function* () {
          let r;
          e === _.MetaMask && (r = yield this.getMetaMaskProvider().request({ method: "eth_requestAccounts" })), e === _.CoinbaseWallet && (r = yield this.getCoinbaseProvider().request({ method: "eth_requestAccounts" })), yield M(this.localForageKey, e);
          let o = u2(v.AutoConnect, [{ wallet: e, address: r }]);
          return this.request(o);
        });
      }
    };
    ({ createBoundEmitterMethod: Me, createChainingEmitterMethod: ee } = Re());
    xe = class extends P {
      constructor() {
        super(...arguments);
        this.isMagic = true;
        this.on = ee("on", this);
        this.once = ee("once", this);
        this.addListener = ee("addListener", this);
        this.off = ee("off", this);
        this.removeListener = ee("removeListener", this);
        this.removeAllListeners = ee("removeAllListeners", this);
        this.emit = Me("emit");
        this.eventNames = Me("eventNames");
        this.listeners = Me("listeners");
        this.listenerCount = Me("listenerCount");
      }
      sendAsync(e, r) {
        if (!r) throw Rt({ procedure: "Magic.rpcProvider.sendAsync", argument: 1, expected: "function", received: r === null ? "null" : typeof r });
        if (Array.isArray(e)) this.overlay.post(g.MAGIC_HANDLE_REQUEST, e.map((o) => {
          let s = K(o);
          return this.prefixPayloadMethodForTestMode(s), s;
        })).then((o) => {
          r(null, o.map((s) => V2(B({}, s.payload), { error: s.hasError ? new _2(s.payload.error) : null })));
        });
        else {
          let o = K(e);
          this.prefixPayloadMethodForTestMode(o), this.overlay.post(g.MAGIC_HANDLE_REQUEST, o).then((s) => {
            r(s.hasError ? new _2(s.payload.error) : null, s.payload);
          });
        }
      }
      send(e, r) {
        if (typeof e == "string") {
          let s = u2(e, Array.isArray(r) ? r : []);
          return this.request(s);
        }
        if (Array.isArray(e) || !!r) {
          this.sendAsync(e, r);
          return;
        }
        let o = vt();
        return o.log(), new F2(e).applyError({ code: -32603, message: o.rawMessage }).payload;
      }
      enable() {
        let e = u2(v.Login);
        return this.request(e);
      }
      request(e) {
        return this.prefixPayloadMethodForTestMode(e), super.request(e);
      }
      prefixPayloadMethodForTestMode(e) {
        let r = "testMode/eth/";
        this.sdk.testMode && (e.method = `${r}${e.method}`);
      }
    };
    Ft = ["request", "overlay", "sdk"];
    Ce = class extends P {
      constructor() {
        super(void 0);
        this.__sdk_access_field_descriptors__ = /* @__PURE__ */ new Map();
        this.__is_initialized__ = false;
        this.utils = { createPromiEvent: k2, isPromiEvent: Ct, encodeJSON: fe, decodeJSON: dt, createJsonRpcRequestPayload: u2, standardizeJsonRpcRequestPayload: K, storage: ae };
        let e = [this, ...gr(this)];
        Ft.forEach((r) => {
          let o = e.map((c2) => Object.getOwnPropertyDescriptor(c2, r)), s = o.findIndex((c2) => !!c2), i = s > 0, a2 = o[s];
          a2 && (this.__sdk_access_field_descriptors__.set(r, { descriptor: a2, isPrototypeField: i }), Object.defineProperty(this, r, { configurable: true, get: () => {
            throw yt(r);
          } }));
        });
      }
      init(e) {
        this.__is_initialized__ || (Ft.forEach((r) => {
          if (this.__sdk_access_field_descriptors__.has(r)) {
            let { descriptor: o, isPrototypeField: s } = this.__sdk_access_field_descriptors__.get(r);
            s ? delete this[r] : Object.defineProperty(this, r, o);
          }
        }), this.sdk = e, this.__is_initialized__ = true);
      }
      createDeprecationWarning(e) {
        let { method: r, removalVersion: o, useInstead: s } = e, i = s ? ` Use \`${s}\` instead.` : "", a2 = `\`${r}\` will be removed from this Extension in version \`${o}\`.${i}`;
        return new oe(this, "DEPRECATION_NOTICE", a2);
      }
      createWarning(e, r) {
        return new oe(this, e, r);
      }
      createError(e, r, o) {
        return new X(this, e, r, o);
      }
    };
    je = class extends Ce {
    };
    q2 = class extends Ce {
    };
    q2.Internal = je, q2.Anonymous = "anonymous extension";
    Ne = class extends P {
      purchase(t) {
        let e = u2(v.NFTPurchase, [t]);
        return this.request(e);
      }
      checkout(t) {
        let e = u2(v.NFTCheckout, [t]);
        return this.request(e);
      }
      transfer(t) {
        let e = u2(v.NFTTransfer, [t]);
        return this.request(e);
      }
    };
    le = class {
      constructor(t, e) {
        this.apiKey = t;
        var i;
        if (!t) throw mt();
        h2.platform === "react-native" && (e == null ? void 0 : e.endpoint) && Tt().log();
        let { defaultEndpoint: r, version: o } = h2;
        this.testMode = !!(e != null && e.testMode), this.useStorageCache = !!(e != null && e.useStorageCache), this.endpoint = Ge((i = e == null ? void 0 : e.endpoint) != null ? i : r).origin, this.auth = new Te(this), this.user = new we(this), this.wallet = new Pe(this), this.nft = new Ne(this), this.rpcProvider = new xe(this);
        let s = vr.call(this, e);
        this.parameters = fe(V2(B({ API_KEY: this.apiKey, DOMAIN_ORIGIN: window.location ? window.location.origin : "", ETH_NETWORK: e == null ? void 0 : e.network, host: Ge(this.endpoint).host, sdk: ht[h2.sdkName], version: o, ext: se(s) ? void 0 : s, locale: (e == null ? void 0 : e.locale) || "en_US" }, h2.bundleId ? { bundleId: h2.bundleId } : {}), { meta: e == null ? void 0 : e.meta })), this.networkHash = Rr(this.apiKey, e == null ? void 0 : e.network, se(s) ? void 0 : s), e != null && e.deferPreload || this.preload();
      }
      get overlay() {
        if (!le.__overlays__.has(this.parameters)) {
          let t = new h2.ViewController(this.endpoint, this.parameters, this.networkHash);
          t.init(), le.__overlays__.set(this.parameters, t);
        }
        return le.__overlays__.get(this.parameters);
      }
      preload() {
        return m2(this, null, function* () {
          yield this.overlay.checkIsReadyForRequest;
        });
      }
    };
    Ae = le;
    Ae.__overlays__ = /* @__PURE__ */ new Map();
    Ve = class {
      constructor(t, e, r) {
        this.endpoint = t;
        this.parameters = e;
        this.networkHash = r;
        this.messageHandlers = /* @__PURE__ */ new Set();
        this.isConnectedToInternet = true;
        this.checkIsReadyForRequest = this.waitForReady(), this.isReadyForRequest = false, this.listen();
      }
      post(t, e) {
        return m2(this, null, function* () {
          return ke((r, o) => m2(this, null, function* () {
            if (!this.isConnectedToInternet) {
              let d2 = ft();
              o(d2);
            }
            this.isReadyForRequest || (yield this.waitForReady());
            let s = [], i = Array.isArray(e) ? e.map((d2) => d2.id) : [], a2 = yield wr(`${t}-${this.parameters}`, e, this.networkHash);
            yield this._post(a2);
            let c2 = (d2) => (p2) => {
              var He;
              let { id: x2, response: v2 } = br(e, p2);
              if (Pr(p2), ((He = v2 == null ? void 0 : v2.payload.error) == null ? void 0 : He.message) === "User denied account access.") Z();
              else if (p2.data.deviceShare) {
                let { deviceShare: Gt } = p2.data;
                Dt(Gt, this.networkHash);
              }
              x2 && v2 && Array.isArray(e) && i.includes(x2) ? (s.push(v2), s.length === e.length && (d2(), r(s))) : x2 && v2 && !Array.isArray(e) && x2 === e.id && (d2(), r(v2));
            }, l = this.on(f.MAGIC_HANDLE_RESPONSE, c2(() => l()));
          }));
        });
      }
      on(t, e) {
        let r = e.bind(window), o = (s) => {
          s.data.msgType === `${t}-${this.parameters}` && r(s);
        };
        return this.messageHandlers.add(o), () => this.messageHandlers.delete(o);
      }
      waitForReady() {
        return new Promise((t) => {
          let e = this.on(f.MAGIC_OVERLAY_READY, () => {
            this.isReadyForRequest = true, t(), e();
          });
          setTimeout(() => {
            this.isReadyForRequest = true, t(), e();
          }, 15e3);
        });
      }
      listen() {
        this.on(f.MAGIC_HIDE_OVERLAY, () => {
          this.hideOverlay();
        }), this.on(f.MAGIC_SHOW_OVERLAY, () => {
          this.showOverlay();
        }), this.on(f.MAGIC_SEND_PRODUCT_ANNOUNCEMENT, (t) => {
          t.data.response.result.product_announcement && new U2(m.ProductAnnouncement, t.data.response.result.product_announcement).log();
        });
      }
    };
  }
});

// ../../node_modules/.pnpm/@magic-sdk+commons@24.10.0_@magic-sdk+provider@28.6.0_localforage@1.10.0__@magic-sdk+types@24.8.0/node_modules/@magic-sdk/commons/dist/es/index.mjs
var init_es3 = __esm({
  "../../node_modules/.pnpm/@magic-sdk+commons@24.10.0_@magic-sdk+provider@28.6.0_localforage@1.10.0__@magic-sdk+types@24.8.0/node_modules/@magic-sdk/commons/dist/es/index.mjs"() {
    "use strict";
    init_es2();
    init_es();
  }
});

// ../../node_modules/.pnpm/magic-sdk@28.6.0/node_modules/magic-sdk/dist/es/index.mjs
var es_exports = {};
__export(es_exports, {
  AuthEventOnReceived: () => F,
  DeepLinkPage: () => E,
  DeviceVerificationEventEmit: () => T,
  DeviceVerificationEventOnReceived: () => h,
  DisableMFAEventEmit: () => V,
  DisableMFAEventOnReceived: () => D,
  EnableMFAEventEmit: () => U,
  EnableMFAEventOnReceived: () => w,
  EthChainType: () => C,
  Events: () => u,
  Extension: () => q2,
  ExtensionError: () => X,
  ExtensionWarning: () => oe,
  FarcasterLoginEventEmit: () => L,
  LoginWithEmailOTPEventEmit: () => I,
  LoginWithEmailOTPEventOnReceived: () => N,
  LoginWithMagicLinkEventEmit: () => x,
  LoginWithMagicLinkEventOnReceived: () => A,
  LoginWithSmsOTPEventEmit: () => y,
  LoginWithSmsOTPEventOnReceived: () => R,
  Magic: () => bt2,
  MagicIncomingWindowMessage: () => f,
  MagicOutgoingWindowMessage: () => g,
  MagicPayloadMethod: () => v,
  NftCheckoutIntermediaryEvents: () => W,
  RPCError: () => _2,
  RPCErrorCode: () => d,
  RecencyCheckEventEmit: () => O,
  RecencyCheckEventOnReceived: () => b,
  RecoveryMethodType: () => q,
  SDKError: () => S2,
  SDKErrorCode: () => p,
  SDKWarning: () => U2,
  SDKWarningCode: () => m,
  UiEventsEmit: () => Y,
  UpdateEmailEventEmit: () => S,
  UpdateEmailEventOnReceived: () => k,
  UserEventsEmit: () => G,
  UserEventsOnReceived: () => H,
  WalletEventOnReceived: () => J,
  Wallets: () => _,
  isPromiEvent: () => Ct
});
function ft2(b3) {
  for (let [R3, A2] of Object.entries(at2)) b3.style[R3] = A2;
}
function ut2(b3) {
  let R3 = [].slice.call(document.querySelectorAll(".magic-iframe"));
  return Boolean(R3.find((A2) => A2.src.includes(b3)));
}
var Zr, Je2, qr, kr, et2, rt2, ve, $e2, tt2, Ze2, se2, ke2, rr2, ge, Te2, at2, pe2, bt2;
var init_es4 = __esm({
  "../../node_modules/.pnpm/magic-sdk@28.6.0/node_modules/magic-sdk/dist/es/index.mjs"() {
    "use strict";
    init_es2();
    init_es2();
    init_es3();
    Zr = Object.create;
    Je2 = Object.defineProperty;
    qr = Object.getOwnPropertyDescriptor;
    kr = Object.getOwnPropertyNames;
    et2 = Object.getPrototypeOf;
    rt2 = Object.prototype.hasOwnProperty;
    ve = ((b3) => typeof __require != "undefined" ? __require : typeof Proxy != "undefined" ? new Proxy(b3, { get: (R3, A2) => (typeof __require != "undefined" ? __require : R3)[A2] }) : b3)(function(b3) {
      if (typeof __require != "undefined") return __require.apply(this, arguments);
      throw new Error('Dynamic require of "' + b3 + '" is not supported');
    });
    $e2 = (b3, R3) => () => (R3 || b3((R3 = { exports: {} }).exports, R3), R3.exports);
    tt2 = (b3, R3, A2, L3) => {
      if (R3 && typeof R3 == "object" || typeof R3 == "function") for (let D3 of kr(R3)) !rt2.call(b3, D3) && D3 !== A2 && Je2(b3, D3, { get: () => R3[D3], enumerable: !(L3 = qr(R3, D3)) || L3.enumerable });
      return b3;
    };
    Ze2 = (b3, R3, A2) => (A2 = b3 != null ? Zr(et2(b3)) : {}, tt2(R3 || !b3 || !b3.__esModule ? Je2(A2, "default", { value: b3, enumerable: true }) : A2, b3));
    se2 = (b3, R3, A2) => new Promise((L3, D3) => {
      var X2 = (I2) => {
        try {
          Y2(A2.next(I2));
        } catch (M2) {
          D3(M2);
        }
      }, P2 = (I2) => {
        try {
          Y2(A2.throw(I2));
        } catch (M2) {
          D3(M2);
        }
      }, Y2 = (I2) => I2.done ? L3(I2.value) : Promise.resolve(I2.value).then(X2, P2);
      Y2((A2 = A2.apply(b3, R3)).next());
    });
    ke2 = $e2((qe2, Ne2) => {
      (function(b3) {
        if (typeof qe2 == "object" && typeof Ne2 < "u") Ne2.exports = b3();
        else if (typeof define == "function" && define.amd) define([], b3);
        else {
          var R3;
          typeof window < "u" ? R3 = window : typeof global < "u" ? R3 = global : typeof self < "u" ? R3 = self : R3 = this, R3.localforage = b3();
        }
      })(function() {
        var b3, R3, A2;
        return function L3(D3, X2, P2) {
          function Y2(H3, $) {
            if (!X2[H3]) {
              if (!D3[H3]) {
                var m3 = typeof ve == "function" && ve;
                if (!$ && m3) return m3(H3, true);
                if (I2) return I2(H3, true);
                var _3 = new Error("Cannot find module '" + H3 + "'");
                throw _3.code = "MODULE_NOT_FOUND", _3;
              }
              var B2 = X2[H3] = { exports: {} };
              D3[H3][0].call(B2.exports, function(z) {
                var Z2 = D3[H3][1][z];
                return Y2(Z2 || z);
              }, B2, B2.exports, L3, D3, X2, P2);
            }
            return X2[H3].exports;
          }
          for (var I2 = typeof ve == "function" && ve, M2 = 0; M2 < P2.length; M2++) Y2(P2[M2]);
          return Y2;
        }({ 1: [function(L3, D3, X2) {
          (function(P2) {
            "use strict";
            var Y2 = P2.MutationObserver || P2.WebKitMutationObserver, I2;
            if (Y2) {
              var M2 = 0, H3 = new Y2(z), $ = P2.document.createTextNode("");
              H3.observe($, { characterData: true }), I2 = function() {
                $.data = M2 = ++M2 % 2;
              };
            } else if (!P2.setImmediate && typeof P2.MessageChannel < "u") {
              var m3 = new P2.MessageChannel();
              m3.port1.onmessage = z, I2 = function() {
                m3.port2.postMessage(0);
              };
            } else "document" in P2 && "onreadystatechange" in P2.document.createElement("script") ? I2 = function() {
              var F3 = P2.document.createElement("script");
              F3.onreadystatechange = function() {
                z(), F3.onreadystatechange = null, F3.parentNode.removeChild(F3), F3 = null;
              }, P2.document.documentElement.appendChild(F3);
            } : I2 = function() {
              setTimeout(z, 0);
            };
            var _3, B2 = [];
            function z() {
              _3 = true;
              for (var F3, k3, U3 = B2.length; U3; ) {
                for (k3 = B2, B2 = [], F3 = -1; ++F3 < U3; ) k3[F3]();
                U3 = B2.length;
              }
              _3 = false;
            }
            D3.exports = Z2;
            function Z2(F3) {
              B2.push(F3) === 1 && !_3 && I2();
            }
          }).call(this, typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {});
        }, {}], 2: [function(L3, D3, X2) {
          "use strict";
          var P2 = L3(1);
          function Y2() {
          }
          var I2 = {}, M2 = ["REJECTED"], H3 = ["FULFILLED"], $ = ["PENDING"];
          D3.exports = m3;
          function m3(h3) {
            if (typeof h3 != "function") throw new TypeError("resolver must be a function");
            this.state = $, this.queue = [], this.outcome = void 0, h3 !== Y2 && Z2(this, h3);
          }
          m3.prototype.catch = function(h3) {
            return this.then(null, h3);
          }, m3.prototype.then = function(h3, N2) {
            if (typeof h3 != "function" && this.state === H3 || typeof N2 != "function" && this.state === M2) return this;
            var E3 = new this.constructor(Y2);
            if (this.state !== $) {
              var O3 = this.state === H3 ? h3 : N2;
              B2(E3, O3, this.outcome);
            } else this.queue.push(new _3(E3, h3, N2));
            return E3;
          };
          function _3(h3, N2, E3) {
            this.promise = h3, typeof N2 == "function" && (this.onFulfilled = N2, this.callFulfilled = this.otherCallFulfilled), typeof E3 == "function" && (this.onRejected = E3, this.callRejected = this.otherCallRejected);
          }
          _3.prototype.callFulfilled = function(h3) {
            I2.resolve(this.promise, h3);
          }, _3.prototype.otherCallFulfilled = function(h3) {
            B2(this.promise, this.onFulfilled, h3);
          }, _3.prototype.callRejected = function(h3) {
            I2.reject(this.promise, h3);
          }, _3.prototype.otherCallRejected = function(h3) {
            B2(this.promise, this.onRejected, h3);
          };
          function B2(h3, N2, E3) {
            P2(function() {
              var O3;
              try {
                O3 = N2(E3);
              } catch (V3) {
                return I2.reject(h3, V3);
              }
              O3 === h3 ? I2.reject(h3, new TypeError("Cannot resolve promise with itself")) : I2.resolve(h3, O3);
            });
          }
          I2.resolve = function(h3, N2) {
            var E3 = F3(z, N2);
            if (E3.status === "error") return I2.reject(h3, E3.value);
            var O3 = E3.value;
            if (O3) Z2(h3, O3);
            else {
              h3.state = H3, h3.outcome = N2;
              for (var V3 = -1, j2 = h3.queue.length; ++V3 < j2; ) h3.queue[V3].callFulfilled(N2);
            }
            return h3;
          }, I2.reject = function(h3, N2) {
            h3.state = M2, h3.outcome = N2;
            for (var E3 = -1, O3 = h3.queue.length; ++E3 < O3; ) h3.queue[E3].callRejected(N2);
            return h3;
          };
          function z(h3) {
            var N2 = h3 && h3.then;
            if (h3 && (typeof h3 == "object" || typeof h3 == "function") && typeof N2 == "function") return function() {
              N2.apply(h3, arguments);
            };
          }
          function Z2(h3, N2) {
            var E3 = false;
            function O3(J2) {
              E3 || (E3 = true, I2.reject(h3, J2));
            }
            function V3(J2) {
              E3 || (E3 = true, I2.resolve(h3, J2));
            }
            function j2() {
              N2(V3, O3);
            }
            var Q = F3(j2);
            Q.status === "error" && O3(Q.value);
          }
          function F3(h3, N2) {
            var E3 = {};
            try {
              E3.value = h3(N2), E3.status = "success";
            } catch (O3) {
              E3.status = "error", E3.value = O3;
            }
            return E3;
          }
          m3.resolve = k3;
          function k3(h3) {
            return h3 instanceof this ? h3 : I2.resolve(new this(Y2), h3);
          }
          m3.reject = U3;
          function U3(h3) {
            var N2 = new this(Y2);
            return I2.reject(N2, h3);
          }
          m3.all = ae2;
          function ae2(h3) {
            var N2 = this;
            if (Object.prototype.toString.call(h3) !== "[object Array]") return this.reject(new TypeError("must be an array"));
            var E3 = h3.length, O3 = false;
            if (!E3) return this.resolve([]);
            for (var V3 = new Array(E3), j2 = 0, Q = -1, J2 = new this(Y2); ++Q < E3; ) ee2(h3[Q], Q);
            return J2;
            function ee2(oe2, a2) {
              N2.resolve(oe2).then(s, function(v2) {
                O3 || (O3 = true, I2.reject(J2, v2));
              });
              function s(v2) {
                V3[a2] = v2, ++j2 === E3 && !O3 && (O3 = true, I2.resolve(J2, V3));
              }
            }
          }
          m3.race = re2;
          function re2(h3) {
            var N2 = this;
            if (Object.prototype.toString.call(h3) !== "[object Array]") return this.reject(new TypeError("must be an array"));
            var E3 = h3.length, O3 = false;
            if (!E3) return this.resolve([]);
            for (var V3 = -1, j2 = new this(Y2); ++V3 < E3; ) Q(h3[V3]);
            return j2;
            function Q(J2) {
              N2.resolve(J2).then(function(ee2) {
                O3 || (O3 = true, I2.resolve(j2, ee2));
              }, function(ee2) {
                O3 || (O3 = true, I2.reject(j2, ee2));
              });
            }
          }
        }, { 1: 1 }], 3: [function(L3, D3, X2) {
          (function(P2) {
            "use strict";
            typeof P2.Promise != "function" && (P2.Promise = L3(2));
          }).call(this, typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {});
        }, { 2: 2 }], 4: [function(L3, D3, X2) {
          "use strict";
          var P2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
            return typeof e;
          } : function(e) {
            return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          };
          function Y2(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }
          function I2() {
            try {
              if (typeof indexedDB < "u") return indexedDB;
              if (typeof webkitIndexedDB < "u") return webkitIndexedDB;
              if (typeof mozIndexedDB < "u") return mozIndexedDB;
              if (typeof OIndexedDB < "u") return OIndexedDB;
              if (typeof msIndexedDB < "u") return msIndexedDB;
            } catch {
              return;
            }
          }
          var M2 = I2();
          function H3() {
            try {
              if (!M2 || !M2.open) return false;
              var e = typeof openDatabase < "u" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform), t = typeof fetch == "function" && fetch.toString().indexOf("[native code") !== -1;
              return (!e || t) && typeof indexedDB < "u" && typeof IDBKeyRange < "u";
            } catch {
              return false;
            }
          }
          function $(e, t) {
            e = e || [], t = t || {};
            try {
              return new Blob(e, t);
            } catch (n) {
              if (n.name !== "TypeError") throw n;
              for (var r = typeof BlobBuilder < "u" ? BlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" ? MozBlobBuilder : WebKitBlobBuilder, o = new r(), i = 0; i < e.length; i += 1) o.append(e[i]);
              return o.getBlob(t.type);
            }
          }
          typeof Promise > "u" && L3(3);
          var m3 = Promise;
          function _3(e, t) {
            t && e.then(function(r) {
              t(null, r);
            }, function(r) {
              t(r);
            });
          }
          function B2(e, t, r) {
            typeof t == "function" && e.then(t), typeof r == "function" && e.catch(r);
          }
          function z(e) {
            return typeof e != "string" && (console.warn(e + " used as a key, but it is not a string."), e = String(e)), e;
          }
          function Z2() {
            if (arguments.length && typeof arguments[arguments.length - 1] == "function") return arguments[arguments.length - 1];
          }
          var F3 = "local-forage-detect-blob-support", k3 = void 0, U3 = {}, ae2 = Object.prototype.toString, re2 = "readonly", h3 = "readwrite";
          function N2(e) {
            for (var t = e.length, r = new ArrayBuffer(t), o = new Uint8Array(r), i = 0; i < t; i++) o[i] = e.charCodeAt(i);
            return r;
          }
          function E3(e) {
            return new m3(function(t) {
              var r = e.transaction(F3, h3), o = $([""]);
              r.objectStore(F3).put(o, "key"), r.onabort = function(i) {
                i.preventDefault(), i.stopPropagation(), t(false);
              }, r.oncomplete = function() {
                var i = navigator.userAgent.match(/Chrome\/(\d+)/), n = navigator.userAgent.match(/Edge\//);
                t(n || !i || parseInt(i[1], 10) >= 43);
              };
            }).catch(function() {
              return false;
            });
          }
          function O3(e) {
            return typeof k3 == "boolean" ? m3.resolve(k3) : E3(e).then(function(t) {
              return k3 = t, k3;
            });
          }
          function V3(e) {
            var t = U3[e.name], r = {};
            r.promise = new m3(function(o, i) {
              r.resolve = o, r.reject = i;
            }), t.deferredOperations.push(r), t.dbReady ? t.dbReady = t.dbReady.then(function() {
              return r.promise;
            }) : t.dbReady = r.promise;
          }
          function j2(e) {
            var t = U3[e.name], r = t.deferredOperations.pop();
            if (r) return r.resolve(), r.promise;
          }
          function Q(e, t) {
            var r = U3[e.name], o = r.deferredOperations.pop();
            if (o) return o.reject(t), o.promise;
          }
          function J2(e, t) {
            return new m3(function(r, o) {
              if (U3[e.name] = U3[e.name] || G3(), e.db) if (t) V3(e), e.db.close();
              else return r(e.db);
              var i = [e.name];
              t && i.push(e.version);
              var n = M2.open.apply(M2, i);
              t && (n.onupgradeneeded = function(f3) {
                var u3 = n.result;
                try {
                  u3.createObjectStore(e.storeName), f3.oldVersion <= 1 && u3.createObjectStore(F3);
                } catch (c2) {
                  if (c2.name === "ConstraintError") console.warn('The database "' + e.name + '" has been upgraded from version ' + f3.oldVersion + " to version " + f3.newVersion + ', but the storage "' + e.storeName + '" already exists.');
                  else throw c2;
                }
              }), n.onerror = function(f3) {
                f3.preventDefault(), o(n.error);
              }, n.onsuccess = function() {
                var f3 = n.result;
                f3.onversionchange = function(u3) {
                  u3.target.close();
                }, r(f3), j2(e);
              };
            });
          }
          function ee2(e) {
            return J2(e, false);
          }
          function oe2(e) {
            return J2(e, true);
          }
          function a2(e, t) {
            if (!e.db) return true;
            var r = !e.db.objectStoreNames.contains(e.storeName), o = e.version < e.db.version, i = e.version > e.db.version;
            if (o && (e.version !== t && console.warn('The database "' + e.name + `" can't be downgraded from version ` + e.db.version + " to version " + e.version + "."), e.version = e.db.version), i || r) {
              if (r) {
                var n = e.db.version + 1;
                n > e.version && (e.version = n);
              }
              return true;
            }
            return false;
          }
          function s(e) {
            return new m3(function(t, r) {
              var o = new FileReader();
              o.onerror = r, o.onloadend = function(i) {
                var n = btoa(i.target.result || "");
                t({ __local_forage_encoded_blob: true, data: n, type: e.type });
              }, o.readAsBinaryString(e);
            });
          }
          function v2(e) {
            var t = N2(atob(e.data));
            return $([t], { type: e.type });
          }
          function p2(e) {
            return e && e.__local_forage_encoded_blob;
          }
          function g2(e) {
            var t = this, r = t._initReady().then(function() {
              var o = U3[t._dbInfo.name];
              if (o && o.dbReady) return o.dbReady;
            });
            return B2(r, e, e), r;
          }
          function w2(e) {
            V3(e);
            for (var t = U3[e.name], r = t.forages, o = 0; o < r.length; o++) {
              var i = r[o];
              i._dbInfo.db && (i._dbInfo.db.close(), i._dbInfo.db = null);
            }
            return e.db = null, ee2(e).then(function(n) {
              return e.db = n, a2(e) ? oe2(e) : n;
            }).then(function(n) {
              e.db = t.db = n;
              for (var f3 = 0; f3 < r.length; f3++) r[f3]._dbInfo.db = n;
            }).catch(function(n) {
              throw Q(e, n), n;
            });
          }
          function T3(e, t, r, o) {
            o === void 0 && (o = 1);
            try {
              var i = e.db.transaction(e.storeName, t);
              r(null, i);
            } catch (n) {
              if (o > 0 && (!e.db || n.name === "InvalidStateError" || n.name === "NotFoundError")) return m3.resolve().then(function() {
                if (!e.db || n.name === "NotFoundError" && !e.db.objectStoreNames.contains(e.storeName) && e.version <= e.db.version) return e.db && (e.version = e.db.version + 1), oe2(e);
              }).then(function() {
                return w2(e).then(function() {
                  T3(e, t, r, o - 1);
                });
              }).catch(r);
              r(n);
            }
          }
          function G3() {
            return { forages: [], db: null, dbReady: null, deferredOperations: [] };
          }
          function fe2(e) {
            var t = this, r = { db: null };
            if (e) for (var o in e) r[o] = e[o];
            var i = U3[r.name];
            i || (i = G3(), U3[r.name] = i), i.forages.push(t), t._initReady || (t._initReady = t.ready, t.ready = g2);
            var n = [];
            function f3() {
              return m3.resolve();
            }
            for (var u3 = 0; u3 < i.forages.length; u3++) {
              var c2 = i.forages[u3];
              c2 !== t && n.push(c2._initReady().catch(f3));
            }
            var l = i.forages.slice(0);
            return m3.all(n).then(function() {
              return r.db = i.db, ee2(r);
            }).then(function(d2) {
              return r.db = d2, a2(r, t._defaultConfig.version) ? oe2(r) : d2;
            }).then(function(d2) {
              r.db = i.db = d2, t._dbInfo = r;
              for (var y3 = 0; y3 < l.length; y3++) {
                var S3 = l[y3];
                S3 !== t && (S3._dbInfo.db = r.db, S3._dbInfo.version = r.version);
              }
            });
          }
          function ie(e, t) {
            var r = this;
            e = z(e);
            var o = new m3(function(i, n) {
              r.ready().then(function() {
                T3(r._dbInfo, re2, function(f3, u3) {
                  if (f3) return n(f3);
                  try {
                    var c2 = u3.objectStore(r._dbInfo.storeName), l = c2.get(e);
                    l.onsuccess = function() {
                      var d2 = l.result;
                      d2 === void 0 && (d2 = null), p2(d2) && (d2 = v2(d2)), i(d2);
                    }, l.onerror = function() {
                      n(l.error);
                    };
                  } catch (d2) {
                    n(d2);
                  }
                });
              }).catch(n);
            });
            return _3(o, t), o;
          }
          function ce2(e, t) {
            var r = this, o = new m3(function(i, n) {
              r.ready().then(function() {
                T3(r._dbInfo, re2, function(f3, u3) {
                  if (f3) return n(f3);
                  try {
                    var c2 = u3.objectStore(r._dbInfo.storeName), l = c2.openCursor(), d2 = 1;
                    l.onsuccess = function() {
                      var y3 = l.result;
                      if (y3) {
                        var S3 = y3.value;
                        p2(S3) && (S3 = v2(S3));
                        var x2 = e(S3, y3.key, d2++);
                        x2 !== void 0 ? i(x2) : y3.continue();
                      } else i();
                    }, l.onerror = function() {
                      n(l.error);
                    };
                  } catch (y3) {
                    n(y3);
                  }
                });
              }).catch(n);
            });
            return _3(o, t), o;
          }
          function nr(e, t, r) {
            var o = this;
            e = z(e);
            var i = new m3(function(n, f3) {
              var u3;
              o.ready().then(function() {
                return u3 = o._dbInfo, ae2.call(t) === "[object Blob]" ? O3(u3.db).then(function(c2) {
                  return c2 ? t : s(t);
                }) : t;
              }).then(function(c2) {
                T3(o._dbInfo, h3, function(l, d2) {
                  if (l) return f3(l);
                  try {
                    var y3 = d2.objectStore(o._dbInfo.storeName);
                    c2 === null && (c2 = void 0);
                    var S3 = y3.put(c2, e);
                    d2.oncomplete = function() {
                      c2 === void 0 && (c2 = null), n(c2);
                    }, d2.onabort = d2.onerror = function() {
                      var x2 = S3.error ? S3.error : S3.transaction.error;
                      f3(x2);
                    };
                  } catch (x2) {
                    f3(x2);
                  }
                });
              }).catch(f3);
            });
            return _3(i, r), i;
          }
          function or2(e, t) {
            var r = this;
            e = z(e);
            var o = new m3(function(i, n) {
              r.ready().then(function() {
                T3(r._dbInfo, h3, function(f3, u3) {
                  if (f3) return n(f3);
                  try {
                    var c2 = u3.objectStore(r._dbInfo.storeName), l = c2.delete(e);
                    u3.oncomplete = function() {
                      i();
                    }, u3.onerror = function() {
                      n(l.error);
                    }, u3.onabort = function() {
                      var d2 = l.error ? l.error : l.transaction.error;
                      n(d2);
                    };
                  } catch (d2) {
                    n(d2);
                  }
                });
              }).catch(n);
            });
            return _3(o, t), o;
          }
          function ir2(e) {
            var t = this, r = new m3(function(o, i) {
              t.ready().then(function() {
                T3(t._dbInfo, h3, function(n, f3) {
                  if (n) return i(n);
                  try {
                    var u3 = f3.objectStore(t._dbInfo.storeName), c2 = u3.clear();
                    f3.oncomplete = function() {
                      o();
                    }, f3.onabort = f3.onerror = function() {
                      var l = c2.error ? c2.error : c2.transaction.error;
                      i(l);
                    };
                  } catch (l) {
                    i(l);
                  }
                });
              }).catch(i);
            });
            return _3(r, e), r;
          }
          function ar2(e) {
            var t = this, r = new m3(function(o, i) {
              t.ready().then(function() {
                T3(t._dbInfo, re2, function(n, f3) {
                  if (n) return i(n);
                  try {
                    var u3 = f3.objectStore(t._dbInfo.storeName), c2 = u3.count();
                    c2.onsuccess = function() {
                      o(c2.result);
                    }, c2.onerror = function() {
                      i(c2.error);
                    };
                  } catch (l) {
                    i(l);
                  }
                });
              }).catch(i);
            });
            return _3(r, e), r;
          }
          function fr2(e, t) {
            var r = this, o = new m3(function(i, n) {
              if (e < 0) {
                i(null);
                return;
              }
              r.ready().then(function() {
                T3(r._dbInfo, re2, function(f3, u3) {
                  if (f3) return n(f3);
                  try {
                    var c2 = u3.objectStore(r._dbInfo.storeName), l = false, d2 = c2.openKeyCursor();
                    d2.onsuccess = function() {
                      var y3 = d2.result;
                      if (!y3) {
                        i(null);
                        return;
                      }
                      e === 0 || l ? i(y3.key) : (l = true, y3.advance(e));
                    }, d2.onerror = function() {
                      n(d2.error);
                    };
                  } catch (y3) {
                    n(y3);
                  }
                });
              }).catch(n);
            });
            return _3(o, t), o;
          }
          function ur2(e) {
            var t = this, r = new m3(function(o, i) {
              t.ready().then(function() {
                T3(t._dbInfo, re2, function(n, f3) {
                  if (n) return i(n);
                  try {
                    var u3 = f3.objectStore(t._dbInfo.storeName), c2 = u3.openKeyCursor(), l = [];
                    c2.onsuccess = function() {
                      var d2 = c2.result;
                      if (!d2) {
                        o(l);
                        return;
                      }
                      l.push(d2.key), d2.continue();
                    }, c2.onerror = function() {
                      i(c2.error);
                    };
                  } catch (d2) {
                    i(d2);
                  }
                });
              }).catch(i);
            });
            return _3(r, e), r;
          }
          function sr2(e, t) {
            t = Z2.apply(this, arguments);
            var r = this.config();
            e = typeof e != "function" && e || {}, e.name || (e.name = e.name || r.name, e.storeName = e.storeName || r.storeName);
            var o = this, i;
            if (!e.name) i = m3.reject("Invalid arguments");
            else {
              var n = e.name === r.name && o._dbInfo.db, f3 = n ? m3.resolve(o._dbInfo.db) : ee2(e).then(function(u3) {
                var c2 = U3[e.name], l = c2.forages;
                c2.db = u3;
                for (var d2 = 0; d2 < l.length; d2++) l[d2]._dbInfo.db = u3;
                return u3;
              });
              e.storeName ? i = f3.then(function(u3) {
                if (!!u3.objectStoreNames.contains(e.storeName)) {
                  var c2 = u3.version + 1;
                  V3(e);
                  var l = U3[e.name], d2 = l.forages;
                  u3.close();
                  for (var y3 = 0; y3 < d2.length; y3++) {
                    var S3 = d2[y3];
                    S3._dbInfo.db = null, S3._dbInfo.version = c2;
                  }
                  var x2 = new m3(function(C3, K2) {
                    var W3 = M2.open(e.name, c2);
                    W3.onerror = function(q3) {
                      var de = W3.result;
                      de.close(), K2(q3);
                    }, W3.onupgradeneeded = function() {
                      var q3 = W3.result;
                      q3.deleteObjectStore(e.storeName);
                    }, W3.onsuccess = function() {
                      var q3 = W3.result;
                      q3.close(), C3(q3);
                    };
                  });
                  return x2.then(function(C3) {
                    l.db = C3;
                    for (var K2 = 0; K2 < d2.length; K2++) {
                      var W3 = d2[K2];
                      W3._dbInfo.db = C3, j2(W3._dbInfo);
                    }
                  }).catch(function(C3) {
                    throw (Q(e, C3) || m3.resolve()).catch(function() {
                    }), C3;
                  });
                }
              }) : i = f3.then(function(u3) {
                V3(e);
                var c2 = U3[e.name], l = c2.forages;
                u3.close();
                for (var d2 = 0; d2 < l.length; d2++) {
                  var y3 = l[d2];
                  y3._dbInfo.db = null;
                }
                var S3 = new m3(function(x2, C3) {
                  var K2 = M2.deleteDatabase(e.name);
                  K2.onerror = function() {
                    var W3 = K2.result;
                    W3 && W3.close(), C3(K2.error);
                  }, K2.onblocked = function() {
                    console.warn('dropInstance blocked for database "' + e.name + '" until all open connections are closed');
                  }, K2.onsuccess = function() {
                    var W3 = K2.result;
                    W3 && W3.close(), x2(W3);
                  };
                });
                return S3.then(function(x2) {
                  c2.db = x2;
                  for (var C3 = 0; C3 < l.length; C3++) {
                    var K2 = l[C3];
                    j2(K2._dbInfo);
                  }
                }).catch(function(x2) {
                  throw (Q(e, x2) || m3.resolve()).catch(function() {
                  }), x2;
                });
              });
            }
            return _3(i, t), i;
          }
          var cr2 = { _driver: "asyncStorage", _initStorage: fe2, _support: H3(), iterate: ce2, getItem: ie, setItem: nr, removeItem: or2, clear: ir2, length: ar2, key: fr2, keys: ur2, dropInstance: sr2 };
          function lr2() {
            return typeof openDatabase == "function";
          }
          var te2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", dr2 = "~~local_forage_type~", Be = /^~~local_forage_type~([^~]+)~/, he2 = "__lfsc__:", be2 = he2.length, _e2 = "arbf", we2 = "blob", xe2 = "si08", Oe = "ui08", Ce2 = "uic8", Le2 = "si16", Pe2 = "si32", Me2 = "ur16", Fe2 = "ui32", Ue2 = "fl32", Ye2 = "fl64", ze2 = be2 + _e2.length, We2 = Object.prototype.toString;
          function Ke(e) {
            var t = e.length * 0.75, r = e.length, o, i = 0, n, f3, u3, c2;
            e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
            var l = new ArrayBuffer(t), d2 = new Uint8Array(l);
            for (o = 0; o < r; o += 4) n = te2.indexOf(e[o]), f3 = te2.indexOf(e[o + 1]), u3 = te2.indexOf(e[o + 2]), c2 = te2.indexOf(e[o + 3]), d2[i++] = n << 2 | f3 >> 4, d2[i++] = (f3 & 15) << 4 | u3 >> 2, d2[i++] = (u3 & 3) << 6 | c2 & 63;
            return l;
          }
          function Ee2(e) {
            var t = new Uint8Array(e), r = "", o;
            for (o = 0; o < t.length; o += 3) r += te2[t[o] >> 2], r += te2[(t[o] & 3) << 4 | t[o + 1] >> 4], r += te2[(t[o + 1] & 15) << 2 | t[o + 2] >> 6], r += te2[t[o + 2] & 63];
            return t.length % 3 === 2 ? r = r.substring(0, r.length - 1) + "=" : t.length % 3 === 1 && (r = r.substring(0, r.length - 2) + "=="), r;
          }
          function vr2(e, t) {
            var r = "";
            if (e && (r = We2.call(e)), e && (r === "[object ArrayBuffer]" || e.buffer && We2.call(e.buffer) === "[object ArrayBuffer]")) {
              var o, i = he2;
              e instanceof ArrayBuffer ? (o = e, i += _e2) : (o = e.buffer, r === "[object Int8Array]" ? i += xe2 : r === "[object Uint8Array]" ? i += Oe : r === "[object Uint8ClampedArray]" ? i += Ce2 : r === "[object Int16Array]" ? i += Le2 : r === "[object Uint16Array]" ? i += Me2 : r === "[object Int32Array]" ? i += Pe2 : r === "[object Uint32Array]" ? i += Fe2 : r === "[object Float32Array]" ? i += Ue2 : r === "[object Float64Array]" ? i += Ye2 : t(new Error("Failed to get type for BinaryArray"))), t(i + Ee2(o));
            } else if (r === "[object Blob]") {
              var n = new FileReader();
              n.onload = function() {
                var f3 = dr2 + e.type + "~" + Ee2(this.result);
                t(he2 + we2 + f3);
              }, n.readAsArrayBuffer(e);
            } else try {
              t(JSON.stringify(e));
            } catch (f3) {
              console.error("Couldn't convert value into a JSON string: ", e), t(null, f3);
            }
          }
          function hr2(e) {
            if (e.substring(0, be2) !== he2) return JSON.parse(e);
            var t = e.substring(ze2), r = e.substring(be2, ze2), o;
            if (r === we2 && Be.test(t)) {
              var i = t.match(Be);
              o = i[1], t = t.substring(i[0].length);
            }
            var n = Ke(t);
            switch (r) {
              case _e2:
                return n;
              case we2:
                return $([n], { type: o });
              case xe2:
                return new Int8Array(n);
              case Oe:
                return new Uint8Array(n);
              case Ce2:
                return new Uint8ClampedArray(n);
              case Le2:
                return new Int16Array(n);
              case Me2:
                return new Uint16Array(n);
              case Pe2:
                return new Int32Array(n);
              case Fe2:
                return new Uint32Array(n);
              case Ue2:
                return new Float32Array(n);
              case Ye2:
                return new Float64Array(n);
              default:
                throw new Error("Unkown type: " + r);
            }
          }
          var Ie2 = { serialize: vr2, deserialize: hr2, stringToBuffer: Ke, bufferToString: Ee2 };
          function He(e, t, r, o) {
            e.executeSql("CREATE TABLE IF NOT EXISTS " + t.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], r, o);
          }
          function mr2(e) {
            var t = this, r = { db: null };
            if (e) for (var o in e) r[o] = typeof e[o] != "string" ? e[o].toString() : e[o];
            var i = new m3(function(n, f3) {
              try {
                r.db = openDatabase(r.name, String(r.version), r.description, r.size);
              } catch (u3) {
                return f3(u3);
              }
              r.db.transaction(function(u3) {
                He(u3, r, function() {
                  t._dbInfo = r, n();
                }, function(c2, l) {
                  f3(l);
                });
              }, f3);
            });
            return r.serializer = Ie2, i;
          }
          function ne2(e, t, r, o, i, n) {
            e.executeSql(r, o, i, function(f3, u3) {
              u3.code === u3.SYNTAX_ERR ? f3.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [t.storeName], function(c2, l) {
                l.rows.length ? n(c2, u3) : He(c2, t, function() {
                  c2.executeSql(r, o, i, n);
                }, n);
              }, n) : n(f3, u3);
            }, n);
          }
          function yr(e, t) {
            var r = this;
            e = z(e);
            var o = new m3(function(i, n) {
              r.ready().then(function() {
                var f3 = r._dbInfo;
                f3.db.transaction(function(u3) {
                  ne2(u3, f3, "SELECT * FROM " + f3.storeName + " WHERE key = ? LIMIT 1", [e], function(c2, l) {
                    var d2 = l.rows.length ? l.rows.item(0).value : null;
                    d2 && (d2 = f3.serializer.deserialize(d2)), i(d2);
                  }, function(c2, l) {
                    n(l);
                  });
                });
              }).catch(n);
            });
            return _3(o, t), o;
          }
          function pr2(e, t) {
            var r = this, o = new m3(function(i, n) {
              r.ready().then(function() {
                var f3 = r._dbInfo;
                f3.db.transaction(function(u3) {
                  ne2(u3, f3, "SELECT * FROM " + f3.storeName, [], function(c2, l) {
                    for (var d2 = l.rows, y3 = d2.length, S3 = 0; S3 < y3; S3++) {
                      var x2 = d2.item(S3), C3 = x2.value;
                      if (C3 && (C3 = f3.serializer.deserialize(C3)), C3 = e(C3, x2.key, S3 + 1), C3 !== void 0) {
                        i(C3);
                        return;
                      }
                    }
                    i();
                  }, function(c2, l) {
                    n(l);
                  });
                });
              }).catch(n);
            });
            return _3(o, t), o;
          }
          function Ve2(e, t, r, o) {
            var i = this;
            e = z(e);
            var n = new m3(function(f3, u3) {
              i.ready().then(function() {
                t === void 0 && (t = null);
                var c2 = t, l = i._dbInfo;
                l.serializer.serialize(t, function(d2, y3) {
                  y3 ? u3(y3) : l.db.transaction(function(S3) {
                    ne2(S3, l, "INSERT OR REPLACE INTO " + l.storeName + " (key, value) VALUES (?, ?)", [e, d2], function() {
                      f3(c2);
                    }, function(x2, C3) {
                      u3(C3);
                    });
                  }, function(S3) {
                    if (S3.code === S3.QUOTA_ERR) {
                      if (o > 0) {
                        f3(Ve2.apply(i, [e, c2, r, o - 1]));
                        return;
                      }
                      u3(S3);
                    }
                  });
                });
              }).catch(u3);
            });
            return _3(n, r), n;
          }
          function gr2(e, t, r) {
            return Ve2.apply(this, [e, t, r, 1]);
          }
          function br2(e, t) {
            var r = this;
            e = z(e);
            var o = new m3(function(i, n) {
              r.ready().then(function() {
                var f3 = r._dbInfo;
                f3.db.transaction(function(u3) {
                  ne2(u3, f3, "DELETE FROM " + f3.storeName + " WHERE key = ?", [e], function() {
                    i();
                  }, function(c2, l) {
                    n(l);
                  });
                });
              }).catch(n);
            });
            return _3(o, t), o;
          }
          function _r(e) {
            var t = this, r = new m3(function(o, i) {
              t.ready().then(function() {
                var n = t._dbInfo;
                n.db.transaction(function(f3) {
                  ne2(f3, n, "DELETE FROM " + n.storeName, [], function() {
                    o();
                  }, function(u3, c2) {
                    i(c2);
                  });
                });
              }).catch(i);
            });
            return _3(r, e), r;
          }
          function wr2(e) {
            var t = this, r = new m3(function(o, i) {
              t.ready().then(function() {
                var n = t._dbInfo;
                n.db.transaction(function(f3) {
                  ne2(f3, n, "SELECT COUNT(key) as c FROM " + n.storeName, [], function(u3, c2) {
                    var l = c2.rows.item(0).c;
                    o(l);
                  }, function(u3, c2) {
                    i(c2);
                  });
                });
              }).catch(i);
            });
            return _3(r, e), r;
          }
          function Er2(e, t) {
            var r = this, o = new m3(function(i, n) {
              r.ready().then(function() {
                var f3 = r._dbInfo;
                f3.db.transaction(function(u3) {
                  ne2(u3, f3, "SELECT key FROM " + f3.storeName + " WHERE id = ? LIMIT 1", [e + 1], function(c2, l) {
                    var d2 = l.rows.length ? l.rows.item(0).key : null;
                    i(d2);
                  }, function(c2, l) {
                    n(l);
                  });
                });
              }).catch(n);
            });
            return _3(o, t), o;
          }
          function Ir2(e) {
            var t = this, r = new m3(function(o, i) {
              t.ready().then(function() {
                var n = t._dbInfo;
                n.db.transaction(function(f3) {
                  ne2(f3, n, "SELECT key FROM " + n.storeName, [], function(u3, c2) {
                    for (var l = [], d2 = 0; d2 < c2.rows.length; d2++) l.push(c2.rows.item(d2).key);
                    o(l);
                  }, function(u3, c2) {
                    i(c2);
                  });
                });
              }).catch(i);
            });
            return _3(r, e), r;
          }
          function Sr(e) {
            return new m3(function(t, r) {
              e.transaction(function(o) {
                o.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(i, n) {
                  for (var f3 = [], u3 = 0; u3 < n.rows.length; u3++) f3.push(n.rows.item(u3).name);
                  t({ db: e, storeNames: f3 });
                }, function(i, n) {
                  r(n);
                });
              }, function(o) {
                r(o);
              });
            });
          }
          function Ar(e, t) {
            t = Z2.apply(this, arguments);
            var r = this.config();
            e = typeof e != "function" && e || {}, e.name || (e.name = e.name || r.name, e.storeName = e.storeName || r.storeName);
            var o = this, i;
            return e.name ? i = new m3(function(n) {
              var f3;
              e.name === r.name ? f3 = o._dbInfo.db : f3 = openDatabase(e.name, "", "", 0), e.storeName ? n({ db: f3, storeNames: [e.storeName] }) : n(Sr(f3));
            }).then(function(n) {
              return new m3(function(f3, u3) {
                n.db.transaction(function(c2) {
                  function l(x2) {
                    return new m3(function(C3, K2) {
                      c2.executeSql("DROP TABLE IF EXISTS " + x2, [], function() {
                        C3();
                      }, function(W3, q3) {
                        K2(q3);
                      });
                    });
                  }
                  for (var d2 = [], y3 = 0, S3 = n.storeNames.length; y3 < S3; y3++) d2.push(l(n.storeNames[y3]));
                  m3.all(d2).then(function() {
                    f3();
                  }).catch(function(x2) {
                    u3(x2);
                  });
                }, function(c2) {
                  u3(c2);
                });
              });
            }) : i = m3.reject("Invalid arguments"), _3(i, t), i;
          }
          var Rr2 = { _driver: "webSQLStorage", _initStorage: mr2, _support: lr2(), iterate: pr2, getItem: yr, setItem: gr2, removeItem: br2, clear: _r, length: wr2, key: Er2, keys: Ir2, dropInstance: Ar };
          function Dr() {
            try {
              return typeof localStorage < "u" && "setItem" in localStorage && !!localStorage.setItem;
            } catch {
              return false;
            }
          }
          function Ge2(e, t) {
            var r = e.name + "/";
            return e.storeName !== t.storeName && (r += e.storeName + "/"), r;
          }
          function Nr() {
            var e = "_localforage_support_test";
            try {
              return localStorage.setItem(e, true), localStorage.removeItem(e), false;
            } catch {
              return true;
            }
          }
          function Tr() {
            return !Nr() || localStorage.length > 0;
          }
          function Br(e) {
            var t = this, r = {};
            if (e) for (var o in e) r[o] = e[o];
            return r.keyPrefix = Ge2(e, t._defaultConfig), Tr() ? (t._dbInfo = r, r.serializer = Ie2, m3.resolve()) : m3.reject();
          }
          function xr(e) {
            var t = this, r = t.ready().then(function() {
              for (var o = t._dbInfo.keyPrefix, i = localStorage.length - 1; i >= 0; i--) {
                var n = localStorage.key(i);
                n.indexOf(o) === 0 && localStorage.removeItem(n);
              }
            });
            return _3(r, e), r;
          }
          function Or(e, t) {
            var r = this;
            e = z(e);
            var o = r.ready().then(function() {
              var i = r._dbInfo, n = localStorage.getItem(i.keyPrefix + e);
              return n && (n = i.serializer.deserialize(n)), n;
            });
            return _3(o, t), o;
          }
          function Cr(e, t) {
            var r = this, o = r.ready().then(function() {
              for (var i = r._dbInfo, n = i.keyPrefix, f3 = n.length, u3 = localStorage.length, c2 = 1, l = 0; l < u3; l++) {
                var d2 = localStorage.key(l);
                if (d2.indexOf(n) === 0) {
                  var y3 = localStorage.getItem(d2);
                  if (y3 && (y3 = i.serializer.deserialize(y3)), y3 = e(y3, d2.substring(f3), c2++), y3 !== void 0) return y3;
                }
              }
            });
            return _3(o, t), o;
          }
          function Lr(e, t) {
            var r = this, o = r.ready().then(function() {
              var i = r._dbInfo, n;
              try {
                n = localStorage.key(e);
              } catch {
                n = null;
              }
              return n && (n = n.substring(i.keyPrefix.length)), n;
            });
            return _3(o, t), o;
          }
          function Pr2(e) {
            var t = this, r = t.ready().then(function() {
              for (var o = t._dbInfo, i = localStorage.length, n = [], f3 = 0; f3 < i; f3++) {
                var u3 = localStorage.key(f3);
                u3.indexOf(o.keyPrefix) === 0 && n.push(u3.substring(o.keyPrefix.length));
              }
              return n;
            });
            return _3(r, e), r;
          }
          function Mr(e) {
            var t = this, r = t.keys().then(function(o) {
              return o.length;
            });
            return _3(r, e), r;
          }
          function Fr(e, t) {
            var r = this;
            e = z(e);
            var o = r.ready().then(function() {
              var i = r._dbInfo;
              localStorage.removeItem(i.keyPrefix + e);
            });
            return _3(o, t), o;
          }
          function Ur(e, t, r) {
            var o = this;
            e = z(e);
            var i = o.ready().then(function() {
              t === void 0 && (t = null);
              var n = t;
              return new m3(function(f3, u3) {
                var c2 = o._dbInfo;
                c2.serializer.serialize(t, function(l, d2) {
                  if (d2) u3(d2);
                  else try {
                    localStorage.setItem(c2.keyPrefix + e, l), f3(n);
                  } catch (y3) {
                    (y3.name === "QuotaExceededError" || y3.name === "NS_ERROR_DOM_QUOTA_REACHED") && u3(y3), u3(y3);
                  }
                });
              });
            });
            return _3(i, r), i;
          }
          function Yr(e, t) {
            if (t = Z2.apply(this, arguments), e = typeof e != "function" && e || {}, !e.name) {
              var r = this.config();
              e.name = e.name || r.name, e.storeName = e.storeName || r.storeName;
            }
            var o = this, i;
            return e.name ? i = new m3(function(n) {
              e.storeName ? n(Ge2(e, o._defaultConfig)) : n(e.name + "/");
            }).then(function(n) {
              for (var f3 = localStorage.length - 1; f3 >= 0; f3--) {
                var u3 = localStorage.key(f3);
                u3.indexOf(n) === 0 && localStorage.removeItem(u3);
              }
            }) : i = m3.reject("Invalid arguments"), _3(i, t), i;
          }
          var zr = { _driver: "localStorageWrapper", _initStorage: Br, _support: Dr(), iterate: Cr, getItem: Or, setItem: Ur, removeItem: Fr, clear: xr, length: Mr, key: Lr, keys: Pr2, dropInstance: Yr }, Wr2 = function(t, r) {
            return t === r || typeof t == "number" && typeof r == "number" && isNaN(t) && isNaN(r);
          }, Kr = function(t, r) {
            for (var o = t.length, i = 0; i < o; ) {
              if (Wr2(t[i], r)) return true;
              i++;
            }
            return false;
          }, je2 = Array.isArray || function(e) {
            return Object.prototype.toString.call(e) === "[object Array]";
          }, le2 = {}, Xe2 = {}, ue2 = { INDEXEDDB: cr2, WEBSQL: Rr2, LOCALSTORAGE: zr }, Hr = [ue2.INDEXEDDB._driver, ue2.WEBSQL._driver, ue2.LOCALSTORAGE._driver], me2 = ["dropInstance"], Se2 = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(me2), Vr = { description: "", driver: Hr.slice(), name: "localforage", size: 4980736, storeName: "keyvaluepairs", version: 1 };
          function Gr(e, t) {
            e[t] = function() {
              var r = arguments;
              return e.ready().then(function() {
                return e[t].apply(e, r);
              });
            };
          }
          function Ae2() {
            for (var e = 1; e < arguments.length; e++) {
              var t = arguments[e];
              if (t) for (var r in t) t.hasOwnProperty(r) && (je2(t[r]) ? arguments[0][r] = t[r].slice() : arguments[0][r] = t[r]);
            }
            return arguments[0];
          }
          var jr = function() {
            function e(t) {
              Y2(this, e);
              for (var r in ue2) if (ue2.hasOwnProperty(r)) {
                var o = ue2[r], i = o._driver;
                this[r] = i, le2[i] || this.defineDriver(o);
              }
              this._defaultConfig = Ae2({}, Vr), this._config = Ae2({}, this._defaultConfig, t), this._driverSet = null, this._initDriver = null, this._ready = false, this._dbInfo = null, this._wrapLibraryMethodsWithReady(), this.setDriver(this._config.driver).catch(function() {
              });
            }
            return e.prototype.config = function(r) {
              if ((typeof r > "u" ? "undefined" : P2(r)) === "object") {
                if (this._ready) return new Error("Can't call config() after localforage has been used.");
                for (var o in r) {
                  if (o === "storeName" && (r[o] = r[o].replace(/\W/g, "_")), o === "version" && typeof r[o] != "number") return new Error("Database version must be a number.");
                  this._config[o] = r[o];
                }
                return "driver" in r && r.driver ? this.setDriver(this._config.driver) : true;
              } else return typeof r == "string" ? this._config[r] : this._config;
            }, e.prototype.defineDriver = function(r, o, i) {
              var n = new m3(function(f3, u3) {
                try {
                  var c2 = r._driver, l = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                  if (!r._driver) {
                    u3(l);
                    return;
                  }
                  for (var d2 = Se2.concat("_initStorage"), y3 = 0, S3 = d2.length; y3 < S3; y3++) {
                    var x2 = d2[y3], C3 = !Kr(me2, x2);
                    if ((C3 || r[x2]) && typeof r[x2] != "function") {
                      u3(l);
                      return;
                    }
                  }
                  var K2 = function() {
                    for (var de = function(Jr) {
                      return function() {
                        var $r = new Error("Method " + Jr + " is not implemented by the current driver"), Qe2 = m3.reject($r);
                        return _3(Qe2, arguments[arguments.length - 1]), Qe2;
                      };
                    }, Re2 = 0, Qr = me2.length; Re2 < Qr; Re2++) {
                      var De2 = me2[Re2];
                      r[De2] || (r[De2] = de(De2));
                    }
                  };
                  K2();
                  var W3 = function(de) {
                    le2[c2] && console.info("Redefining LocalForage driver: " + c2), le2[c2] = r, Xe2[c2] = de, f3();
                  };
                  "_support" in r ? r._support && typeof r._support == "function" ? r._support().then(W3, u3) : W3(!!r._support) : W3(true);
                } catch (q3) {
                  u3(q3);
                }
              });
              return B2(n, o, i), n;
            }, e.prototype.driver = function() {
              return this._driver || null;
            }, e.prototype.getDriver = function(r, o, i) {
              var n = le2[r] ? m3.resolve(le2[r]) : m3.reject(new Error("Driver not found."));
              return B2(n, o, i), n;
            }, e.prototype.getSerializer = function(r) {
              var o = m3.resolve(Ie2);
              return B2(o, r), o;
            }, e.prototype.ready = function(r) {
              var o = this, i = o._driverSet.then(function() {
                return o._ready === null && (o._ready = o._initDriver()), o._ready;
              });
              return B2(i, r, r), i;
            }, e.prototype.setDriver = function(r, o, i) {
              var n = this;
              je2(r) || (r = [r]);
              var f3 = this._getSupportedDrivers(r);
              function u3() {
                n._config.driver = n.driver();
              }
              function c2(y3) {
                return n._extend(y3), u3(), n._ready = n._initStorage(n._config), n._ready;
              }
              function l(y3) {
                return function() {
                  var S3 = 0;
                  function x2() {
                    for (; S3 < y3.length; ) {
                      var C3 = y3[S3];
                      return S3++, n._dbInfo = null, n._ready = null, n.getDriver(C3).then(c2).catch(x2);
                    }
                    u3();
                    var K2 = new Error("No available storage method found.");
                    return n._driverSet = m3.reject(K2), n._driverSet;
                  }
                  return x2();
                };
              }
              var d2 = this._driverSet !== null ? this._driverSet.catch(function() {
                return m3.resolve();
              }) : m3.resolve();
              return this._driverSet = d2.then(function() {
                var y3 = f3[0];
                return n._dbInfo = null, n._ready = null, n.getDriver(y3).then(function(S3) {
                  n._driver = S3._driver, u3(), n._wrapLibraryMethodsWithReady(), n._initDriver = l(f3);
                });
              }).catch(function() {
                u3();
                var y3 = new Error("No available storage method found.");
                return n._driverSet = m3.reject(y3), n._driverSet;
              }), B2(this._driverSet, o, i), this._driverSet;
            }, e.prototype.supports = function(r) {
              return !!Xe2[r];
            }, e.prototype._extend = function(r) {
              Ae2(this, r);
            }, e.prototype._getSupportedDrivers = function(r) {
              for (var o = [], i = 0, n = r.length; i < n; i++) {
                var f3 = r[i];
                this.supports(f3) && o.push(f3);
              }
              return o;
            }, e.prototype._wrapLibraryMethodsWithReady = function() {
              for (var r = 0, o = Se2.length; r < o; r++) Gr(this, Se2[r]);
            }, e.prototype.createInstance = function(r) {
              return new e(r);
            }, e;
          }(), Xr = new jr();
          D3.exports = Xr;
        }, { 3: 3 }] }, {}, [4])(4);
      });
    });
    rr2 = $e2((ye, er) => {
      (function(b3, R3) {
        typeof ye == "object" && typeof er < "u" ? R3(ye) : typeof define == "function" && define.amd ? define("localforage-driver-memory", ["exports"], R3) : R3(b3.LocalforageDriverMemory = {});
      })(typeof self < "u" ? self : ye, function(b3) {
        "use strict";
        var R3 = "localforage-driver-memory";
        function A2(a2) {
          var s = typeof Symbol == "function" && a2[Symbol.iterator], v2 = 0;
          return s ? s.call(a2) : { next: function() {
            return a2 && v2 >= a2.length && (a2 = void 0), { value: a2 && a2[v2++], done: !a2 };
          } };
        }
        function L3(a2, s) {
          a2 = a2 || [], s = s || {};
          try {
            return new Blob(a2, s);
          } catch (w2) {
            if (w2.name !== "TypeError") throw w2;
            for (var v2 = typeof BlobBuilder < "u" ? BlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" ? MozBlobBuilder : WebKitBlobBuilder, p2 = new v2(), g2 = 0; g2 < a2.length; g2 += 1) p2.append(a2[g2]);
            return p2.getBlob(s.type);
          }
        }
        var D3 = /^~~local_forage_type~([^~]+)~/, X2 = 9, P2 = X2 + 4, Y2 = Object.prototype.toString;
        function I2(a2) {
          var s = a2.length * 0.75, v2 = a2.length;
          a2[a2.length - 1] === "=" && (s--, a2[a2.length - 2] === "=" && s--);
          for (var p2 = new ArrayBuffer(s), g2 = new Uint8Array(p2), w2 = 0, T3 = 0; w2 < v2; w2 += 4) {
            var G3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(a2[w2]), fe2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(a2[w2 + 1]), ie = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(a2[w2 + 2]), ce2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(a2[w2 + 3]);
            g2[T3++] = G3 << 2 | fe2 >> 4, g2[T3++] = (fe2 & 15) << 4 | ie >> 2, g2[T3++] = (ie & 3) << 6 | ce2 & 63;
          }
          return p2;
        }
        function M2(a2) {
          for (var s = new Uint8Array(a2), v2 = "", p2 = 0; p2 < s.length; p2 += 3) v2 += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[s[p2] >> 2], v2 += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[(s[p2] & 3) << 4 | s[p2 + 1] >> 4], v2 += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[(s[p2 + 1] & 15) << 2 | s[p2 + 2] >> 6], v2 += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[s[p2 + 2] & 63];
          return s.length % 3 === 2 ? v2 = v2.substring(0, v2.length - 1) + "=" : s.length % 3 === 1 && (v2 = v2.substring(0, v2.length - 2) + "=="), v2;
        }
        function H3(a2, s) {
          var v2 = "";
          if (a2 && (v2 = Y2.call(a2)), a2 && (v2 === "[object ArrayBuffer]" || a2.buffer && Y2.call(a2.buffer) === "[object ArrayBuffer]")) {
            var p2 = void 0, g2 = "__lfsc__:";
            a2 instanceof ArrayBuffer ? (p2 = a2, g2 += "arbf") : (p2 = a2.buffer, v2 === "[object Int8Array]" ? g2 += "si08" : v2 === "[object Uint8Array]" ? g2 += "ui08" : v2 === "[object Uint8ClampedArray]" ? g2 += "uic8" : v2 === "[object Int16Array]" ? g2 += "si16" : v2 === "[object Uint16Array]" ? g2 += "ur16" : v2 === "[object Int32Array]" ? g2 += "si32" : v2 === "[object Uint32Array]" ? g2 += "ui32" : v2 === "[object Float32Array]" ? g2 += "fl32" : v2 === "[object Float64Array]" ? g2 += "fl64" : s(new Error("Failed to get type for BinaryArray"))), s(g2 + M2(p2));
          } else if (v2 === "[object Blob]") {
            var w2 = new FileReader();
            w2.onload = function() {
              var T3 = "~~local_forage_type~" + a2.type + "~" + M2(this.result);
              s("__lfsc__:blob" + T3);
            }, w2.readAsArrayBuffer(a2);
          } else try {
            s(JSON.stringify(a2));
          } catch (T3) {
            console.error("Couldn't convert value into a JSON string: ", a2), s(null, T3);
          }
        }
        function $(a2) {
          if (a2.substring(0, X2) !== "__lfsc__:") return JSON.parse(a2);
          var s = a2.substring(P2), v2 = a2.substring(X2, P2), p2;
          if (v2 === "blob" && D3.test(s)) {
            var g2 = s.match(D3);
            p2 = g2[1], s = s.substring(g2[0].length);
          }
          var w2 = I2(s);
          switch (v2) {
            case "arbf":
              return w2;
            case "blob":
              return L3([w2], { type: p2 });
            case "si08":
              return new Int8Array(w2);
            case "ui08":
              return new Uint8Array(w2);
            case "uic8":
              return new Uint8ClampedArray(w2);
            case "si16":
              return new Int16Array(w2);
            case "ur16":
              return new Uint16Array(w2);
            case "si32":
              return new Int32Array(w2);
            case "ui32":
              return new Uint32Array(w2);
            case "fl32":
              return new Float32Array(w2);
            case "fl64":
              return new Float64Array(w2);
            default:
              throw new Error("Unkown type: " + v2);
          }
        }
        function m3(a2) {
          var s, v2;
          if (a2 === null || typeof a2 != "object" || "isActiveClone" in a2) return a2;
          var p2 = a2 instanceof Date ? new Date(a2) : a2.constructor();
          try {
            for (var g2 = A2(Object.keys(a2)), w2 = g2.next(); !w2.done; w2 = g2.next()) {
              var T3 = w2.value;
              Object.prototype.hasOwnProperty.call(a2, T3) && (a2.isActiveClone = null, p2[T3] = m3(a2[T3]), delete a2.isActiveClone);
            }
          } catch (G3) {
            s = { error: G3 };
          } finally {
            try {
              w2 && !w2.done && (v2 = g2.return) && v2.call(g2);
            } finally {
              if (s) throw s.error;
            }
          }
          return p2;
        }
        function _3(a2, s) {
          return (a2.name || s.name) + "/" + (a2.storeName || s.storeName) + "/";
        }
        function B2(a2, s) {
          s && a2.then(function(v2) {
            s(null, v2);
          }, function(v2) {
            s(v2);
          });
        }
        function z() {
          for (var a2 = [], s = 0; s < arguments.length; s++) a2[s] = arguments[s];
          if (arguments.length && typeof arguments[arguments.length - 1] == "function") return arguments[arguments.length - 1];
        }
        function Z2(a2, s) {
          var v2 = this;
          if (s = z.apply(this, arguments), a2 = typeof a2 != "function" && a2 || {}, !a2.name) {
            var p2 = this.config();
            a2.name = a2.name || p2.name, a2.storeName = a2.storeName || p2.storeName;
          }
          var g2;
          return a2.name ? g2 = new Promise(function(w2) {
            a2.storeName ? w2(_3(a2, v2._defaultConfig)) : w2(a2.name + "/");
          }) : g2 = Promise.reject("Invalid arguments"), { promise: g2, callback: s };
        }
        function F3(a2) {
          return typeof a2 != "string" && (console.warn(a2 + " used as a key, but it is not a string."), a2 = String(a2)), a2;
        }
        var k3 = { bufferToString: M2, deserialize: $, serialize: H3, stringToBuffer: I2 }, U3 = {}, ae2 = function() {
          function a2(s) {
            this.kp = s, this.data = {};
          }
          return a2.resolve = function(s) {
            return U3[s] || (U3[s] = new a2(s)), U3[s];
          }, a2.prototype.clear = function() {
            this.data = {};
          }, a2.prototype.drop = function() {
            this.clear(), delete U3[this.kp];
          }, a2.prototype.get = function(s) {
            return this.data[s];
          }, a2.prototype.key = function(s) {
            return this.keys()[s];
          }, a2.prototype.keys = function() {
            return Object.keys(this.data);
          }, a2.prototype.rm = function(s) {
            delete this.data[s];
          }, a2.prototype.set = function(s, v2) {
            this.data[s] = v2;
          }, a2;
        }();
        function re2(a2) {
          var s = a2 ? m3(a2) : {}, v2 = _3(s, this._defaultConfig), p2 = ae2.resolve(v2);
          return this._dbInfo = s, this._dbInfo.serializer = k3, this._dbInfo.keyPrefix = v2, this._dbInfo.mStore = p2, Promise.resolve();
        }
        function h3(a2) {
          var s = this, v2 = this.ready().then(function() {
            s._dbInfo.mStore.clear();
          });
          return B2(v2, a2), v2;
        }
        function N2(a2, s) {
          var v2 = Z2.apply(this, arguments), p2 = v2.promise, g2 = v2.callback, w2 = p2.then(function(T3) {
            ae2.resolve(T3).drop();
          });
          return B2(w2, g2), p2;
        }
        function E3(a2, s) {
          var v2 = this;
          a2 = F3(a2);
          var p2 = this.ready().then(function() {
            var g2 = v2._dbInfo.mStore.get(a2);
            return g2 == null ? null : v2._dbInfo.serializer.deserialize(g2);
          });
          return B2(p2, s), p2;
        }
        function O3(a2, s) {
          var v2 = this, p2 = this.ready().then(function() {
            for (var g2 = v2._dbInfo.mStore, w2 = g2.keys(), T3 = 0; T3 < w2.length; T3++) {
              var G3 = g2.get(w2[T3]);
              if (G3 && (G3 = v2._dbInfo.serializer.deserialize(G3)), G3 = a2(G3, w2[T3], T3 + 1), G3 !== void 0) return G3;
            }
          });
          return B2(p2, s), p2;
        }
        function V3(a2, s) {
          var v2 = this, p2 = this.ready().then(function() {
            var g2;
            try {
              g2 = v2._dbInfo.mStore.key(a2), g2 === void 0 && (g2 = null);
            } catch {
              g2 = null;
            }
            return g2;
          });
          return B2(p2, s), p2;
        }
        function j2(a2) {
          var s = this, v2 = this.ready().then(function() {
            return s._dbInfo.mStore.keys();
          });
          return B2(v2, a2), v2;
        }
        function Q(a2) {
          var s = this.keys().then(function(v2) {
            return v2.length;
          });
          return B2(s, a2), s;
        }
        function J2(a2, s) {
          var v2 = this;
          a2 = F3(a2);
          var p2 = this.ready().then(function() {
            v2._dbInfo.mStore.rm(a2);
          });
          return B2(p2, s), p2;
        }
        function ee2(a2, s, v2) {
          var p2 = this;
          a2 = F3(a2);
          var g2 = this.ready().then(function() {
            s === void 0 && (s = null);
            var w2 = s;
            return new Promise(function(T3, G3) {
              p2._dbInfo.serializer.serialize(s, function(fe2, ie) {
                if (ie) G3(ie);
                else try {
                  p2._dbInfo.mStore.set(a2, fe2), T3(w2);
                } catch (ce2) {
                  G3(ce2);
                }
              });
            });
          });
          return B2(g2, v2), g2;
        }
        var oe2 = true;
        b3._support = oe2, b3._driver = R3, b3._initStorage = re2, b3.clear = h3, b3.dropInstance = N2, b3.getItem = E3, b3.iterate = O3, b3.key = V3, b3.keys = j2, b3.length = Q, b3.removeItem = J2, b3.setItem = ee2, Object.defineProperty(b3, "__esModule", { value: true });
      });
    });
    ge = Ze2(ke2());
    Te2 = Ze2(rr2());
    at2 = { display: "block", visibility: "hidden", position: "fixed", top: "0", right: "0", width: "100%", height: "100%", borderRadius: "0", border: "none", zIndex: "2147483647", opacity: "0" };
    pe2 = class extends Ve {
      constructor() {
        super(...arguments);
        this.activeElement = null;
      }
      init() {
        this.test = "hello", this.iframe = new Promise((A2) => {
          let L3 = () => {
            if (ut2(encodeURIComponent(this.parameters))) Wr().log();
            else {
              let D3 = document.createElement("iframe");
              D3.classList.add("magic-iframe"), D3.dataset.magicIframeLabel = Ge(this.endpoint).host, D3.title = "Secure Modal", D3.src = Ge(`/send?params=${encodeURIComponent(this.parameters)}`, this.endpoint).href, D3.allow = "clipboard-read; clipboard-write", ft2(D3), document.body.appendChild(D3), A2(D3);
            }
          };
          ["loaded", "interactive", "complete"].includes(document.readyState) ? L3() : window.addEventListener("load", L3, false);
        }), window.addEventListener("message", (A2) => {
          var L3;
          if (A2.origin === this.endpoint && A2.data && A2.data.msgType && this.messageHandlers.size) {
            A2.data.response = (L3 = A2.data.response) != null ? L3 : {};
            for (let D3 of this.messageHandlers.values()) D3(A2);
          }
        });
      }
      showOverlay() {
        return se2(this, null, function* () {
          let A2 = yield this.iframe;
          A2.style.visibility = "visible", A2.style.opacity = "1", this.activeElement = document.activeElement, A2.focus();
        });
      }
      hideOverlay() {
        return se2(this, null, function* () {
          var L3;
          let A2 = yield this.iframe;
          A2.style.visibility = "hidden", A2.style.opacity = "0", (L3 = this.activeElement) != null && L3.focus && this.activeElement.focus(), this.activeElement = null;
        });
      }
      _post(A2) {
        return se2(this, null, function* () {
          let L3 = yield this.iframe;
          if (L3 && L3.contentWindow) L3.contentWindow.postMessage(A2, this.endpoint);
          else throw ft();
        });
      }
    };
    bt2 = jn(Ae, { platform: "web", sdkName: "magic-sdk", version: "28.6.0", defaultEndpoint: "https://auth.magic.link/", ViewController: pe2, configureStorage: () => se2(void 0, null, function* () {
      let b3 = ge.default.createInstance({ name: "MagicAuthLocalStorageDB", storeName: "MagicAuthLocalStorage" });
      return yield b3.defineDriver(Te2), yield b3.setDriver([ge.default.INDEXEDDB, ge.default.LOCALSTORAGE, Te2._driver]), b3;
    }) });
  }
});

// ../../node_modules/.pnpm/@magic-ext+algorand@23.6.0/node_modules/@magic-ext/algorand/dist/es/index.mjs
var es_exports2 = {};
__export(es_exports2, {
  AlgorandExtension: () => c
});
var a, c;
var init_es5 = __esm({
  "../../node_modules/.pnpm/@magic-ext+algorand@23.6.0/node_modules/@magic-ext/algorand/dist/es/index.mjs"() {
    "use strict";
    init_es3();
    a = (s, e, n) => new Promise((g2, o) => {
      var l = (r) => {
        try {
          i(n.next(r));
        } catch (t) {
          o(t);
        }
      }, u3 = (r) => {
        try {
          i(n.throw(r));
        } catch (t) {
          o(t);
        }
      }, i = (r) => r.done ? g2(r.value) : Promise.resolve(r.value).then(l, u3);
      i((n = n.apply(s, e)).next());
    });
    c = class extends q2.Internal {
      constructor(n) {
        super();
        this.algorandConfig = n;
        this.name = "algod";
        this.config = {};
        this.config = { rpcUrl: n.rpcUrl, chainType: "ALOGD" };
      }
      signTransaction(n) {
        return a(this, null, function* () {
          return this.request(this.utils.createJsonRpcRequestPayload("algod_signTransaction", n));
        });
      }
      signBid(n) {
        return a(this, null, function* () {
          return this.request(this.utils.createJsonRpcRequestPayload("algod_signBid", n));
        });
      }
      getWallet() {
        return a(this, null, function* () {
          return this.request(this.utils.createJsonRpcRequestPayload("algod_getWallet", []));
        });
      }
      signGroupTransaction(n) {
        return a(this, null, function* () {
          return this.request(this.utils.createJsonRpcRequestPayload("algod_signGroupTransaction", n));
        });
      }
      signGroupTransactionV2(n) {
        return a(this, null, function* () {
          return this.request(this.utils.createJsonRpcRequestPayload("algod_signGroupTransactionV2", n));
        });
      }
    };
  }
});

// src/logger.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
  LogLevel2[LogLevel2["INFO"] = 1] = "INFO";
  LogLevel2[LogLevel2["WARN"] = 2] = "WARN";
  LogLevel2[LogLevel2["ERROR"] = 3] = "ERROR";
  return LogLevel2;
})(LogLevel || {});
var Logger = class _Logger {
  static instance = null;
  level;
  isClient;
  constructor() {
    this.level = 2 /* WARN */;
    this.isClient = typeof window !== "undefined";
  }
  static getInstance() {
    if (!_Logger.instance) {
      _Logger.instance = new _Logger();
    }
    return _Logger.instance;
  }
  static setLevel(level) {
    _Logger.getInstance().level = level;
  }
  log(level, scope, message, ...args) {
    if (level >= this.level && this.isClient) {
      const formattedMessage = scope ? `[${scope}] ${message}` : message;
      switch (level) {
        case 0 /* DEBUG */:
        case 1 /* INFO */:
          console.info(formattedMessage, ...args);
          break;
        case 2 /* WARN */:
          console.warn(formattedMessage, ...args);
          break;
        case 3 /* ERROR */:
          console.error(formattedMessage, ...args);
          break;
      }
    }
  }
  createScopedLogger(scope) {
    return {
      debug: (message, ...args) => this.log(0 /* DEBUG */, scope, message, ...args),
      info: (message, ...args) => this.log(1 /* INFO */, scope, message, ...args),
      warn: (message, ...args) => this.log(2 /* WARN */, scope, message, ...args),
      error: (message, ...args) => this.log(3 /* ERROR */, scope, message, ...args)
    };
  }
  debug(message, ...args) {
    this.log(0 /* DEBUG */, void 0, message, ...args);
  }
  info(message, ...args) {
    this.log(1 /* INFO */, void 0, message, ...args);
  }
  warn(message, ...args) {
    this.log(2 /* WARN */, void 0, message, ...args);
  }
  error(message, ...args) {
    this.log(3 /* ERROR */, void 0, message, ...args);
  }
  // For testing purposes
  setIsClient(isClient) {
    this.isClient = isClient;
  }
};
var logger = Logger.getInstance();

// src/manager.ts
import { Store } from "@tanstack/store";
import algosdk12 from "algosdk";

// src/network.ts
var NetworkId = /* @__PURE__ */ ((NetworkId2) => {
  NetworkId2["MAINNET"] = "mainnet";
  NetworkId2["TESTNET"] = "testnet";
  NetworkId2["BETANET"] = "betanet";
  NetworkId2["FNET"] = "fnet";
  NetworkId2["LOCALNET"] = "localnet";
  NetworkId2["VOIMAIN"] = "voimain";
  NetworkId2["ARAMIDMAIN"] = "aramidmain";
  return NetworkId2;
})(NetworkId || {});
function isValidNetworkId(networkId) {
  return Object.values(NetworkId).includes(networkId);
}
function isNetworkConfigMap(config) {
  const networkKeys = Object.values(NetworkId);
  return Object.keys(config).some((key) => networkKeys.includes(key));
}
var nodeServerMap = {
  ["mainnet" /* MAINNET */]: "https://mainnet-api.4160.nodely.dev",
  ["testnet" /* TESTNET */]: "https://testnet-api.4160.nodely.dev",
  ["betanet" /* BETANET */]: "https://betanet-api.4160.nodely.dev",
  ["fnet" /* FNET */]: "https://fnet-api.4160.nodely.dev",
  ["voimain" /* VOIMAIN */]: "https://mainnet-api.voi.nodely.dev",
  ["aramidmain" /* ARAMIDMAIN */]: "https://algod.aramidmain.a-wallet.net"
};
function createDefaultNetworkConfig() {
  const localnetConfig = {
    token: "a".repeat(64),
    baseServer: "http://localhost",
    port: 4001,
    headers: {}
  };
  return Object.values(NetworkId).reduce((configMap, value) => {
    const network = value;
    const isLocalnet = network === "localnet" /* LOCALNET */;
    configMap[network] = isLocalnet ? localnetConfig : {
      token: "",
      baseServer: nodeServerMap[network],
      port: "",
      headers: {}
    };
    return configMap;
  }, {});
}
var caipChainId = {
  ["mainnet" /* MAINNET */]: "algorand:wGHE2Pwdvd7S12BL5FaOP20EGYesN73k",
  ["testnet" /* TESTNET */]: "algorand:SGO1GKSzyE7IEPItTxCByw9x8FmnrCDe",
  ["betanet" /* BETANET */]: "algorand:mFgazF-2uRS1tMiL9dsj01hJGySEmPN2",
  ["fnet" /* FNET */]: "algorand:kUt08LxeVAAGHnh4JoAoAMM9ql_hBwSo",
  ["voimain" /* VOIMAIN */]: "algorand:r20fSQI8gWe_kFZziNonSPCXLwcQmH_n",
  ["aramidmain" /* ARAMIDMAIN */]: "algorand:PgeQVJJgx_LYKJfIEz7dbfNPuXmDyJ-O"
};

// src/storage.ts
var StorageAdapter = class {
  static getItem(key) {
    if (typeof window === "undefined") {
      return null;
    }
    return localStorage.getItem(key);
  }
  static setItem(key, value) {
    if (typeof window === "undefined") {
      return;
    }
    localStorage.setItem(key, value);
  }
  static removeItem(key) {
    if (typeof window === "undefined") {
      return;
    }
    localStorage.removeItem(key);
  }
};

// src/store.ts
import algosdk from "algosdk";

// src/wallets/types.ts
var WalletId = /* @__PURE__ */ ((WalletId2) => {
  WalletId2["BIATEC"] = "biatec";
  WalletId2["DEFLY"] = "defly";
  WalletId2["CUSTOM"] = "custom";
  WalletId2["EXODUS"] = "exodus";
  WalletId2["KIBISIS"] = "kibisis";
  WalletId2["KMD"] = "kmd";
  WalletId2["LUTE"] = "lute";
  WalletId2["MAGIC"] = "magic";
  WalletId2["MNEMONIC"] = "mnemonic";
  WalletId2["PERA"] = "pera";
  WalletId2["PERA2"] = "pera-beta";
  WalletId2["WALLETCONNECT"] = "walletconnect";
  return WalletId2;
})(WalletId || {});
var SignTxnsError = class extends Error {
  code;
  data;
  constructor(message, code, data) {
    super(message);
    this.name = "SignTxnsError";
    this.code = code;
    this.data = data;
  }
};

// src/store.ts
var defaultState = {
  wallets: {},
  activeWallet: null,
  activeNetwork: "testnet" /* TESTNET */,
  algodClient: new algosdk.Algodv2("", "https://testnet-api.4160.nodely.dev/")
};
var LOCAL_STORAGE_KEY = "@txnlab/use-wallet:v3";
function addWallet(store, { walletId, wallet }) {
  store.setState((state) => {
    const updatedWallets = {
      ...state.wallets,
      [walletId]: {
        accounts: wallet.accounts.map((account) => ({ ...account })),
        activeAccount: wallet.activeAccount ? { ...wallet.activeAccount } : null
      }
    };
    return {
      ...state,
      wallets: updatedWallets,
      activeWallet: walletId
    };
  });
}
function removeWallet(store, { walletId }) {
  store.setState((state) => {
    const updatedWallets = { ...state.wallets };
    delete updatedWallets[walletId];
    return {
      ...state,
      wallets: updatedWallets,
      activeWallet: state.activeWallet === walletId ? null : state.activeWallet
    };
  });
}
function setActiveWallet(store, { walletId }) {
  store.setState((state) => ({
    ...state,
    activeWallet: walletId
  }));
}
function setActiveAccount(store, { walletId, address }) {
  store.setState((state) => {
    const wallet = state.wallets[walletId];
    if (!wallet) {
      logger.warn(`Wallet with id "${walletId}" not found`);
      return state;
    }
    const newActiveAccount = wallet.accounts.find((a2) => a2.address === address);
    if (!newActiveAccount) {
      logger.warn(`Account with address ${address} not found in wallet "${walletId}"`);
      return state;
    }
    const updatedWallet = {
      ...wallet,
      accounts: wallet.accounts.map((account) => ({ ...account })),
      activeAccount: { ...newActiveAccount }
    };
    const updatedWallets = {
      ...state.wallets,
      [walletId]: updatedWallet
    };
    return {
      ...state,
      wallets: updatedWallets
    };
  });
}
function setAccounts(store, { walletId, accounts }) {
  store.setState((state) => {
    const wallet = state.wallets[walletId];
    if (!wallet) {
      logger.warn(`Wallet with id "${walletId}" not found`);
      return state;
    }
    const newAccounts = accounts.map((account) => ({ ...account }));
    const isActiveAccountConnected = newAccounts.some(
      (account) => account.address === wallet.activeAccount?.address
    );
    const newActiveAccount = isActiveAccountConnected ? { ...wallet.activeAccount } : newAccounts[0] || null;
    const updatedWallet = {
      ...wallet,
      accounts: newAccounts,
      activeAccount: newActiveAccount
    };
    const updatedWallets = {
      ...state.wallets,
      [walletId]: updatedWallet
    };
    return {
      ...state,
      wallets: updatedWallets
    };
  });
}
function setActiveNetwork(store, { networkId, algodClient }) {
  store.setState((state) => ({
    ...state,
    activeNetwork: networkId,
    algodClient
  }));
}
function isValidWalletId(walletId) {
  return Object.values(WalletId).includes(walletId);
}
function isValidWalletAccount(account) {
  return typeof account === "object" && account !== null && typeof account.name === "string" && typeof account.address === "string";
}
function isValidWalletState(wallet) {
  return typeof wallet === "object" && wallet !== null && Array.isArray(wallet.accounts) && wallet.accounts.every(isValidWalletAccount) && (wallet.activeAccount === null || isValidWalletAccount(wallet.activeAccount));
}
function isValidState(state) {
  if (!state || typeof state !== "object") return false;
  if (typeof state.wallets !== "object") return false;
  for (const [walletId, wallet] of Object.entries(state.wallets)) {
    if (!isValidWalletId(walletId) || !isValidWalletState(wallet)) return false;
  }
  if (state.activeWallet !== null && !isValidWalletId(state.activeWallet)) return false;
  if (!isValidNetworkId(state.activeNetwork)) return false;
  return true;
}

// src/wallets/walletconnect.ts
import algosdk2 from "algosdk";

// src/wallets/base.ts
var BaseWallet = class {
  id;
  metadata;
  store;
  getAlgodClient;
  subscribe;
  logger;
  constructor({
    id,
    metadata,
    store,
    subscribe,
    getAlgodClient
  }) {
    this.id = id;
    this.store = store;
    this.subscribe = subscribe;
    this.getAlgodClient = getAlgodClient;
    const ctor = this.constructor;
    this.metadata = { ...ctor.defaultMetadata, ...metadata };
    this.logger = logger.createScopedLogger(`Wallet:${this.id.toUpperCase()}`);
  }
  static defaultMetadata = { name: "Base Wallet", icon: "" };
  setActive = () => {
    this.logger.info(`Set active wallet: ${this.id}`);
    setActiveWallet(this.store, { walletId: this.id });
  };
  setActiveAccount = (account) => {
    this.logger.info(`Set active account: ${account}`);
    setActiveAccount(this.store, {
      walletId: this.id,
      address: account
    });
  };
  transactionSigner = async (txnGroup, indexesToSign) => {
    const signTxnsResult = await this.signTransactions(txnGroup, indexesToSign);
    const signedTxns = signTxnsResult.reduce((acc, value) => {
      if (value !== null) {
        acc.push(value);
      }
      return acc;
    }, []);
    return signedTxns;
  };
  // ---------- Derived Properties ------------------------------------ //
  get name() {
    return this.id.toUpperCase();
  }
  get accounts() {
    const state = this.store.state;
    const walletState = state.wallets[this.id];
    return walletState ? walletState.accounts : [];
  }
  get addresses() {
    return this.accounts.map((account) => account.address);
  }
  get activeAccount() {
    const state = this.store.state;
    const walletState = state.wallets[this.id];
    return walletState ? walletState.activeAccount : null;
  }
  get activeAddress() {
    return this.activeAccount?.address ?? null;
  }
  get activeNetwork() {
    const state = this.store.state;
    return state.activeNetwork;
  }
  get isConnected() {
    const state = this.store.state;
    const walletState = state.wallets[this.id];
    return walletState ? walletState.accounts.length > 0 : false;
  }
  get isActive() {
    const state = this.store.state;
    return state.activeWallet === this.id;
  }
  // ---------- Protected Methods ------------------------------------- //
  onDisconnect = () => {
    this.logger.debug(`Removing wallet from store...`);
    removeWallet(this.store, { walletId: this.id });
  };
  manageWalletConnectSession = (action, targetWalletId) => {
    const walletId = targetWalletId || this.id;
    if (action === "backup") {
      const data = StorageAdapter.getItem("walletconnect");
      if (data) {
        StorageAdapter.setItem(`walletconnect-${walletId}`, data);
        StorageAdapter.removeItem("walletconnect");
        this.logger.debug(`Backed up WalletConnect session for ${walletId}`);
      }
    } else if (action === "restore") {
      const data = StorageAdapter.getItem(`walletconnect-${walletId}`);
      if (data) {
        StorageAdapter.setItem("walletconnect", data);
        StorageAdapter.removeItem(`walletconnect-${walletId}`);
        this.logger.debug(`Restored WalletConnect session for ${walletId}`);
      }
    }
  };
};

// src/wallets/walletconnect.ts
var SessionError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "SessionError";
  }
};
var ICON = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 480 480" xmlns="http://www.w3.org/2000/svg">
  <rect width="480" height="480" fill="#FFFFFF" />
  <path fill="#3396FF" d="M126.6,168c62.6-61.3,164.2-61.3,226.8,0l7.5,7.4c3.1,3.1,3.1,8,0,11.1l-25.8,25.2c-1.6,1.5-4.1,1.5-5.7,0l-10.4-10.2c-43.7-42.8-114.5-42.8-158.2,0l-11.1,10.9c-1.6,1.5-4.1,1.5-5.7,0l-25.8-25.2c-3.1-3.1-3.1-8,0-11.1L126.6,168zM406.7,220.2l22.9,22.5c3.1,3.1,3.1,8,0,11.1L326.2,355.1c-3.1,3.1-8.2,3.1-11.3,0l-73.4-71.9c-0.8-0.8-2.1-0.8-2.8,0l-73.4,71.9c-3.1,3.1-8.2,3.1-11.3,0L50.3,253.8c-3.1-3.1-3.1-8,0-11.1l22.9-22.5c3.1-3.1,8.2-3.1,11.3,0l73.4,71.9c0.8,0.8,2.1,0.8,2.8,0 l73.4-71.9c3.1-3.1,8.2-3.1,11.3,0l73.4,71.9c0.8,0.8,2.1,0.8,2.8,0l73.4-71.9C398.5,217.1,403.6,217.1,406.7,220.2L406.7,220.2z" />
</svg>
`)}`;
var WalletConnect = class extends BaseWallet {
  client = null;
  options;
  modal = null;
  modalOptions;
  session = null;
  store;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    options,
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    if (!options?.projectId) {
      this.logger.error("Missing required option: projectId");
      throw new Error("Missing required option: projectId");
    }
    const {
      projectId,
      relayUrl = "wss://relay.walletconnect.com",
      metadata: metadataOptions,
      ...modalOptions
    } = options;
    const clientMetadata = {
      ...this.getWindowMetadata(),
      ...metadataOptions
    };
    this.options = {
      projectId,
      relayUrl,
      metadata: clientMetadata
    };
    this.modalOptions = modalOptions;
    this.store = store;
  }
  static defaultMetadata = {
    name: "WalletConnect",
    icon: ICON
  };
  /**
   * Get metadata from the current window. This is adapted from the @walletconnect/utils
   * implementation, to avoid requiring the entire package as a dependency.
   * @see https://github.com/WalletConnect/walletconnect-utils/blob/master/browser/window-metadata/src/index.ts
   */
  getWindowMetadata() {
    let doc;
    let loc;
    const defaultMetadata = {
      name: "",
      description: "",
      url: "",
      icons: []
    };
    function getFromWindow(name2) {
      let res;
      if (typeof window !== "undefined" && typeof window[name2] !== "undefined") {
        res = window[name2];
      }
      return res;
    }
    function getFromWindowOrThrow(name2) {
      const res = getFromWindow(name2);
      if (!res) {
        throw new Error(`${name2} is not defined in Window`);
      }
      return res;
    }
    function getDocumentOrThrow() {
      return getFromWindowOrThrow("document");
    }
    function getLocationOrThrow() {
      return getFromWindowOrThrow("location");
    }
    try {
      doc = getDocumentOrThrow();
      loc = getLocationOrThrow();
    } catch (error) {
      this.logger.warn("Error getting window metadata:", error);
      return defaultMetadata;
    }
    function getIcons() {
      const links = doc.getElementsByTagName("link");
      const icons2 = [];
      for (let i = 0; i < links.length; i++) {
        const link = links[i];
        const rel = link.getAttribute("rel");
        if (rel) {
          if (rel.toLowerCase().indexOf("icon") > -1) {
            const href = link.getAttribute("href");
            if (href) {
              if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                let absoluteHref = loc.protocol + "//" + loc.host;
                if (href.indexOf("/") === 0) {
                  absoluteHref += href;
                } else {
                  const path = loc.pathname.split("/");
                  path.pop();
                  const finalPath = path.join("/");
                  absoluteHref += finalPath + "/" + href;
                }
                icons2.push(absoluteHref);
              } else if (href.indexOf("//") === 0) {
                const absoluteUrl = loc.protocol + href;
                icons2.push(absoluteUrl);
              } else {
                icons2.push(href);
              }
            }
          }
        }
      }
      return icons2;
    }
    function getWindowMetadataOfAny(...args) {
      const metaTags = doc.getElementsByTagName("meta");
      for (let i = 0; i < metaTags.length; i++) {
        const tag = metaTags[i];
        const attributes = ["itemprop", "property", "name"].map((target) => tag.getAttribute(target)).filter((attr) => {
          if (attr) {
            return args.includes(attr);
          }
          return false;
        });
        if (attributes.length && attributes) {
          const content = tag.getAttribute("content");
          if (content) {
            return content;
          }
        }
      }
      return "";
    }
    function getName() {
      let name2 = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
      if (!name2) {
        name2 = doc.title;
      }
      return name2;
    }
    function getDescription() {
      const description2 = getWindowMetadataOfAny(
        "description",
        "og:description",
        "twitter:description",
        "keywords"
      );
      return description2;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
      description,
      url,
      icons,
      name
    };
    return meta;
  }
  async initializeClient() {
    this.logger.info("Initializing client...");
    const SignClient = (await import("@walletconnect/sign-client")).SignClient;
    const client = await SignClient.init(this.options);
    client.on("session_event", (args) => {
      this.logger.info("EVENT: session_event", args);
    });
    client.on("session_update", ({ topic, params }) => {
      this.logger.info("EVENT: session_update", { topic, params });
      const { namespaces } = params;
      const session = client.session.get(topic);
      const updatedSession = { ...session, namespaces };
      this.onSessionConnected(updatedSession);
    });
    client.on("session_delete", () => {
      this.logger.info("EVENT: session_delete");
      this.session = null;
    });
    this.client = client;
    this.logger.info("Client initialized");
    return client;
  }
  async initializeModal() {
    this.logger.info("Initializing modal...");
    const WalletConnectModal = (await import("@walletconnect/modal")).WalletConnectModal;
    const modal = new WalletConnectModal({
      projectId: this.options.projectId,
      ...this.modalOptions
    });
    modal.subscribeModal((state) => this.logger.info(`Modal ${state.open ? "open" : "closed"}`));
    this.modal = modal;
    this.logger.info("Modal initialized");
    return modal;
  }
  onSessionConnected(session) {
    const caipAccounts = session.namespaces.algorand.accounts;
    if (!caipAccounts.length) {
      this.logger.error("No accounts found!");
      throw new Error("No accounts found!");
    }
    const accounts = [...new Set(caipAccounts.map((account) => account.split(":").pop()))];
    const walletAccounts = accounts.map((address, idx) => ({
      name: `${this.metadata.name} Account ${idx + 1}`,
      address
    }));
    const state = this.store.state;
    const walletState = state.wallets[this.id];
    if (!walletState) {
      const newWalletState = {
        accounts: walletAccounts,
        activeAccount: walletAccounts[0]
      };
      addWallet(this.store, {
        walletId: this.id,
        wallet: newWalletState
      });
      this.logger.info("Connected", newWalletState);
    } else {
      const match = compareAccounts(walletAccounts, walletState.accounts);
      if (!match) {
        this.logger.warn("Session accounts mismatch, updating accounts", {
          prev: walletState.accounts,
          current: walletAccounts
        });
        setAccounts(this.store, {
          walletId: this.id,
          accounts: walletAccounts
        });
      }
    }
    this.session = session;
    return walletAccounts;
  }
  get activeChainId() {
    const chainId = caipChainId[this.activeNetwork];
    if (!chainId) {
      this.logger.warn(`No CAIP-2 chain ID found for network: ${this.activeNetwork}`);
      return "";
    }
    return chainId;
  }
  connect = async () => {
    this.logger.info("Connecting...");
    try {
      const client = this.client || await this.initializeClient();
      const modal = this.modal || await this.initializeModal();
      const requiredNamespaces = {
        algorand: {
          chains: [this.activeChainId],
          methods: ["algo_signTxn"],
          events: []
        }
      };
      const { uri, approval } = await client.connect({ requiredNamespaces });
      if (!uri) {
        this.logger.error("No URI found");
        throw new Error("No URI found");
      }
      await modal.openModal({ uri });
      const session = await approval();
      const walletAccounts = this.onSessionConnected(session);
      this.logger.info("Connected successfully");
      return walletAccounts;
    } catch (error) {
      this.logger.error("Error connecting:", error.message);
      throw error;
    } finally {
      this.modal?.closeModal();
    }
  };
  disconnect = async () => {
    this.logger.info("Disconnecting...");
    try {
      this.onDisconnect();
      if (this.client && this.session) {
        await this.client.disconnect({
          topic: this.session.topic,
          reason: {
            message: "User disconnected.",
            code: 6e3
          }
        });
      }
      this.logger.info("Disconnected");
    } catch (error) {
      this.logger.error("Error disconnecting:", error.message);
      throw error;
    }
  };
  resumeSession = async () => {
    try {
      const state = this.store.state;
      const walletState = state.wallets[this.id];
      if (!walletState) {
        this.logger.info("No session to resume");
        return;
      }
      this.logger.info("Resuming session...");
      const client = this.client || await this.initializeClient();
      if (client.session.length) {
        const lastKeyIndex = client.session.keys.length - 1;
        const restoredSession = client.session.get(client.session.keys[lastKeyIndex]);
        this.onSessionConnected(restoredSession);
      }
      this.logger.info("Session resumed successfully");
    } catch (error) {
      this.logger.error("Error resuming session:", error.message);
      this.onDisconnect();
      throw error;
    }
  };
  processTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txn, index) => {
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk2.encodeAddress(txn.from.publicKey);
      const canSignTxn = this.addresses.includes(signer);
      const txnString = byteArrayToBase64(txn.toByte());
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn: txnString });
      } else {
        txnsToSign.push({ txn: txnString, signers: [] });
      }
    });
    return txnsToSign;
  }
  processEncodedTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txnBuffer, index) => {
      const txnDecodeObj = algosdk2.decodeObj(txnBuffer);
      const isSigned = isSignedTxn(txnDecodeObj);
      const txn = isSigned ? algosdk2.decodeSignedTransaction(txnBuffer).txn : algosdk2.decodeUnsignedTransaction(txnBuffer);
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk2.encodeAddress(txn.from.publicKey);
      const canSignTxn = !isSigned && this.addresses.includes(signer);
      const txnString = byteArrayToBase64(txn.toByte());
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn: txnString });
      } else {
        txnsToSign.push({ txn: txnString, signers: [] });
      }
    });
    return txnsToSign;
  }
  signTransactions = async (txnGroup, indexesToSign) => {
    try {
      if (!this.session) {
        this.logger.error("No session found!");
        throw new SessionError("No session found!");
      }
      this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
      let txnsToSign = [];
      if (isTransactionArray(txnGroup)) {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processTxns(flatTxns, indexesToSign);
      } else {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processEncodedTxns(flatTxns, indexesToSign);
      }
      const client = this.client || await this.initializeClient();
      this.logger.debug("Sending processed transactions to wallet...", [txnsToSign]);
      const request = formatJsonRpcRequest("algo_signTxn", [txnsToSign]);
      const signTxnsResult = await client.request({
        chainId: this.activeChainId,
        topic: this.session.topic,
        request
      });
      this.logger.debug("Received signed transactions from wallet", signTxnsResult);
      const signedTxns = signTxnsResult.reduce((acc, value) => {
        if (value) {
          let signedTxn;
          if (typeof value === "string") {
            signedTxn = base64ToByteArray(value);
          } else if (value instanceof Uint8Array) {
            signedTxn = value;
          } else if (Array.isArray(value)) {
            signedTxn = new Uint8Array(value);
          } else {
            this.logger.warn("Unexpected type in signTxnsResult", value);
            signedTxn = new Uint8Array();
          }
          acc.push(signedTxn);
        }
        return acc;
      }, []);
      const result = txnsToSign.reduce((acc, txn) => {
        if (txn.signers && txn.signers.length == 0) {
          acc.push(null);
        } else {
          const signedTxn = signedTxns.shift();
          if (signedTxn) {
            acc.push(signedTxn);
          }
        }
        return acc;
      }, []);
      this.logger.debug("Transactions signed successfully", result);
      return result;
    } catch (error) {
      this.logger.error("Error signing transactions:", error.message);
      throw error;
    }
  };
};

// src/wallets/biatec.ts
var ICON2 = `data:image/svg+xml;base64,${btoa(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 180"><path d="M94.27 151.629c-.861-.526-1.51-1.37-1.83-2.386-.197-.62-.18-.627 1.082-.437.705.105 1.6.356 1.988.557.696.36 1.815 1.876 1.815 2.459 0 .486-2.166.348-3.054-.193m23.953-.263c-.788-.419-2.095-2.123-2.108-2.75-.01-.433 2.467-.182 3.403.345.955.536 2.148 1.97 2.148 2.582 0 .503-2.397.38-3.443-.177m-9.024-1.165c-1.567-1.193-2.38-2.74-2.55-4.849-.075-.933-.054-1.697.045-1.697.866 0 2.714 1.67 3.439 3.107.398.789.657 3.888.351 4.195-.07.07-.648-.27-1.285-.756m-8.906-1.354c-.63-.684-1.21-1.648-1.387-2.305-.318-1.18-.136-3.416.278-3.416.555 0 2.108 1.697 2.505 2.737.472 1.237.457 3.905-.023 4.063-.16.053-.777-.433-1.373-1.08m-6.805-1.775c-2.764-.612-5.223-1.425-5.357-1.772-.08-.21.169-1.027.555-1.814s.701-1.469.701-1.515c0-.047-.803.067-1.786.253-.982.185-1.857.256-1.944.157-.088-.1-.365-.715-.618-1.367-.252-.652-.858-1.729-1.345-2.393-1.293-1.76-5.285-5.526-7.272-6.858-3.826-2.564-4.96-3.855-4.667-5.316.08-.402.692-1.574 1.359-2.606 1.65-2.551 2.51-4.472 2.512-5.62.002-.571-.364-1.69-.901-2.758l-.905-1.796.706-.532c1.936-1.46 4.649-4.916 4.205-5.36-.06-.06-.846.72-1.745 1.732-3.553 3.997-7.814 6.463-16.014 9.27-5.324 1.823-5.853 2.06-7.183 3.228-1.555 1.365-1.962 2.502-2.531 7.063-.284 2.275-.706 4.79-.937 5.591-.231.8-.403 2.17-.382 3.043.032 1.346-.157 2.06-1.248 4.698-1.498 3.622-1.068 3.708-4.138-.827l-2.036-3.008.747-.784c.411-.43 1.075-.978 1.475-1.216.955-.568.919-.922-.236-2.331-.53-.647-.917-1.209-.86-1.25s.43-.277.83-.526c1.788-1.12 2.7-4.727 2.987-11.822.214-5.274.595-6.46 2.195-6.83 6.634-1.535 7.58-1.98 8.618-4.066.926-1.858.9-3.701-.121-8.475-.87-4.072-1.047-7.21-.516-9.223.606-2.303 3.759-7.433 5.667-9.221.376-.353.684-.729.684-.835 0-.254-3.325-2.697-4.448-3.268-.482-.245-1.455-.45-2.163-.456-3.892-.03-6.628 1.877-8.722 6.08-.603 1.212-1.582 2.73-2.176 3.374-2.733 2.965-8.602 4.09-12.666 2.43l-.913-.374 1.323-.05c1.422-.054 3.498-.94 3.944-1.683.414-.69.076-.79-1.06-.314-1.443.605-4.075.597-5.039-.015-1.259-.8-2.23-1.81-2.795-2.908l-.535-1.042 1.243 1.095c1.51 1.328 2.691 1.752 4.425 1.585 1.506-.145 2.523-.851 1.65-1.147-3.195-1.08-5.834-3.078-7.07-5.35-.809-1.485-1.513-3.982-1.504-5.334l.006-.936.42.854c.232.47.941 1.333 1.576 1.918l1.155 1.064 2.189-.012 2.188-.011-1.012-.535c-.975-.514-3.353-2.766-3.353-3.175 0-.11.506.079 1.124.418 1.282.703 3.888 1.32 4.21.996.12-.118-.204-.612-.718-1.097-.513-.484-1.17-1.344-1.46-1.911l-.525-1.03 1.174.895c2.02 1.542 3.883 1.506 6.342-.123.69-.457 1.218-.863 1.175-.903s-.989.227-2.103.594c-1.87.618-2.11.64-3.151.305-1.284-.415-2.023-1.273-2.25-2.613l-.158-.926.486.595c1.07 1.31 2.652 1.255 6.363-.224 1.132-.451 2.892-1.036 3.91-1.3 2.732-.706 1.561-.926-2.298-.43-1.778.228-3.27.376-3.318.329-.047-.047.662-.415 1.575-.818 2.002-.883 4.78-1.152 6.858-.663 1.817.427 2.555.81 4.032 2.087 1.151.997 3.654 2.156 4.605 2.133.595-.015-2.96-3.395-4.552-4.328-1.639-.96-4.11-1.542-6.107-1.438-.92.049-1.627.016-1.571-.073.242-.388 3.44-.825 5.203-.71 4.048.265 6.96 2.546 10.902 8.537 2.553 3.883 4.234 5.67 6.137 6.524l1.092.49 2.215-1.027c4.747-2.2 8.797-2.518 16.097-1.26 2.25.387 4.717.704 5.482.704h1.39l.074 3.203.074 3.203.894-1.113c.88-1.096.894-1.152.846-3.516l-.049-2.402-1.61-1.721c-4.14-4.425-4.335-6.536-1.135-12.213 2.744-4.87 2.704-4.41.813-9.32-.883-2.292-1.696-4.167-1.807-4.167-.339 0-.205 4 .196 5.821.716 3.256.435 4.822-1.006 5.603-.371.2-2.144.33-4.904.36-3.6.036-4.348-.022-4.473-.348-.087-.227.102-.582.451-.845.53-.4.563-.53.274-1.09-.18-.35-.692-1.022-1.137-1.493s-.734-.933-.64-1.026c.093-.094 1.072-.036 2.175.128 3.023.45 3.76.398 4.211-.297.4-.615 2.887-9.725 2.704-9.907-.196-.196-1.55 1.62-2.759 3.7-1.782 3.068-3.14 3.895-6.379 3.889-2.485-.005-5.43-1.098-8.658-3.213-1.439-.943-3.02-1.855-3.514-2.027-1.524-.531-3.75-.392-5.163.324l-1.26.638.567-.603c.892-.95 3.048-2.004 4.432-2.167 1.94-.23 3.3.283 5.786 2.18 2.39 1.823 3.163 2.225 4.28 2.225.6 0 .497-.12-.745-.872-.792-.48-2.416-1.598-3.609-2.486-2.658-1.978-4.119-2.58-5.831-2.4l-1.26.132.926-.39c.667-.281 1.609-.36 3.373-.284 1.346.059 2.448.077 2.448.04 0-.278-2.537-1.455-3.71-1.722-.89-.202-1.231-.365-.884-.421.312-.051 1.86.225 3.44.614 2.564.63 3.167.687 5.602.525 5.536-.369 7.032-1.144 9.218-4.774l1.433-2.382-1.224 1.323c-.673.728-1.779 1.928-2.457 2.666-.677.739-1.53 1.417-1.893 1.508l-.662.165.61-.503c.334-.277 1.088-1.491 1.675-2.698 1.772-3.648 3.228-4.779 6.772-5.257 3.522-.476 4.797-.791 5.421-1.342.332-.293.429-.44.215-.329-.213.112-1.94.277-3.836.367-2.955.14-3.666.263-4.97.86-1.632.749-4.092 2.893-4.996 4.356-.764 1.236-.923.905-.224-.465 1.387-2.718 4.685-4.945 8.366-5.651l1.815-.349-1.058-.235c-.582-.13-1.952-.224-3.043-.209l-1.984.027 1.72-.82c1.427-.682 2.04-.822 3.611-.822 1.607 0 1.86-.06 1.679-.4-.539-1.005-1.377-1.452-2.69-1.432-.769.011-1.156-.067-.937-.19.534-.298 2.168-.34 4.169-.104 1.648.194 1.82.159 3.59-.733 1.023-.515 2.472-1.047 3.22-1.183 1.388-.253 3.607-.04 4.472.429.942.51 1.958 1.825 2.095 2.712.116.746 0 1.052-.671 1.777-.752.813-.811 1.018-.811 2.82 0 1.706-.105 2.127-.85 3.424-.467.814-.973 1.476-1.124 1.473s-.797-.242-1.435-.532c-1.277-.579-1.714-.435-1.988.655-.115.46.045.84.605 1.44.42.448 1.621 2.237 2.671 3.975 1.883 3.116 1.905 3.175 1.585 4.146-.258.78-.258 1.56 0 3.73.179 1.51.253 3.031.166 3.38-.128.509.033.795.805 1.432 1.367 1.126 5.02 2.947 5.914 2.947 1.268 0 1.588.247 1.588 1.227 0 1.057-.642 2.742-1.045 2.742-.153 0-.278-.298-.278-.662 0-.558-.123-.661-.793-.661-.436 0-2.162-.467-3.836-1.036l-3.044-1.036v1.788c0 .984-.077 3.057-.172 4.608l-.173 2.82h3.015l-.133.86c-.073.472-.206 2.11-.295 3.637-.373 6.42-.634 7.203-4.207 12.65-4.119 6.278-4.635 7.984-3.493 11.548.37 1.158.647 2.133.613 2.167-.246.246-2.569-1.19-3.783-2.34-2.616-2.473-2.922-3.975-1.146-5.619.954-.882 1.054-1.087.892-1.828-.417-1.91-.553-1.976-1-.482-.232.777-.693 1.849-1.024 2.382-.526.846-.603 1.318-.603 3.705v2.736l3.175 1.022c1.746.562 3.446 1.028 3.777 1.034.583.012.59-.012.194-.776-.224-.434-.479-1.307-.566-1.939-.208-1.523.53-3.065 3.905-8.159 4.537-6.845 5.478-9.25 5.681-14.513.07-1.82.19-3.93.267-4.692.137-1.353.17-1.398 1.379-1.933 2.27-1.004 4.245-3.717 6.253-8.589.526-1.274.459-1.204-1.891 1.985-1.019 1.382-2.13 2.751-2.47 3.042-.604.516-.603.506.048-.397.938-1.299 1.216-2.144 1.685-5.107.663-4.193 1.699-6.255 4.604-9.16 3.639-3.638 9.47-6.348 13.7-6.365.635-.003 1.201-.155 1.322-.356.117-.192 1.105-.92 2.196-1.615 1.092-.696 2.252-1.511 2.579-1.812.327-.3.66-.48.74-.4.081.081-.038.942-.263 1.914s-.41 1.88-.41 2.016c0 .37 1.393.3 1.992-.102.287-.192 1.296-.62 2.241-.953s1.998-.78 2.338-.994c.34-.215.665-.345.722-.288.302.302-1.982 3.526-2.927 4.132l-1.152.74c-.277.179 1.202 3.732 1.975 4.745.674.882.862 1.347.742 1.825-.089.354.045 1.273.296 2.044.645 1.98 2.913 6.751 3.698 7.779.808 1.06.82 1.416.075 2.363-.32.408-.648 1.225-.728 1.816-.118.879-.279 1.12-.89 1.335-1.457.512-2.298-.449-2.94-3.358-.113-.512-.325-.728-.715-.728-.634 0-.619.099.398 2.514.368.873.572 1.685.453 1.804-.12.119-.679.178-1.244.132-1.006-.082-1.03-.108-1.165-1.29-.11-.958-.407-1.515-1.444-2.716-1.28-1.483-1.523-1.617-3.974-2.186-.436-.102-1.235-.406-1.776-.677l-.981-.491-.311 1.124c-.462 1.668-.381 7.592.14 10.35.244 1.29.926 3.552 1.516 5.027 1.864 4.655 1.933 4.98 1.924 9.031-.006 2.853-.112 3.972-.461 4.87-.25.641-.415 1.204-.367 1.252.047.047 2.935.203 6.419.347 4.2.174 6.786.397 7.679.664 1.433.429 2.955 1.341 3.328 1.995.125.219 1.292 3.718 2.594 7.777 2.56 7.978 2.515 7.613 1.142 9.263-.582.7-.623.918-.458 2.455l.18 1.686-1.685 1.59c-2.476 2.335-2.487 2.338-2.833.702l-.825-3.894c-.497-2.344-.503-2.535-.09-2.844.245-.182.75-.332 1.121-.335 1.259-.007 1.444-.36.672-1.277l-.7-.833.461-1.209c.403-1.054.421-1.428.146-2.924-.856-4.647-3.463-7.755-6.516-7.769-1.198-.006-5.626.726-6.143 1.015-.419.235 1.36 2.035 4.026 4.073 1.954 1.494 2.487 2.265 2.708 3.918.115.858-.031 1.278-.963 2.753-1.122 1.776-2.596 4.941-4.015 8.62-.437 1.133-1.048 2.383-1.358 2.777-.546.695-.623.712-2.434.544-1.51-.14-2.034-.085-2.726.287-.933.503-1.032.488-5.234-.754l-1.852-.547 1.058-.93c2.452-2.155 4.96-4.035 5.375-4.028.245.004.743.417 1.107.919.364.5.74.914.835.918.336.014 2.673-2.777 3.423-4.09.928-1.622 1.429-3.721 1.19-4.992-.414-2.208-2.105-3.2-8.836-5.183-4.604-1.356-5.44-1.637-6.837-2.3-.81-.384-.92-.36-3.047.664-2.593 1.248-5.507 2.251-8.665 2.983-3.304.766-9.686.95-12.988.376-3.227-.562-7.639-2.035-9.626-3.214-.856-.508-1.618-.862-1.693-.787-.15.15 1.12 2.079 1.665 2.53.271.226.239.732-.166 2.586-1.245 5.713-2.66 8.612-7.189 14.73-2.852 3.852-3.402 5.685-2.327 7.762.66 1.274 9.278 9.763 11.016 10.85.797.498 1.576 1.26 1.929 1.889.496.883 2.158 5.275 2.158 5.704 0 .2-1.577.111-2.779-.154m46.76-1.68c-2.98-1.107-5.348-3.111-7.054-5.97-1.025-1.72-2.16-4.428-1.946-4.643.229-.229 3.039.644 4.916 1.527 3.417 1.608 6.275 5.198 6.594 8.283.178 1.723.063 1.76-2.51.803m-70.399.107c-2.923-.4-6.887-2.043-7.56-3.132-.23-.371 1.693-1.772 3.683-2.683 4.119-1.887 9.22-1.779 13.075.277 1.637.873 4.347 2.943 4.307 3.29-.014.122-.895.499-1.957.837-4.06 1.29-8.482 1.831-11.548 1.411m51.264-1.55c-1.687-.66-3.315-1.831-4.87-3.503l-1.323-1.421 2.116-.183c3.467-.298 6.424.354 8.757 1.932 1.096.742 2.753 2.456 2.753 2.848 0 .859-5.46 1.099-7.433.326m38.521-1.26c-3.84-.798-6.966-2.331-9.705-4.761-2.156-1.913-3.179-2.512-5.08-2.978-1.478-.362-3.339-1.249-3.339-1.591 0-.318 2.824-.81 5.689-.991 7.046-.446 13.549 2.741 16.133 7.908.513 1.024.932 2.025.932 2.224 0 .277-.479.354-2.05.33-1.128-.016-2.289-.08-2.58-.14m-61.217-2.076c-1.35-.421-2.52-1.449-3.238-2.845l-.51-.992h1.178c1.479 0 2.46.365 3.42 1.273.65.615 1.762 2.392 1.762 2.817 0 .255-1.426.117-2.612-.253m5.45-1.504c-1.583-1.153-2.396-3.509-1.878-5.442.192-.715.563-.742 1.334-.098 1.18.986 1.673 2.177 1.674 4.051 0 .974-.09 1.826-.2 1.895-.112.068-.53-.114-.93-.406m-26.254-1.075a150 150 0 0 0-3.968-1.97l-2.382-1.138 1.21-.001c2.527-.002 4.928 1.203 6.339 3.185.306.43.52.777.473.77-.046-.007-.799-.388-1.672-.845zm-14.354-3.608c-.764-.264-1.631-.699-1.927-.966-.59-.534-1.695-2.22-1.542-2.352.053-.045.573-.192 1.155-.325 1.324-.303 1.45-.925.662-3.265-.306-.908-.503-1.705-.438-1.77.066-.066.637.018 1.27.187.95.253 1.683.849 4.194 3.411 2.483 2.534 3.286 3.19 4.366 3.566.727.253 1.62.587 1.984.742l.662.28-.662.199c-.779.234-6.102.794-7.42.782-.503-.005-1.54-.225-2.304-.489m104.313-.83c-1.528-.484-4.719-2.704-4.75-3.303-.006-.145.88-.42 1.972-.61 2.368-.414 4.676-.11 6.582.864 1.41.721 3.082 2.35 2.83 2.756-.55.891-4.237 1.054-6.634.294m-56.58-.117c-2.06-.734-3.35-2.65-3.345-4.961.006-2.304.15-2.574 1.279-2.397 1.516.239 3.013.83 3.677 1.455l.609.572 1.523-1.507c.838-.829 1.593-1.507 1.679-1.507.085 0 .362.735.614 1.633.94 3.35-.383 5.974-3.431 6.806-1.302.356-1.35.354-2.605-.094m-75.315-.698c-6.533-.942-11.018-2.967-14.552-6.571-1.972-2.01-3.175-3.81-2.8-4.186.109-.109 1.32-.239 2.693-.29 5.235-.192 9.266 1.449 13.22 5.381 2.097 2.085 5.101 5.853 4.838 6.068-.05.041-1.58-.14-3.4-.402m97.327-1.25c4.267-5.096 8.959-7.442 13.334-6.666.982.174 1.84.405 1.906.513.198.32-1.54 2.713-2.834 3.904-2.314 2.13-5.42 3.148-10.492 3.438l-3.055.175zm17.502-.559c0-.646 1.702-5.318 2.447-6.715 1.472-2.762 4.84-5.965 5.538-5.267.161.161.234 1.18.176 2.481-.114 2.603-.705 4.023-2.51 6.03-1.524 1.695-5.651 4.23-5.651 3.471m8.04-1.157c3.728-2.356 7.725-5.133 8.864-6.158 1.353-1.218 1.403-1.24.984-.43-1.093 2.113-4.85 5.104-7.93 6.31-1.734.68-2.798.834-1.919.278m2.457-4.828c-.243-.511-.443-1.383-.443-1.937 0-1.018.973-3.223 1.5-3.399.368-.123 1.146 1.814 1.146 2.853 0 .855-.78 2.6-1.39 3.105-.298.247-.456.127-.813-.622m11.343.373c-1.157-.135-2.15-.292-2.206-.348-.16-.16 1.966-2.017 3.71-3.24 2.387-1.673 4.54-2.317 7.745-2.316 2.182 0 2.874.104 3.949.596l1.303.595-.907.936c-2.935 3.03-7.986 4.433-13.594 3.777m-135.543-5.98c-3.17-5.953-3.802-11.809-1.769-16.407.766-1.73 2.408-4.033 2.878-4.033.185 0 .7.685 1.142 1.522 2.02 3.82 2.643 8.569 1.708 13.03-.515 2.454-2.383 7.938-2.705 7.938-.089 0-.653-.923-1.254-2.05m131.543-.026c-2.11-1.55-3.023-3.093-3.023-5.108 0-1.215.77-3.056 1.587-3.796.494-.447.574-.438 1.965.243 1.713.838 2.676 1.892 3.072 3.363.464 1.725-.257 3.872-1.791 5.328l-.771.733zm-142.341-2.392c-.955-.434-3.028-2.462-3.028-2.963 0-.106.589-.273 1.309-.372 2.032-.28 3.923.381 5.269 1.84.602.654 1.095 1.295 1.095 1.426 0 .289-1.308.57-2.613.562-.527-.003-1.442-.225-2.032-.493m134.927-3.139c1.218-3.954 1.471-13.59.477-18.203a57 57 0 0 0-1.472-5.291c-1.025-3-1.187-3.508-1.031-3.229.06.11.227.199.369.199s.185-.12.095-.265-.099-.265-.019-.265c.285 0 2.284 4.27 2.94 6.28.942 2.884 1.488 6.584 1.481 10.037-.008 4.205-.63 7.156-2.126 10.088-.577 1.13-.974 1.491-.714.65m15.622-.53c.096-.4.694-1.798 1.33-3.108 1.78-3.673 4.396-6.043 7.61-6.899 2.261-.602 2.412-.555 2.244.699-.39 2.903-3.348 6.413-6.971 8.27-.455.233-1.63.726-2.608 1.094l-1.78.67zm-150.592-3.621c-5.551-2.683-8.865-5.295-11.436-9.013-2.092-3.028-3.72-7.066-3.72-9.231 0-.636.089-.69 1.135-.69 2.913 0 6.796 1.74 9.585 4.296 3.283 3.008 5.033 6.073 6.587 11.534 1.15 4.043 1.263 4.544 1.02 4.54-.111 0-1.539-.647-3.17-1.436m145.075.485c-.092-.241-.309-1.552-.48-2.914-.562-4.443.43-8.183 2.772-10.456.58-.562 1.164-1.022 1.3-1.022.405 0 1.01 1.75 1.186 3.43.324 3.1-.9 6.63-3.421 9.872-.926 1.19-1.226 1.431-1.357 1.09m-6.353-7.675c.34-1.413.908-2.21 1.957-2.745 1.55-.792 1.96-.718 1.754.314-.326 1.628-1.397 2.695-3.034 3.022-.84.168-.856.154-.677-.591m18.432-2.084c-.473-.206-.857-.469-.854-.585.01-.368 1.945-1.592 2.816-1.781.461-.1 1.34-.047 1.952.118l1.114.3-.882.909c-.764.789-2.17 1.45-3.022 1.422-.145-.005-.651-.178-1.124-.383m-4.19-2.014c.437-5.243 1.85-8.992 4.434-11.754 1.589-1.698 4.011-3.172 5.51-3.353.608-.073.669.016.745 1.087.125 1.742-.655 4.812-1.81 7.117-1.233 2.466-3.244 4.75-6.16 7-3.185 2.457-2.932 2.466-2.719-.097M164.535 96.2c.011-.601.996-2.432 1.613-2.997.74-.68 1.86-1.142 2.764-1.142.74 0 .783.213.287 1.402-.328.784-2.05 2.558-2.496 2.573-.105.004-.636.11-1.182.237-.703.163-.99.142-.986-.073M39.38 92.511l-1.19-.287 1.894-.184c2.429-.237 4.211-.836 5.755-1.933 1.705-1.212 2.43-2.3 3.187-4.777.358-1.173 1.027-2.644 1.487-3.27.855-1.16 1.328-1.354.772-.315-.17.317-.42 1.753-.555 3.191s-.371 2.944-.524 3.347c-1.29 3.39-6.255 5.33-10.826 4.228m132.353-3.022c-1.37-3.004-1.722-4.62-1.596-7.322.12-2.584.663-4.209 1.984-5.941l.698-.915.593.689c1.538 1.787 2.37 6.366 1.72 9.457-.375 1.79-1.903 5.61-2.293 5.734-.158.05-.656-.715-1.106-1.702m6.655.323c.094-.582.245-3.618.336-6.747.16-5.514-.097-11.175-.726-16.007-.66-5.078-2.584-11.438-4.788-15.834-.572-1.142-.914-1.998-.76-1.903.154.096.28.02.28-.17 0-.608 1.905 2.465 3.056 4.93 3.19 6.83 5.492 18.482 5.039 25.5-.219 3.379-.79 6.78-1.52 9.04-.672 2.084-1.164 2.722-.917 1.191m-5.129-39.936c0-.065-.119-.19-.264-.28s-.265-.038-.265.116.12.28.265.28.264-.052.264-.116M21.39 87.46c-6.885-6.262-9.634-10.983-10.312-17.71-.218-2.153.098-6.211.514-6.628.377-.377 2.86.757 4.714 2.153 4.287 3.228 7.128 8.67 7.976 15.276.349 2.717.746 9.923.547 9.92-.073-.001-1.62-1.356-3.44-3.01m141.818 1.495c.002-1.223.51-2.654 1.254-3.539.681-.81 2.635-1.902 2.999-1.677.248.154-.193 2.347-.65 3.224-.523 1.007-1.444 1.82-2.616 2.31l-.989.413zm19.715-9.65c.101-.48.414-1.25.694-1.712.53-.872 2.361-1.937 3.331-1.937.515 0 .537.075.29.992-.432 1.599-1.891 2.901-3.749 3.347-.733.176-.746.16-.566-.69m-1.078-4.864c-.434-3.474.426-7.949 2.004-10.427.992-1.557 3.308-3.704 3.996-3.704.79 0 1.023 5.098.34 7.427-.775 2.639-3.22 6.102-5.41 7.661l-.744.53zM27.106 70.74c-.83-2.163.852-9.285 3.442-14.577 3.414-6.977 9.876-14.173 15.518-17.28 1.338-.736 1.306-.696-.732.921-3.554 2.82-6.93 6.51-9.617 10.514-2.78 4.142-4.184 7.582-5.825 14.274-.593 2.419-1.273 4.885-1.512 5.482-.446 1.116-.991 1.401-1.274.666m148.415-4.429c-3.31-1.775-5.714-4.87-6.05-7.787-.123-1.073-.097-1.124.573-1.122 1.742.006 4.537 2.38 5.833 4.954.468.928 1.437 4.572 1.263 4.746-.028.028-.757-.328-1.62-.79M24.465 63.817c-1.392-2.767-2.046-5.175-2.208-8.138-.16-2.924.292-6.48.823-6.48.632 0 2.73 1.536 3.654 2.676 1.65 2.036 2.173 3.325 2.185 5.393.01 1.729-.094 2.069-1.554 5.094-.86 1.782-1.663 3.24-1.783 3.24s-.623-.803-1.117-1.785m155.049-4.47c-.602-3.045-.356-5.571.757-7.767.795-1.57 2.708-3.351 3.137-2.921.187.187.302 1.33.302 3 0 2.617-.03 2.756-1.001 4.573-.551 1.03-1.462 2.322-2.024 2.871l-1.022.998zm-68.432-2.831c0-.451.748-1.115 1.521-1.35.762-.233.743.064-.061.978-.678.77-1.46.969-1.46.372M33.59 54.752c1.046-1.877 3.42-4.082 5.433-5.045 1.457-.699 2.23-.892 3.93-.982 2.15-.115 3.863.18 4.728.812.444.324.393.442-.74 1.701-1.47 1.635-3.438 2.97-5.575 3.778-1.242.47-2.33.63-4.998.735l-3.41.135zm76.965.194c0-.802 1.282-2.19 2.17-2.35.969-.176 1.534.041 1.534.587 0 .382-.305.583-1.245.82-.685.172-1.518.608-1.852.968l-.607.655zm57.018-.605c-.437-.225-.965-.578-1.173-.783-.327-.323-.22-.446.794-.905 1.314-.597 2.774-.659 4.347-.184 1.386.417 1.347.95-.122 1.69-1.377.695-2.73.76-3.846.182m-58.306-1.16c.174-.5.815-1.406 1.424-2.015.918-.918 1.368-1.152 2.637-1.37 1.42-.246 2.024-.224 3.048.107.8.26-.765 1.148-2.022 1.148-1.584 0-2.915.6-4.27 1.928l-1.133 1.109zm65.577-2.87c-.75-1.497-.906-2.129-1.001-4.048-.094-1.886-.02-2.485.431-3.506.3-.677.655-1.231.79-1.231.33 0 1.475 1.777 1.856 2.883.497 1.442.383 4.31-.236 5.965-.3.803-.638 1.517-.75 1.586-.11.069-.602-.673-1.09-1.649m-65.359.239c.662-1.25 2.453-2.918 3.604-3.357 1.384-.53 4.318-.42 5.512.206l.757.397-.576.403c-.45.315-1.084.374-2.904.27-2.854-.163-3.938.155-5.54 1.625-.876.802-1.1.922-.853.456m-79.602-1.036c-1.895-1.894-2.474-3.183-2.62-5.824-.066-1.211-.008-2.314.128-2.45.332-.332 2.019.945 2.831 2.145.348.513.825 1.5 1.06 2.192.47 1.384.581 4.818.164 5.076-.144.089-.848-.423-1.563-1.139m78.698-.58c.528-1.848 2.227-3.934 3.94-4.841 1.648-.872 4.113-.74 7.331.392l2.55.897-.936.614c-.919.602-.967.606-2.55.2-2.732-.698-3.209-.739-5.014-.424-2.025.352-3.826 1.419-4.84 2.865-.543.777-.635.833-.481.297m54.957-.028c-.619-.306-1.125-.665-1.125-.797 0-.133.387-.477.86-.765 1.455-.887 4.475-.65 6.244.49l.621.401-1.15.602c-1.547.81-3.894.84-5.45.07m-113.51-5.029c-.621-.307-1.376-.872-1.677-1.255l-.548-.696.883-.372c2.07-.872 5.296-.261 6.675 1.263.498.55.494.556-.662 1.08-1.52.69-3.253.682-4.672-.02m69.126-.293c-2.905-1.128-5.647-1.179-7.871-.147-.837.388-1.522.665-1.522.615 0-.292 2.738-1.751 3.95-2.106 1.796-.525 4.726-.535 6.634-.023 1.759.472 3.564.489 4.61.043.696-.298.59-.32-1.07-.226-1.83.103-1.852.096-3.683-1.16-1.013-.694-2.318-1.413-2.9-1.596l-1.058-.333.988-.018c.544-.01 2.135.28 3.535.644 2.6.675 4.605.856 4.605.415 0-.347-1.479-1.36-2.616-1.791-.935-.355-.915-.361.9-.261 2.1.115 3.862.79 4.957 1.899.72.729.727.73.727.13 0-.934-1.81-2.484-3.47-2.973-1.732-.51-.9-.598.957-.102 2.68.716 5.39 2.515 6.21 4.124.295.578.537 1.15.537 1.273 0 .122-1.102.361-2.448.532s-3.511.671-4.812 1.112c-3.03 1.027-4.41 1.017-7.16-.05m-83.06-2.246c-.331-4.672.95-8.655 3.622-11.257l1.343-1.308.418.754c.31.56.419 1.506.419 3.664 0 2.803-.036 2.984-.958 4.895-.887 1.84-3.687 5.524-4.365 5.745-.197.064-.358-.772-.48-2.493m125.87-.33c-.464-.283-1.05-.829-1.301-1.212-.556-.848-.22-1.17 1.221-1.176 1.652-.007 4.104 1.78 3.588 2.615-.3.486-2.579.34-3.507-.227m-104.922-.902c-1.831-.683-4.166-2.965-3.74-3.655.203-.328 3.603-.26 4.628.093.494.17 1.341.6 1.882.955 1.055.692 2.477 2.374 2.223 2.628-.352.353-4.033.337-4.993-.021m.993-5.296c-.727-.191-2.034-.56-2.902-.82l-1.58-.473.898-.75c2.53-2.112 6.92-3.595 9.62-3.25 1.876.239 3.85 1.003 4.937 1.91l.907.758-1.14.825c-1.943 1.409-3.805 1.977-6.771 2.068-1.607.05-3.165-.056-3.969-.268" style="fill:teal;stroke-width:.264583"></path></svg>
`)}`;
var BiatecWallet = class extends WalletConnect {
  static defaultMetadata = {
    name: "BiatecWallet",
    icon: ICON2
  };
};

// src/wallets/custom.ts
var ICON3 = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="#525252" />
</svg>
`)}`;
var CustomWallet = class extends BaseWallet {
  provider;
  store;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    options,
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    if (!options?.provider) {
      this.logger.error("Missing required option: provider");
      throw new Error("Missing required option: provider");
    }
    this.provider = options.provider;
    this.store = store;
  }
  static defaultMetadata = {
    name: "Custom",
    icon: ICON3
  };
  connect = async (args) => {
    this.logger.info("Connecting...");
    try {
      if (!this.provider.connect) {
        this.logger.error("Method not supported: connect");
        throw new Error("Method not supported: connect");
      }
      const walletAccounts = await this.provider.connect(args);
      if (walletAccounts.length === 0) {
        this.logger.error("No accounts found!");
        throw new Error("No accounts found!");
      }
      const activeAccount = walletAccounts[0];
      const walletState = {
        accounts: walletAccounts,
        activeAccount
      };
      addWallet(this.store, {
        walletId: this.id,
        wallet: walletState
      });
      this.logger.info("\u2705 Connected.", walletState);
      return walletAccounts;
    } catch (error) {
      this.logger.error("Error connecting:", error.message || error);
      throw error;
    }
  };
  disconnect = async () => {
    this.logger.info("Disconnecting...");
    this.onDisconnect();
    await this.provider.disconnect?.();
  };
  resumeSession = async () => {
    try {
      const state = this.store.state;
      const walletState = state.wallets[this.id];
      if (!walletState) {
        this.logger.info("No session to resume");
        return;
      }
      this.logger.info("Resuming session...");
      const result = await this.provider.resumeSession?.();
      if (Array.isArray(result)) {
        const walletAccounts = result;
        if (walletAccounts.length === 0) {
          this.logger.error("No accounts found!");
          throw new Error("No accounts found!");
        }
        const match = compareAccounts(walletAccounts, walletState.accounts);
        if (!match) {
          this.logger.warn("Session accounts mismatch, updating accounts", {
            prev: walletState.accounts,
            current: walletAccounts
          });
          setAccounts(this.store, {
            walletId: this.id,
            accounts: walletAccounts
          });
        }
      }
      this.logger.info("Session resumed.");
    } catch (error) {
      this.logger.error("Error resuming session:", error.message);
      throw error;
    }
  };
  signTransactions = async (txnGroup, indexesToSign) => {
    if (!this.provider.signTransactions) {
      this.logger.error("Method not supported: signTransactions");
      throw new Error("Method not supported: signTransactions");
    }
    this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
    return await this.provider.signTransactions(txnGroup, indexesToSign);
  };
  transactionSigner = async (txnGroup, indexesToSign) => {
    if (!this.provider.transactionSigner) {
      this.logger.error("Method not supported: transactionSigner");
      throw new Error("Method not supported: transactionSigner");
    }
    this.logger.debug("Transaction signer called...", { txnGroup, indexesToSign });
    return await this.provider.transactionSigner(txnGroup, indexesToSign);
  };
};

// src/wallets/defly.ts
import algosdk3 from "algosdk";
var ICON4 = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
  <rect width="1024" height="1024" />
  <path fill="#FFFFFF" d="M779.9,684.4L512,230L244.1,684.4L512,529.5L779.9,684.4z" />
  <path fill="#FFFFFF" d="M733.1,730L512,613.5L290.9,730L512,658L733.1,730z" />
</svg>
`)}`;
var DeflyWallet = class extends BaseWallet {
  client = null;
  options;
  store;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    options = {},
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    this.options = options;
    this.store = store;
  }
  static defaultMetadata = {
    name: "Defly",
    icon: ICON4
  };
  async initializeClient() {
    this.logger.info("Initializing client...");
    const module = await import("@blockshake/defly-connect");
    const DeflyWalletConnect = module.default ? module.default.DeflyWalletConnect : module.DeflyWalletConnect;
    const client = new DeflyWalletConnect(this.options);
    this.client = client;
    this.logger.info("Client initialized");
    return client;
  }
  connect = async () => {
    this.logger.info("Connecting...");
    const currentActiveWallet = this.store.state.activeWallet;
    if (currentActiveWallet && currentActiveWallet !== this.id) {
      this.manageWalletConnectSession("backup", currentActiveWallet);
    }
    const client = this.client || await this.initializeClient();
    const accounts = await client.connect();
    client.connector?.on("disconnect", this.onDisconnect);
    if (accounts.length === 0) {
      this.logger.error("No accounts found!");
      throw new Error("No accounts found!");
    }
    const walletAccounts = accounts.map((address, idx) => ({
      name: `${this.metadata.name} Account ${idx + 1}`,
      address
    }));
    const activeAccount = walletAccounts[0];
    const walletState = {
      accounts: walletAccounts,
      activeAccount
    };
    addWallet(this.store, {
      walletId: this.id,
      wallet: walletState
    });
    this.logger.info("\u2705 Connected.", walletState);
    return walletAccounts;
  };
  disconnect = async () => {
    this.logger.info("Disconnecting...");
    const client = this.client || await this.initializeClient();
    const currentActiveWallet = this.store.state.activeWallet;
    if (currentActiveWallet && currentActiveWallet !== this.id) {
      this.manageWalletConnectSession("backup", currentActiveWallet);
      this.manageWalletConnectSession("restore", this.id);
      await client.disconnect();
      await new Promise((resolve) => setTimeout(resolve, 500));
      this.manageWalletConnectSession("restore", currentActiveWallet);
    } else {
      await client.disconnect();
    }
    this.onDisconnect();
    this.logger.info("Disconnected");
  };
  setActive = () => {
    this.logger.info(`Set active wallet: ${this.id}`);
    const currentActiveWallet = this.store.state.activeWallet;
    if (currentActiveWallet && currentActiveWallet !== this.id) {
      this.manageWalletConnectSession("backup", currentActiveWallet);
    }
    this.manageWalletConnectSession("restore");
    setActiveWallet(this.store, { walletId: this.id });
  };
  resumeSession = async () => {
    try {
      const state = this.store.state;
      const walletState = state.wallets[this.id];
      if (!walletState) {
        this.logger.info("No session to resume");
        return;
      }
      this.logger.info("Resuming session...");
      const client = this.client || await this.initializeClient();
      const accounts = await client.reconnectSession();
      if (accounts.length === 0) {
        this.logger.error("No accounts found!");
        throw new Error("No accounts found!");
      }
      const walletAccounts = accounts.map((address, idx) => ({
        name: `${this.metadata.name} Account ${idx + 1}`,
        address
      }));
      const match = compareAccounts(walletAccounts, walletState.accounts);
      if (!match) {
        this.logger.warn("Session accounts mismatch, updating accounts", {
          prev: walletState.accounts,
          current: walletAccounts
        });
        setAccounts(this.store, {
          walletId: this.id,
          accounts: walletAccounts
        });
      }
      this.logger.info("Session resumed");
    } catch (error) {
      this.logger.error("Error resuming session:", error.message);
      this.onDisconnect();
      throw error;
    }
  };
  processTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txn, index) => {
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk3.encodeAddress(txn.from.publicKey);
      const canSignTxn = this.addresses.includes(signer);
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn });
      } else {
        txnsToSign.push({ txn, signers: [] });
      }
    });
    return txnsToSign;
  }
  processEncodedTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txnBuffer, index) => {
      const txnDecodeObj = algosdk3.decodeObj(txnBuffer);
      const isSigned = isSignedTxn(txnDecodeObj);
      const txn = isSigned ? algosdk3.decodeSignedTransaction(txnBuffer).txn : algosdk3.decodeUnsignedTransaction(txnBuffer);
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk3.encodeAddress(txn.from.publicKey);
      const canSignTxn = !isSigned && this.addresses.includes(signer);
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn });
      } else {
        txnsToSign.push({ txn, signers: [] });
      }
    });
    return txnsToSign;
  }
  signTransactions = async (txnGroup, indexesToSign) => {
    try {
      this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
      let txnsToSign = [];
      if (isTransactionArray(txnGroup)) {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processTxns(flatTxns, indexesToSign);
      } else {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processEncodedTxns(flatTxns, indexesToSign);
      }
      const client = this.client || await this.initializeClient();
      this.logger.debug("Sending processed transactions to wallet...", [txnsToSign]);
      const signedTxns = await client.signTransaction([txnsToSign]);
      this.logger.debug("Received signed transactions from wallet", signedTxns);
      const result = txnsToSign.reduce((acc, txn) => {
        if (txn.signers && txn.signers.length == 0) {
          acc.push(null);
        } else {
          const signedTxn = signedTxns.shift();
          if (signedTxn) {
            acc.push(signedTxn);
          }
        }
        return acc;
      }, []);
      this.logger.debug("Transactions signed successfully", result);
      return result;
    } catch (error) {
      this.logger.error("Error signing transactions:", error.message);
      throw error;
    }
  };
};

// src/wallets/exodus.ts
import algosdk4 from "algosdk";
var ICON5 = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
  <linearGradient id="grad1" gradientUnits="userSpaceOnUse" x1="246.603" y1="9.2212" x2="174.158" y2="308.5426" gradientTransform="matrix(1 0 0 -1 0 302)">
    <stop offset="0" stop-color="#0B46F9" />
    <stop offset="1" stop-color="#BBFBE0" />
  </linearGradient>
  <path fill="url(#grad1)" d="M274.7,93.9L166.6,23v39.6l69.4,45.1l-8.2,25.8h-61.2v32.9h61.2l8.2,25.8l-69.4,45.1V277l108.2-70.7L257,150.1L274.7,93.9z" />
  
  <linearGradient id="grad2" gradientUnits="userSpaceOnUse" x1="129.3516" y1="-19.1573" x2="56.9066" y2="280.1641" gradientTransform="matrix(1 0 0 -1 0 302)">
    <stop offset="0" stop-color="#0B46F9" />
    <stop offset="1" stop-color="#BBFBE0" />
  </linearGradient>
  <path fill="url(#grad2)" d="M72.5,166.4h61v-32.9H72.2l-7.9-25.8l69.2-45.1V23L25.3,93.9L43,150.1l-17.7,56.2L133.7,277v-39.6l-69.4-45.1L72.5,166.4z" />
  
  <mask id="mask1" maskUnits="userSpaceOnUse" x="25.4" y="23" width="247.6" height="254">
    <path fill="url(#grad1)" d="M274.7,93.9L166.6,23v39.6l69.4,45.1l-8.2,25.8h-61.2v32.9h61.2l8.2,25.8l-69.4,45.1V277l108.2-70.7L257,150.1L274.7,93.9z" />
    <path fill="url(#grad2)" d="M72.5,166.4h61v-32.9H72.2l-7.9-25.8l69.2-45.1V23L25.3,93.9L43,150.1l-17.7,56.2L133.7,277v-39.6l-69.4-45.1L72.5,166.4z" />
  </mask>
  
  <linearGradient id="grad3" gradientUnits="userSpaceOnUse" x1="46.4662" y1="228.7554" x2="171.8638" y2="135.1039" gradientTransform="matrix(1 0 0 -1 0 302)">
    <stop offset="0.1198" stop-color="#8952FF" stop-opacity="0.87" />
    <stop offset="1" stop-color="#DABDFF" stop-opacity="0" />
  </linearGradient>
  <rect x="25.4" y="23" width="247.6" height="254" fill="url(#grad3)" mask="url(#mask1)" />
</svg>
`)}`;
var ExodusWallet = class extends BaseWallet {
  client = null;
  options;
  store;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    options = {},
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    this.options = options;
    this.store = store;
  }
  static defaultMetadata = {
    name: "Exodus",
    icon: ICON5
  };
  async initializeClient() {
    this.logger.info("Initializing client...");
    if (typeof window === "undefined" || window.algorand === void 0) {
      this.logger.error("Exodus is not available.");
      throw new Error("Exodus is not available.");
    }
    const client = window.algorand;
    this.client = client;
    this.logger.info("Client initialized");
    return client;
  }
  connect = async () => {
    this.logger.info("Connecting...");
    const client = this.client || await this.initializeClient();
    const { accounts } = await client.enable(this.options);
    if (accounts.length === 0) {
      this.logger.error("No accounts found!");
      throw new Error("No accounts found!");
    }
    const walletAccounts = accounts.map((address, idx) => ({
      name: `${this.metadata.name} Account ${idx + 1}`,
      address
    }));
    const activeAccount = walletAccounts[0];
    const walletState = {
      accounts: walletAccounts,
      activeAccount
    };
    addWallet(this.store, {
      walletId: this.id,
      wallet: walletState
    });
    this.logger.info("\u2705 Connected.", walletState);
    return walletAccounts;
  };
  disconnect = async () => {
    this.logger.info("Disconnecting...");
    this.onDisconnect();
    this.logger.info("Disconnected.");
  };
  resumeSession = async () => {
    try {
      const state = this.store.state;
      const walletState = state.wallets[this.id];
      if (!walletState) {
        this.logger.info("No session to resume");
        return;
      }
      this.logger.info("Resuming session...");
      const client = await this.initializeClient();
      if (!client.isConnected) {
        this.logger.error("Exodus is not connected.");
        throw new Error("Exodus is not connected.");
      }
      this.logger.info("Session resumed");
    } catch (error) {
      this.logger.error("Error resuming session:", error.message);
      this.onDisconnect();
      throw error;
    }
  };
  processTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txn, index) => {
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk4.encodeAddress(txn.from.publicKey);
      const canSignTxn = this.addresses.includes(signer);
      const txnString = byteArrayToBase64(txn.toByte());
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn: txnString });
      } else {
        txnsToSign.push({ txn: txnString, signers: [] });
      }
    });
    return txnsToSign;
  }
  processEncodedTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txnBuffer, index) => {
      const txnDecodeObj = algosdk4.decodeObj(txnBuffer);
      const isSigned = isSignedTxn(txnDecodeObj);
      const txn = isSigned ? algosdk4.decodeSignedTransaction(txnBuffer).txn : algosdk4.decodeUnsignedTransaction(txnBuffer);
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk4.encodeAddress(txn.from.publicKey);
      const canSignTxn = !isSigned && this.addresses.includes(signer);
      const txnString = byteArrayToBase64(txn.toByte());
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn: txnString });
      } else {
        txnsToSign.push({ txn: txnString, signers: [] });
      }
    });
    return txnsToSign;
  }
  signTransactions = async (txnGroup, indexesToSign) => {
    try {
      this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
      let txnsToSign = [];
      if (isTransactionArray(txnGroup)) {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processTxns(flatTxns, indexesToSign);
      } else {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processEncodedTxns(flatTxns, indexesToSign);
      }
      const client = this.client || await this.initializeClient();
      this.logger.debug("Sending processed transactions to wallet...", txnsToSign);
      const signTxnsResult = await client.signTxns(txnsToSign);
      this.logger.debug("Received signed transactions from wallet", signTxnsResult);
      const result = signTxnsResult.map((value) => {
        if (value === null) {
          return null;
        }
        return base64ToByteArray(value);
      });
      this.logger.debug("Transactions signed successfully", result);
      return result;
    } catch (error) {
      this.logger.error("Error signing transactions:", error.message);
      throw error;
    }
  };
};

// src/wallets/kibisis.ts
import algosdk5 from "algosdk";
function isAVMWebProviderSDKError(error) {
  return typeof error === "object" && "code" in error && "message" in error;
}
var KIBISIS_AVM_WEB_PROVIDER_ID = "f6d1c86b-4493-42fb-b88d-a62407b4cdf6";
var ICON6 = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 480 480" xmlns="http://www.w3.org/2000/svg">
  <rect fill="#801C96" width="480" height="480" />
  <path fill="#FFFFFF" d="M393.5,223.2c0-7.3-0.6-14.6-1.6-21.6c-0.9-6.5-2.3-12.8-4-18.9c-18-64.9-77.4-112.5-148-112.5c-70.6,0-130,47.6-148,112.5c-1.7,6.2-3,12.5-4,19c-1,7.1-1.6,14.3-1.6,21.6h0v85.5h19.7v-85.5c0-7.2,0.6-14.4,1.8-21.4c14,1.1,27.6,4.3,40.5,9.5c15.9,6.4,30.3,15.6,42.6,27.3c12.3,11.7,22,25.4,28.7,40.6c6.9,15.6,10.5,32.2,10.5,49.2v81.4h0.1h19.6h0.1v-81.5c0.1-17.1,3.6-33.7,10.5-49.2c6.7-15.2,16.4-28.8,28.7-40.6c4.2-4,8.6-7.7,13.2-11.1v132.2h19.7V223.2h0c0-2.5-0.1-5-0.4-7.4c3.3-1.6,6.6-3.1,10-4.5c12.9-5.2,26.4-8.4,40.4-9.5c1.2,7,1.7,14.2,1.8,21.4v85.5h19.7L393.5,223.2L393.5,223.2z M240.1,277.3c-11.6-29.3-32.7-54.1-59.8-71c2.9-10,8.2-19.1,15.8-26.6c11.8-11.8,27.4-18.2,44-18.2s32.3,6.5,44,18.2c4.1,4.1,7.5,8.7,10.3,13.6c5.6-3.4,11.4-6.4,17.4-9.2c-14-25.2-40.9-42.3-71.8-42.3c-35.9,0-66.3,23-77.5,55.1c-15.5-7.1-32.5-11.8-50.4-13.5c1.3-4,2.7-7.9,4.3-11.8c6.7-15.9,16.4-30.3,28.7-42.6s26.6-22,42.6-28.7c16.5-7,34-10.5,52.1-10.5s35.6,3.5,52.1,10.5c15.9,6.7,30.3,16.4,42.6,28.7s22,26.6,28.7,42.6c1.6,3.9,3.1,7.8,4.3,11.8C309,189.2,260.1,226.5,240.1,277.3z" />
  <path fill="#FFFFFF" d="M158.1,359.8h19.7V245.5c-6.1-5.4-12.7-10-19.7-14V359.8z" />
</svg>
`)}`;
var KibisisWallet = class extends BaseWallet {
  avmWebClient = null;
  avmWebProviderSDK = null;
  store;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    this.store = store;
  }
  static defaultMetadata = {
    name: "Kibisis",
    icon: ICON6
  };
  /**
   * private functions
   */
  /**
   * Calls the "disable" method on the provider. This method will timeout after 0.75 seconds.
   * @returns {Promise<AVMWebProviderSDK.IDisableResult>} a promise that resolves to the result.
   * @private
   * @throws {MethodNotSupportedError} if the method is not supported for the configured network.
   * @throws {MethodTimedOutError} if the method timed out by lack of response (>= 3 minutes).
   * @throws {NetworkNotSupportedError} if the network is not supported for the configured network.
   * @throws {UnknownError} if the response result is empty.
   */
  async _disable() {
    const {
      ARC0027MethodEnum,
      ARC0027MethodTimedOutError,
      ARC0027UnknownError,
      LOWER_REQUEST_TIMEOUT
    } = this.avmWebProviderSDK || await this._initializeAVMWebProviderSDK();
    const avmWebClient = this.avmWebClient || await this._initializeAVMWebClient();
    const genesisHash = await this._getGenesisHash();
    return new Promise((resolve, reject) => {
      const timerId = window.setTimeout(() => {
        avmWebClient.removeListener(listenerId);
        reject(
          new ARC0027MethodTimedOutError({
            method: ARC0027MethodEnum.Disable,
            message: `no response from provider "${this.metadata.name}"`,
            providerId: KIBISIS_AVM_WEB_PROVIDER_ID
          })
        );
      }, LOWER_REQUEST_TIMEOUT);
      const listenerId = avmWebClient.onDisable(({ error, method, result }) => {
        avmWebClient.removeListener(listenerId);
        window.clearTimeout(timerId);
        if (error) {
          return reject(error);
        }
        if (!result) {
          return reject(
            new ARC0027UnknownError({
              message: `received response, but "${method}" request details were empty for provider "${this.metadata.name}"`,
              providerId: KIBISIS_AVM_WEB_PROVIDER_ID
            })
          );
        }
        this.logger.debug("Disable successful", { result });
        return resolve(result);
      });
      this.logger.debug("Sending disable request...", { genesisHash });
      avmWebClient.disable({
        genesisHash,
        providerId: KIBISIS_AVM_WEB_PROVIDER_ID
      });
    });
  }
  /**
   * Calls the "enable" method on the provider. This method will timeout after 3 minutes.
   * @returns {Promise<AVMWebProviderSDK.IEnableResult>} a promise that resolves to the result.
   * @private
   * @throws {MethodCanceledError} if the method was cancelled by the user.
   * @throws {MethodNotSupportedError} if the method is not supported for the configured network.
   * @throws {MethodTimedOutError} if the method timed out by lack of response (>= 3 minutes).
   * @throws {NetworkNotSupportedError} if the network is not supported for the configured network.
   * @throws {UnknownError} if the response result is empty.
   */
  async _enable() {
    const {
      ARC0027MethodEnum,
      ARC0027MethodTimedOutError,
      ARC0027UnknownError,
      DEFAULT_REQUEST_TIMEOUT
    } = this.avmWebProviderSDK || await this._initializeAVMWebProviderSDK();
    const avmWebClient = this.avmWebClient || await this._initializeAVMWebClient();
    const genesisHash = await this._getGenesisHash();
    return new Promise((resolve, reject) => {
      const timerId = window.setTimeout(() => {
        avmWebClient.removeListener(listenerId);
        reject(
          new ARC0027MethodTimedOutError({
            method: ARC0027MethodEnum.Enable,
            message: `no response from provider "${this.metadata.name}"`,
            providerId: KIBISIS_AVM_WEB_PROVIDER_ID
          })
        );
      }, DEFAULT_REQUEST_TIMEOUT);
      const listenerId = avmWebClient.onEnable(({ error, method, result }) => {
        avmWebClient.removeListener(listenerId);
        window.clearTimeout(timerId);
        if (error) {
          return reject(error);
        }
        if (!result) {
          return reject(
            new ARC0027UnknownError({
              message: `received response, but "${method}" request details were empty for provider "${this.metadata.name}"`,
              providerId: KIBISIS_AVM_WEB_PROVIDER_ID
            })
          );
        }
        this.logger.debug("Enable successful", { result });
        return resolve(result);
      });
      this.logger.debug("Sending enable request...", { genesisHash });
      avmWebClient.enable({
        genesisHash,
        providerId: KIBISIS_AVM_WEB_PROVIDER_ID
      });
    });
  }
  async _getGenesisHash() {
    const algodClient = this.getAlgodClient();
    const version = await algodClient.versionsCheck().do();
    return version.genesis_hash_b64;
  }
  async _initializeAVMWebClient() {
    const avmWebProviderSDK = this.avmWebProviderSDK || await this._initializeAVMWebProviderSDK();
    if (!this.avmWebClient) {
      this.logger.info("Initializing new AVM Web Client...");
      this.avmWebClient = avmWebProviderSDK.AVMWebClient.init();
      this.logger.info("AVM Web Client initialized");
    }
    return this.avmWebClient;
  }
  async _initializeAVMWebProviderSDK() {
    if (!this.avmWebProviderSDK) {
      this.logger.info("Initializing @agoralabs-sh/avm-web-provider...");
      const module = await import("@agoralabs-sh/avm-web-provider");
      this.avmWebProviderSDK = module.default ? module.default : module;
      if (!this.avmWebProviderSDK) {
        throw new Error(
          "Failed to initialize, the @agoralabs-sh/avm-web-provider SDK was not provided"
        );
      }
      if (!this.avmWebProviderSDK.AVMWebClient) {
        throw new Error(
          "Failed to initialize, AVMWebClient missing from @agoralabs-sh/avm-web-provider SDK"
        );
      }
      this.logger.info("@agoralabs-sh/avm-web-provider initialized");
    }
    return this.avmWebProviderSDK;
  }
  _mapAVMWebProviderAccountToWalletAccounts(accounts) {
    return accounts.map(({ address, name }, idx) => ({
      name: name || `[${this.metadata.name}] Account ${idx + 1}`,
      address
    }));
  }
  /**
   * Calls the "signTransactions" method to sign the supplied ARC-0001 transactions. This method will timeout after 3
   * minutes.
   * @returns {Promise<AVMWebProviderSDK.ISignTransactionsResult>} a promise that resolves to the result.
   * @private
   * @throws {InvalidInputError} if computed group ID for the txns does not match the assigned group ID.
   * @throws {InvalidGroupIdError} if the unsigned txns is malformed or not conforming to ARC-0001.
   * @throws {MethodCanceledError} if the method was cancelled by the user.
   * @throws {MethodNotSupportedError} if the method is not supported for the configured network.
   * @throws {MethodTimedOutError} if the method timed out by lack of response (>= 3 minutes).
   * @throws {NetworkNotSupportedError} if the network is not supported for the configured network.
   * @throws {UnauthorizedSignerError} if a signer in the request is not authorized by the provider.
   * @throws {UnknownError} if the response result is empty.
   */
  async _signTransactions(txns) {
    const {
      ARC0027MethodEnum,
      ARC0027MethodTimedOutError,
      ARC0027UnknownError,
      DEFAULT_REQUEST_TIMEOUT
    } = this.avmWebProviderSDK || await this._initializeAVMWebProviderSDK();
    const avmWebClient = this.avmWebClient || await this._initializeAVMWebClient();
    return new Promise((resolve, reject) => {
      const timerId = window.setTimeout(() => {
        avmWebClient.removeListener(listenerId);
        reject(
          new ARC0027MethodTimedOutError({
            method: ARC0027MethodEnum.SignTransactions,
            message: `no response from provider "${this.metadata.name}"`,
            providerId: KIBISIS_AVM_WEB_PROVIDER_ID
          })
        );
      }, DEFAULT_REQUEST_TIMEOUT);
      const listenerId = avmWebClient.onSignTransactions(({ error, method, result }) => {
        avmWebClient.removeListener(listenerId);
        window.clearTimeout(timerId);
        if (error) {
          return reject(error);
        }
        if (!result) {
          return reject(
            new ARC0027UnknownError({
              message: `received response, but "${method}" request details were empty for provider "${this.metadata.name}"`,
              providerId: KIBISIS_AVM_WEB_PROVIDER_ID
            })
          );
        }
        this.logger.debug("Sign transactions successful", { result });
        return resolve(result);
      });
      this.logger.debug("Sending sign transactions request...", { txns });
      avmWebClient.signTransactions({
        txns,
        providerId: KIBISIS_AVM_WEB_PROVIDER_ID
      });
    });
  }
  /**
   * public functions
   */
  async connect() {
    let result;
    try {
      this.logger.info("Connecting...");
      result = await this._enable();
      this.logger.info(`Successfully connected on network "${result.genesisId}"`);
    } catch (error) {
      this.logger.error(
        "Error connecting:",
        isAVMWebProviderSDKError(error) ? `${error.message} (code: ${error.code})` : error.message
      );
      throw error;
    }
    const walletAccounts = this._mapAVMWebProviderAccountToWalletAccounts(result.accounts);
    const walletState = {
      accounts: walletAccounts,
      activeAccount: walletAccounts[0]
    };
    addWallet(this.store, {
      walletId: this.id,
      wallet: walletState
    });
    this.logger.info("\u2705 Connected.", walletState);
    return walletAccounts;
  }
  async disconnect() {
    try {
      this.logger.info("Disconnecting...");
      this.onDisconnect();
      const result = await this._disable();
      this.logger.info(
        `Successfully disconnected${result.sessionIds && result.sessionIds.length ? ` sessions [${result.sessionIds.join(",")}]` : ""} on network "${result.genesisId}"`
      );
    } catch (error) {
      this.logger.error(
        "Error disconnecting:",
        isAVMWebProviderSDKError(error) ? `${error.message} (code: ${error.code})` : error.message
      );
      throw error;
    }
  }
  async resumeSession() {
    const state = this.store.state;
    const walletState = state.wallets[this.id];
    let result;
    if (!walletState) {
      this.logger.info("No session to resume");
      return;
    }
    try {
      this.logger.info("Resuming session...");
      result = await this._enable();
      if (result.accounts.length === 0) {
        throw new Error("No accounts found!");
      }
      const walletAccounts = this._mapAVMWebProviderAccountToWalletAccounts(result.accounts);
      const match = compareAccounts(walletAccounts, walletState.accounts);
      if (!match) {
        this.logger.warn("Session accounts mismatch, updating accounts", {
          prev: walletState.accounts,
          current: walletAccounts
        });
        setAccounts(this.store, {
          walletId: this.id,
          accounts: walletAccounts
        });
      }
      this.logger.info("Session resumed successfully");
    } catch (error) {
      this.logger.error(
        "Error resuming session:",
        isAVMWebProviderSDKError(error) ? `${error.message} (code: ${error.code})` : error.message
      );
      this.onDisconnect();
      throw error;
    }
  }
  processTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txn, index) => {
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk5.encodeAddress(txn.from.publicKey);
      const canSignTxn = this.addresses.includes(signer);
      const txnString = byteArrayToBase64(txn.toByte());
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn: txnString });
      } else {
        txnsToSign.push({ txn: txnString, signers: [] });
      }
    });
    return txnsToSign;
  }
  processEncodedTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txnBuffer, index) => {
      const txnDecodeObj = algosdk5.decodeObj(txnBuffer);
      const isSigned = isSignedTxn(txnDecodeObj);
      const txn = isSigned ? algosdk5.decodeSignedTransaction(txnBuffer).txn : algosdk5.decodeUnsignedTransaction(txnBuffer);
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk5.encodeAddress(txn.from.publicKey);
      const canSignTxn = !isSigned && this.addresses.includes(signer);
      const txnString = byteArrayToBase64(txn.toByte());
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn: txnString });
      } else {
        txnsToSign.push({ txn: txnString, signers: [] });
      }
    });
    return txnsToSign;
  }
  signTransactions = async (txnGroup, indexesToSign) => {
    try {
      this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
      let txnsToSign = [];
      if (isTransactionArray(txnGroup)) {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processTxns(flatTxns, indexesToSign);
      } else {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processEncodedTxns(flatTxns, indexesToSign);
      }
      this.logger.debug("Sending processed transactions to wallet...", txnsToSign);
      const signTxnsResult = await this._signTransactions(txnsToSign);
      this.logger.debug("Received signed transactions from wallet", signTxnsResult);
      const result = signTxnsResult.stxns.map((value) => {
        if (value === null) {
          return null;
        }
        return base64ToByteArray(value);
      });
      this.logger.debug("Transactions signed successfully", result);
      return result;
    } catch (error) {
      this.logger.error(
        "Error signing transactions:",
        isAVMWebProviderSDKError(error) ? `${error.message} (code: ${error.code})` : error.message
      );
      throw error;
    }
  };
};

// src/wallets/kmd.ts
import algosdk6 from "algosdk";
var ICON7 = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
  <linearGradient id="algokitGradient" gradientUnits="userSpaceOnUse" x1="0" y1="400" x2="400" y2="0">
    <stop offset="0" style="stop-color:#31D8EE"/>
    <stop offset="1" style="stop-color:#01DC94"/>
  </linearGradient>
  <rect fill="url(#algokitGradient)" width="400" height="400" />
  <path fill="#FFFFFF" d="M309.2,309.3H275l-22.2-82.7l-47.9,82.7h-38.3l73.9-128l-11.9-44.5l-99.6,172.6H90.8L217.1,90.6 h33.5l14.7,54.3h34.6l-23.6,41L309.2,309.3z" />
</svg>
`)}`;
var KmdWallet = class extends BaseWallet {
  client = null;
  options;
  walletName;
  walletId = "";
  password = "";
  store;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    options,
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    const {
      token = "a".repeat(64),
      baseServer = "http://127.0.0.1",
      port = 4002,
      wallet = "unencrypted-default-wallet"
    } = options || {};
    this.options = { token, baseServer, port };
    this.walletName = wallet;
    this.store = store;
  }
  static defaultMetadata = {
    name: "KMD",
    icon: ICON7
  };
  async initializeClient() {
    this.logger.info("Initializing client...");
    const { token, baseServer, port } = this.options;
    const client = new algosdk6.Kmd(token, baseServer, port);
    this.client = client;
    this.logger.info("Client initialized");
    return client;
  }
  connect = async () => {
    this.logger.info("Connecting...");
    if (!this.client) {
      await this.initializeClient();
    }
    try {
      const token = await this.fetchToken();
      const accounts = await this.fetchAccounts(token);
      if (accounts.length === 0) {
        throw new Error("No accounts found!");
      }
      const walletAccounts = accounts.map((address, idx) => ({
        name: `${this.metadata.name} Account ${idx + 1}`,
        address
      }));
      const activeAccount = walletAccounts[0];
      const walletState = {
        accounts: walletAccounts,
        activeAccount
      };
      addWallet(this.store, {
        walletId: this.id,
        wallet: walletState
      });
      await this.releaseToken(token);
      this.logger.info("\u2705 Connected.", walletState);
      return walletAccounts;
    } catch (error) {
      this.logger.error("Error connecting:", error.message);
      throw error;
    }
  };
  disconnect = async () => {
    this.logger.info("Disconnecting...");
    this.onDisconnect();
    this.logger.info("Disconnected.");
  };
  resumeSession = async () => {
    try {
      const state = this.store.state;
      const walletState = state.wallets[this.id];
      if (!walletState) {
        this.logger.info("No session to resume");
        return;
      }
      this.logger.info("Resuming session...");
      await this.initializeClient();
      this.logger.info("Session resumed");
    } catch (error) {
      this.logger.error("Error resuming session:", error.message);
      this.onDisconnect();
      throw error;
    }
  };
  processTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txn, index) => {
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk6.encodeAddress(txn.from.publicKey);
      const canSignTxn = this.addresses.includes(signer);
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push(txn);
      }
    });
    return txnsToSign;
  }
  processEncodedTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txnBuffer, index) => {
      const txnDecodeObj = algosdk6.decodeObj(txnBuffer);
      const isSigned = isSignedTxn(txnDecodeObj);
      const txn = isSigned ? algosdk6.decodeSignedTransaction(txnBuffer).txn : algosdk6.decodeUnsignedTransaction(txnBuffer);
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk6.encodeAddress(txn.from.publicKey);
      const canSignTxn = !isSigned && this.addresses.includes(signer);
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push(txn);
      }
    });
    return txnsToSign;
  }
  signTransactions = async (txnGroup, indexesToSign) => {
    try {
      this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
      let txnsToSign = [];
      if (isTransactionArray(txnGroup)) {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processTxns(flatTxns, indexesToSign);
      } else {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processEncodedTxns(flatTxns, indexesToSign);
      }
      const token = await this.fetchToken();
      const password = this.getPassword();
      const client = this.client || await this.initializeClient();
      this.logger.debug("Sending processed transactions to wallet...", txnsToSign);
      const signedTxns = await Promise.all(
        txnsToSign.map((txn) => client.signTransaction(token, password, txn))
      );
      this.logger.debug("Received signed transactions from wallet", signedTxns);
      await this.releaseToken(token);
      this.logger.debug("Transactions signed successfully", signedTxns);
      return signedTxns;
    } catch (error) {
      this.logger.error("Error signing transactions:", error.message);
      throw error;
    }
  };
  async fetchWalletId() {
    this.logger.debug("Fetching wallet data...", { walletName: this.walletName });
    const client = this.client || await this.initializeClient();
    const { wallets } = await client.listWallets();
    const wallet = wallets.find((wallet2) => wallet2.name === this.walletName);
    if (!wallet) {
      this.logger.error(`Wallet "${this.walletName}" not found!`);
      throw new Error(`Wallet "${this.walletName}" not found!`);
    }
    this.walletId = wallet.id;
    this.logger.debug("Wallet data fetched successfully", { walletId: this.walletId });
    return wallet.id;
  }
  async fetchToken() {
    this.logger.debug("Fetching token...", { walletId: this.walletId });
    const client = this.client || await this.initializeClient();
    const walletId = this.walletId || await this.fetchWalletId();
    const password = this.getPassword();
    const { wallet_handle_token } = await client.initWalletHandle(
      walletId,
      password
    );
    this.logger.debug("Token fetched successfully");
    return wallet_handle_token;
  }
  async releaseToken(token) {
    this.logger.debug("Releasing token...");
    const client = this.client || await this.initializeClient();
    await client.releaseWalletHandle(token);
    this.logger.debug("Token released successfully");
  }
  getPassword() {
    if (this.password) {
      return this.password;
    }
    const password = prompt("KMD password") || "";
    this.password = password;
    return password;
  }
  async fetchAccounts(token) {
    this.logger.debug("Fetching accounts...");
    const client = this.client || await this.initializeClient();
    const { addresses } = await client.listKeys(token);
    this.logger.debug("Accounts fetched successfully", { addresses });
    return addresses;
  }
};

// src/wallets/lute.ts
import algosdk7 from "algosdk";
function isSignTxnsError(error) {
  return error instanceof Error && "code" in error;
}
var ICON8 = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
  <path fill="#AB47BC" d="M283.7,263.6c-0.6,0-1.3-0.1-1.8-0.4c-0.6-0.3-1.1-0.8-1.5-1.3c-0.4-0.6-0.7-1.3-0.8-2 c-0.1-0.8-0.1-1.7,0.1-2.5c0.2-0.9,0.6-1.8,1.2-2.6c0.6-0.8,1.4-1.7,2.2-2.3c0.9-0.7,2.1-1.2,3.2-1.6c1.2-0.4,2.7-0.5,4-0.5 c1.4,0,3,0.3,4.4,0.8c1.5,0.5,3.1,1.4,4.3,2.3c1.4,1,2.8,2.4,3.8,3.7c1.1,1.5,2.1,3.3,2.8,5.1c0.7,1.9,1.2,4.1,1.3,6.1 c0.2,2.1,0,4.6-0.4,6.7c-0.5,2.2-1.4,4.7-2.4,6.7c-1.1,2.1-2.8,4.4-4.4,6.2c-1.8,1.9-4.1,3.7-6.3,5c-2.3,1.4-5.2,2.6-7.9,3.3 c-2.8,0.7-6.1,1.1-8.9,1.1c-3,0-6.5-0.6-9.3-1.4c-3-0.9-6.4-2.4-9.1-4c-2.8-1.7-5.8-4.2-8-6.6c-2.3-2.5-4.6-5.8-6.2-8.9 c-1.7-3.2-3.1-7.1-3.8-10.7c-0.8-3.7-1.1-8-0.9-11.8c0.2-3.9,1.1-8.3,2.3-12c1.3-3.8,3.4-8.1,5.7-11.4c2.3-3.5,5.6-7.1,8.8-9.9 c3.3-2.8,7.5-5.6,11.5-7.5c4.1-1.9,9-3.5,13.5-4.3c4.6-0.8,10-1.1,14.6-0.7c4.8,0.4,10.2,1.6,14.7,3.3c4.7,1.7,9.7,4.4,13.8,7.3 c4.2,3,8.5,7,11.7,10.9c3.3,4.1,6.5,9.2,8.7,14c2.2,4.9,4,10.9,4.9,16.3c0.9,5.5,1,11.9,0.4,17.5c-0.6,5.7-2.2,12.1-4.3,17.4 c-2.1,5.5-5.4,11.4-8.9,16.1c-3.6,4.8-8.4,9.8-13.1,13.6c-4.8,3.8-11,7.5-16.6,9.9c-5.8,2.5-12.8,4.5-19.1,5.4 c-6.4,0.9-13.9,1-20.3,0.2c-6.6-0.8-14-2.7-20.1-5.2c-6.3-2.5-13.1-6.4-18.5-10.5c-5.5-4.2-11.2-9.8-15.4-15.3 c-4.3-5.6-8.4-12.7-11.2-19.2c-2.8-6.7-4.9-14.7-5.9-21.9c-0.9-5.9-2.8-12.6-5.2-18.1c-2.3-5.4-5.9-11.2-9.5-15.8 c-3.6-4.5-8.3-9-13-12.4c-4.5-3.3-10.1-6.4-15.3-8.3c-5-1.9-11.1-3.4-16.5-3.9c-5.2-0.5-11.3-0.3-16.5,0.5c-5,0.8-10.7,2.6-15.3,4.7 c-4.5,2.1-9.4,5.1-13.2,8.3c-3.7,3.1-7.5,7.2-10.2,11.1c-2.7,3.8-5.2,8.6-6.7,13c-1.5,4.2-2.6,9.3-3,13.8c-0.3,4.3-0.1,9.4,0.7,13.7 c0.8,4.1,2.3,8.8,4.2,12.5c1.8,3.6,4.4,7.6,7.1,10.6c2.6,2.9,6,5.9,9.3,8.1c3.1,2.1,7.1,4,10.6,5.1c3.4,1.1,7.5,1.9,11.1,2 c3.5,0.2,7.4-0.2,10.8-1c3.2-0.7,6.8-2.1,9.7-3.6c2.8-1.5,5.7-3.6,8-5.8c2.2-2.1,4.3-4.8,5.9-7.4c1.5-2.5,2.8-5.5,3.5-8.3 c0.7-2.6,1.1-5.7,1.1-8.5c0-2.6-0.5-5.5-1.2-8c-0.7-2.3-1.8-4.9-3.1-6.9c-1.2-1.9-2.9-3.9-4.6-5.4c-1.6-1.4-3.6-2.8-5.5-3.7 c-1.8-0.9-4-1.6-5.9-1.9c-1.8-0.3-3.9-0.4-5.8-0.1c-1.7,0.2-3.6,0.7-5.1,1.4c-1.4,0.6-2.9,1.6-4.1,2.6c-1.1,0.9-2.1,2.2-2.9,3.4 c-0.7,1.1-1.2,2.5-1.5,3.7c-0.3,1.1-0.4,2.4-0.3,3.6c0.1,1,0.4,2.2,0.8,3.1c0.4,0.8,1,1.7,1.6,2.3c0.6,0.5,1.3,1,2.1,1.3 c0.6,0.2,1.5,0.4,2.1,0.3c0.6-0.1,1.3-0.3,1.8-0.6c0.5-0.3,1-0.8,1.2-1.4c0.3-0.5,0.7-1,1.2-1.4c0.5-0.3,1.2-0.6,1.8-0.6 c0.7-0.1,1.5,0.1,2.1,0.3c0.7,0.3,1.5,0.8,2.1,1.3c0.6,0.6,1.3,1.5,1.6,2.3c0.4,0.9,0.7,2.1,0.8,3.1c0.1,1.1,0,2.5-0.3,3.6 c-0.3,1.2-0.9,2.6-1.5,3.7c-0.7,1.2-1.8,2.4-2.9,3.4c-1.2,1-2.7,2-4.1,2.6c-1.5,0.7-3.4,1.2-5.1,1.4c-1.8,0.2-4,0.2-5.8-0.1 c-2-0.3-4.1-1-5.9-1.9c-1.9-0.9-4-2.3-5.5-3.7c-1.7-1.5-3.4-3.5-4.6-5.4c-1.3-2-2.4-4.6-3.1-6.9c-0.7-2.5-1.2-5.4-1.2-8 c0-2.7,0.4-5.8,1.1-8.5c0.7-2.8,2-5.8,3.5-8.3c1.5-2.6,3.7-5.3,5.9-7.4c2.3-2.2,5.2-4.3,8-5.8c2.9-1.6,6.5-2.9,9.7-3.6 c3.4-0.8,7.4-1.1,10.8-1c3.6,0.2,7.7,0.9,11.1,2c3.6,1.2,7.5,3.1,10.6,5.1c3.3,2.1,6.7,5.1,9.3,8.1c2.7,3,5.3,7,7.1,10.6 c1.8,3.8,3.4,8.4,4.2,12.5c0.8,4.3,1.1,9.3,0.7,13.7c-0.4,4.5-1.5,9.6-3,13.8c-1.6,4.4-4.1,9.2-6.7,13c-2.8,3.9-6.5,8-10.2,11.1 c-3.8,3.2-8.7,6.2-13.2,8.3c-4.6,2.1-10.3,3.8-15.3,4.7c-5.2,0.9-11.3,1-16.5,0.5c-5.4-0.5-11.5-2-16.5-3.9 c-5.2-2-10.8-5.1-15.3-8.3c-4.6-3.4-9.4-7.9-13-12.4c-3.7-4.6-7.2-10.4-9.5-15.8c-2.4-5.5-4.3-12.2-5.2-18.1 c-0.9-6.1-1-13.2-0.3-19.3c0.7-6.3,2.5-13.4,4.9-19.2c2.4-6,6.1-12.5,10-17.7c4-5.3,9.3-10.7,14.6-14.8c5.3-4.2,12.1-8.1,18.3-10.7 c6.4-2.7,14.1-4.8,21-5.7c7-1,15.2-1,22.2-0.1c7.2,0.9,15.2,3.1,21.9,5.8c5.6,2.2,12.3,3.9,18.3,4.6c5.8,0.7,12.6,0.5,18.4-0.4 c5.6-0.9,12-2.7,17.2-5c5.1-2.3,10.6-5.6,14.9-9.1c4.2-3.4,8.5-8,11.7-12.3c3.1-4.3,6-9.6,7.8-14.5c1.8-4.8,3.1-10.5,3.6-15.6 c0.5-4.9,0.3-10.7-0.6-15.6c-0.8-4.7-2.5-10.1-4.5-14.4c-2-4.2-4.9-8.8-7.9-12.3c-2.9-3.4-6.8-6.9-10.5-9.5 c-3.6-2.5-8.1-4.8-12.2-6.2c-4-1.4-8.7-2.4-12.9-2.7c-4-0.3-8.7,0-12.7,0.8c-3.8,0.8-8.1,2.2-11.6,4c-3.4,1.7-7,4.1-9.7,6.6 c-2.7,2.4-5.4,5.6-7.3,8.6c-1.9,2.9-3.6,6.5-4.6,9.8c-1,3.2-1.6,6.9-1.7,10.2c-0.1,3.2,0.3,6.8,1,9.9c0.7,2.9,2,6.2,3.5,8.8 c1.4,2.5,3.4,5.1,5.4,7.2c1.9,1.9,4.4,3.8,6.8,5.2c2.2,1.3,5,2.4,7.5,3c2.3,0.6,5.1,0.9,7.6,0.8c2.3-0.1,4.9-0.5,7-1.3 c2-0.7,4.2-1.7,6-2.9c1.6-1.1,3.3-2.7,4.6-4.2c1.2-1.4,2.3-3.2,3-4.9c0.7-1.6,1.2-3.5,1.3-5.1c0.2-1.5,0.1-3.3-0.2-4.9 c-0.3-1.4-0.8-2.9-1.5-4.2c-0.6-1.1-1.5-2.3-2.4-3.2c-0.8-0.8-1.9-1.5-3-2c-0.9-0.4-2.1-0.7-3.1-0.8c-0.9-0.1-1.9,0-2.8,0.3 c-0.7,0.2-1.6,0.6-2.2,1.1c-0.5,0.4-1,1.1-1.3,1.7c-0.3,0.6-0.4,1.3-0.4,1.9c0,0.6,0.2,1.2,0.6,1.7c0.3,0.5,0.5,1.2,0.6,1.7 c0,0.6-0.1,1.3-0.4,1.9c-0.3,0.6-0.8,1.3-1.3,1.7c-0.6,0.5-1.4,0.9-2.2,1.1c-0.9,0.3-1.9,0.3-2.8,0.3c-1-0.1-2.2-0.4-3.1-0.8 c-1-0.5-2.1-1.2-3-2c-0.9-0.9-1.8-2.1-2.4-3.2c-0.7-1.2-1.2-2.8-1.5-4.2c-0.3-1.5-0.4-3.3-0.2-4.9c0.2-1.7,0.7-3.6,1.3-5.1 c0.7-1.7,1.8-3.5,3-4.9c1.3-1.5,3-3.1,4.6-4.2c1.8-1.2,4-2.3,6-2.9c2.2-0.7,4.8-1.2,7-1.3c2.4-0.1,5.2,0.2,7.6,0.8 c2.5,0.6,5.3,1.7,7.5,3c2.4,1.3,4.9,3.2,6.8,5.2c2,2,4,4.7,5.4,7.2c1.5,2.6,2.7,5.9,3.5,8.8c0.8,3.1,1.1,6.7,1,9.9 c-0.1,3.3-0.7,7.1-1.7,10.2c-1,3.3-2.7,6.9-4.6,9.8c-1.9,3-4.7,6.2-7.3,8.6c-2.8,2.5-6.4,5-9.7,6.6c-3.5,1.8-7.8,3.2-11.6,4 c-4,0.8-8.7,1.1-12.7,0.8c-4.2-0.3-9-1.3-12.9-2.7c-4.1-1.4-8.6-3.7-12.2-6.2c-3.7-2.6-7.6-6.1-10.5-9.5c-3-3.6-5.9-8.1-7.9-12.3 c-2-4.4-3.7-9.7-4.5-14.4c-0.8-4.9-1.1-10.6-0.6-15.6c0.5-5.1,1.8-10.8,3.6-15.6c1.8-4.9,4.7-10.3,7.8-14.5 c3.2-4.4,7.5-8.9,11.7-12.3c4.3-3.5,9.8-6.9,14.9-9.1c5.2-2.3,11.6-4.2,17.2-5c5.8-0.9,12.6-1,18.4-0.4c6,0.7,12.7,2.4,18.3,4.6 c5.7,2.3,12,5.7,16.9,9.4c5.1,3.8,10.3,8.9,14.2,13.8c4,5.1,7.8,11.5,10.3,17.5c2.6,6.1,4.6,13.5,5.5,20c0.9,6.7,1,14.5,0.1,21.2 c-0.9,6.9-2.9,14.6-5.5,21c-2.7,6.5-6.8,13.6-11,19.3c-4.4,5.7-10.3,11.7-16,16c-4.7,3.7-9.5,8.7-13.1,13.6 c-3.5,4.7-6.8,10.7-8.9,16.1c-2.1,5.3-3.6,11.7-4.3,17.4c-0.6,5.5-0.4,12,0.4,17.5c0.9,5.3,2.6,11.3,4.9,16.3c2.2,4.8,5.4,10,8.7,14 c3.2,3.9,7.6,8,11.7,10.9c4,2.9,9.1,5.6,13.8,7.3c4.5,1.7,9.9,2.9,14.7,3.3c4.6,0.4,10,0.2,14.6-0.7c4.4-0.8,9.4-2.4,13.5-4.3 c3.9-1.9,8.2-4.6,11.5-7.5c3.2-2.7,6.4-6.4,8.8-9.9c2.3-3.4,4.4-7.6,5.7-11.4c1.2-3.7,2.1-8.1,2.3-12c0.2-3.7-0.1-8.1-0.9-11.8 c-0.8-3.5-2.2-7.5-3.8-10.7c-1.6-3.1-3.9-6.3-6.2-8.9c-2.2-2.4-5.2-4.9-8-6.6c-2.7-1.7-6-3.2-9.1-4c-2.9-0.8-6.3-1.4-9.3-1.4 c-2.9,0-6.2,0.4-8.9,1.1c-2.6,0.7-5.5,1.9-7.9,3.3c-2.2,1.3-4.5,3.2-6.3,5c-1.7,1.8-3.3,4-4.4,6.2c-1.1,2-2,4.5-2.4,6.7 c-0.4,2.1-0.6,4.5-0.4,6.7c0.2,2,0.6,4.2,1.3,6.1c0.6,1.7,1.7,3.6,2.8,5.1c1,1.3,2.4,2.7,3.8,3.7c1.3,0.9,2.8,1.8,4.3,2.3 c1.3,0.5,2.9,0.8,4.4,0.8c1.3,0,2.7-0.1,4-0.5c1.1-0.3,2.3-0.9,3.2-1.6c0.8-0.6,1.7-1.4,2.2-2.3c0.5-0.7,0.9-1.7,1.2-2.6 c0.2-0.8,0.2-1.7,0.1-2.5c-0.1-0.7-0.4-1.4-0.8-2c-0.4-0.5-0.9-1-1.5-1.3C285,263.7,284.3,263.6,283.7,263.6L283.7,263.6z" />
</svg>
`)}`;
var LuteWallet = class extends BaseWallet {
  client = null;
  options;
  store;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    options,
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    if (!options?.siteName) {
      this.logger.error("Missing required option: siteName");
      throw new Error("Missing required option: siteName");
    }
    this.options = options;
    this.store = store;
  }
  static defaultMetadata = {
    name: "Lute",
    icon: ICON8
  };
  async initializeClient() {
    this.logger.info("Initializing client...");
    const module = await import("lute-connect");
    const LuteConnect = module.default;
    const client = new LuteConnect(this.options.siteName);
    this.client = client;
    this.logger.info("Client initialized");
    return client;
  }
  async getGenesisId() {
    const algodClient = this.getAlgodClient();
    const genesis = await algodClient.genesis().do();
    const genesisId = `${genesis.network}-${genesis.id}`;
    return genesisId;
  }
  connect = async () => {
    this.logger.info("Connecting...");
    const client = this.client || await this.initializeClient();
    const genesisId = await this.getGenesisId();
    const accounts = await client.connect(genesisId);
    if (accounts.length === 0) {
      this.logger.error("No accounts found!");
      throw new Error("No accounts found!");
    }
    const walletAccounts = accounts.map((address, idx) => ({
      name: `${this.metadata.name} Account ${idx + 1}`,
      address
    }));
    const activeAccount = walletAccounts[0];
    const walletState = {
      accounts: walletAccounts,
      activeAccount
    };
    addWallet(this.store, {
      walletId: this.id,
      wallet: walletState
    });
    this.logger.info("Connected successfully", walletState);
    return walletAccounts;
  };
  disconnect = async () => {
    this.onDisconnect();
    this.logger.info("Disconnected");
  };
  resumeSession = async () => {
    try {
      const state = this.store.state;
      const walletState = state.wallets[this.id];
      if (!walletState) {
        this.logger.info("No session to resume");
        return;
      }
      this.logger.info("Resuming session...");
      await this.initializeClient();
      this.logger.info("Session resumed successfully");
    } catch (error) {
      this.logger.error("Error resuming session:", error.message);
      this.onDisconnect();
      throw error;
    }
  };
  processTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txn, index) => {
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk7.encodeAddress(txn.from.publicKey);
      const canSignTxn = this.addresses.includes(signer);
      const txnString = byteArrayToBase64(txn.toByte());
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn: txnString });
      } else {
        txnsToSign.push({ txn: txnString, signers: [] });
      }
    });
    return txnsToSign;
  }
  processEncodedTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txnBuffer, index) => {
      const txnDecodeObj = algosdk7.decodeObj(txnBuffer);
      const isSigned = isSignedTxn(txnDecodeObj);
      const txn = isSigned ? algosdk7.decodeSignedTransaction(txnBuffer).txn : algosdk7.decodeUnsignedTransaction(txnBuffer);
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk7.encodeAddress(txn.from.publicKey);
      const canSignTxn = !isSigned && this.addresses.includes(signer);
      const txnString = byteArrayToBase64(txn.toByte());
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn: txnString });
      } else {
        txnsToSign.push({ txn: txnString, signers: [] });
      }
    });
    return txnsToSign;
  }
  signTransactions = async (txnGroup, indexesToSign) => {
    try {
      this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
      let txnsToSign = [];
      if (isTransactionArray(txnGroup)) {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processTxns(flatTxns, indexesToSign);
      } else {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processEncodedTxns(flatTxns, indexesToSign);
      }
      const client = this.client || await this.initializeClient();
      this.logger.debug("Sending processed transactions to wallet...", txnsToSign);
      const signTxnsResult = await client.signTxns(txnsToSign);
      this.logger.debug("Transactions signed successfully", signTxnsResult);
      return signTxnsResult;
    } catch (error) {
      if (isSignTxnsError(error)) {
        this.logger.error("Error signing transactions:", error.message, `(code: ${error.code})`);
        throw new SignTxnsError(error.message, error.code);
      }
      this.logger.error("Unknown error signing transactions:", error);
      throw error;
    }
  };
};

// src/wallets/magic.ts
import algosdk8 from "algosdk";
var ICON9 = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 47 47" xmlns="http://www.w3.org/2000/svg">
  <path fill="#6851FF" d="M 23.960861 1.80769 C 25.835077 4.103153 27.902216 6.23489 30.137539 8.178169 C 28.647968 13.009323 27.846092 18.142094 27.846092 23.462154 C 27.846092 28.782307 28.648062 33.915169 30.13763 38.746368 C 27.902216 40.689724 25.835077 42.821476 23.960861 45.116985 C 22.086554 42.821476 20.019415 40.689632 17.783998 38.746368 C 19.273476 33.915169 20.075445 28.7824 20.075445 23.462337 C 20.075445 18.142277 19.273476 13.009506 17.783998 8.178318 C 20.019415 6.235001 22.086554 4.10321 23.960861 1.80769 Z M 13.511427 35.406403 C 11.145139 33.747814 8.633816 32.282063 6.000269 31.031937 C 6.730776 28.637476 7.123754 26.095783 7.123754 23.462429 C 7.123754 20.828892 6.730762 18.287201 6.000235 15.892738 C 8.633816 14.642616 11.145175 13.176861 13.511501 11.518276 C 14.416311 15.352554 14.895074 19.351414 14.895074 23.462154 C 14.895074 27.572985 14.416283 31.571938 13.511427 35.406403 Z M 33.027046 23.462337 C 33.027046 27.572985 33.505753 31.571846 34.410553 35.406124 C 36.776859 33.747631 39.288094 32.281876 41.921539 31.031845 C 41.191017 28.637384 40.798061 26.095692 40.798061 23.462246 C 40.798061 20.8288 41.191017 18.287201 41.921539 15.89283 C 39.288094 14.642708 36.776768 13.177048 34.410553 11.518555 C 33.505753 15.352831 33.027046 19.351692 33.027046 23.462337 Z" />
</svg>
`)}`;
var MagicAuth = class extends BaseWallet {
  client = null;
  options;
  store;
  userInfo = null;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    options,
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    if (!options?.apiKey) {
      this.logger.error("Missing required option: apiKey");
      throw new Error("Missing required option: apiKey");
    }
    this.options = options;
    this.store = store;
  }
  static defaultMetadata = {
    name: "Magic",
    icon: ICON9
  };
  async initializeClient() {
    this.logger.info("Initializing client...");
    const Magic = (await Promise.resolve().then(() => (init_es4(), es_exports))).Magic;
    const AlgorandExtension = (await Promise.resolve().then(() => (init_es5(), es_exports2))).AlgorandExtension;
    const client = new Magic(this.options.apiKey, {
      extensions: {
        algorand: new AlgorandExtension({
          rpcUrl: ""
        })
      }
    });
    this.client = client;
    this.logger.info("Client initialized");
    return client;
  }
  connect = async (args) => {
    this.logger.info("Connecting...");
    if (!args?.email || typeof args.email !== "string") {
      this.logger.error("Magic Link provider requires an email (string) to connect");
      throw new Error("Magic Link provider requires an email (string) to connect");
    }
    const { email } = args;
    const client = this.client || await this.initializeClient();
    this.logger.info(`Logging in ${email}...`);
    await client.auth.loginWithMagicLink({ email });
    const userInfo = await client.user.getInfo();
    if (!userInfo) {
      this.logger.error("User info not found!");
      throw new Error("User info not found!");
    }
    if (!userInfo.publicAddress) {
      this.logger.error("No account found!");
      throw new Error("No account found!");
    }
    this.userInfo = userInfo;
    this.logger.info("Login successful", userInfo);
    const walletAccount = {
      name: userInfo.email ?? "Magic Wallet 1",
      address: userInfo.publicAddress
    };
    const walletState = {
      accounts: [walletAccount],
      activeAccount: walletAccount
    };
    addWallet(this.store, {
      walletId: this.id,
      wallet: walletState
    });
    this.logger.info("Connected successfully", walletState);
    return [walletAccount];
  };
  disconnect = async () => {
    this.logger.info("Disconnecting...");
    this.onDisconnect();
    const client = this.client || await this.initializeClient();
    this.logger.info(`Logging out ${this.userInfo?.email || "user"}...`);
    await client.user.logout();
    this.logger.info("Disconnected");
  };
  resumeSession = async () => {
    try {
      const state = this.store.state;
      const walletState = state.wallets[this.id];
      if (!walletState) {
        this.logger.info("No session to resume");
        return;
      }
      this.logger.info("Resuming session...");
      const client = this.client || await this.initializeClient();
      const isLoggedIn = await client.user.isLoggedIn();
      if (!isLoggedIn) {
        this.logger.warn("Not logged in, please reconnect...");
        this.onDisconnect();
        return;
      }
      const userInfo = await client.user.getInfo();
      if (!userInfo) {
        await client.user.logout();
        this.logger.error("User info not found!");
        throw new Error("User info not found!");
      }
      if (!userInfo.publicAddress) {
        await client.user.logout();
        this.logger.error("No account found!");
        throw new Error("No account found!");
      }
      this.userInfo = userInfo;
      const walletAccount = {
        name: userInfo.email ?? `${this.metadata.name} Account 1`,
        address: userInfo.publicAddress
      };
      const storedAccount = walletState.accounts[0];
      const { name, address } = walletAccount;
      const { name: storedName, address: storedAddress } = storedAccount;
      const match = name === storedName && address === storedAddress;
      if (!match) {
        this.logger.warn("Session account mismatch, updating account", {
          prev: storedAccount,
          current: walletAccount
        });
        setAccounts(this.store, {
          walletId: this.id,
          accounts: [walletAccount]
        });
      }
      this.logger.info("Session resumed successfully");
    } catch (error) {
      this.logger.error("Error resuming session:", error.message);
      this.onDisconnect();
      throw error;
    }
  };
  processTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txn, index) => {
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk8.encodeAddress(txn.from.publicKey);
      const canSignTxn = this.addresses.includes(signer);
      const txnString = byteArrayToBase64(txn.toByte());
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn: txnString });
      } else {
        txnsToSign.push({ txn: txnString, signers: [] });
      }
    });
    return txnsToSign;
  }
  processEncodedTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txnBuffer, index) => {
      const txnDecodeObj = algosdk8.decodeObj(txnBuffer);
      const isSigned = isSignedTxn(txnDecodeObj);
      const txn = isSigned ? algosdk8.decodeSignedTransaction(txnBuffer).txn : algosdk8.decodeUnsignedTransaction(txnBuffer);
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk8.encodeAddress(txn.from.publicKey);
      const canSignTxn = !isSigned && this.addresses.includes(signer);
      const txnString = byteArrayToBase64(txn.toByte());
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn: txnString });
      } else {
        txnsToSign.push({ txn: txnString, signers: [] });
      }
    });
    return txnsToSign;
  }
  signTransactions = async (txnGroup, indexesToSign) => {
    try {
      this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
      let txnsToSign = [];
      if (isTransactionArray(txnGroup)) {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processTxns(flatTxns, indexesToSign);
      } else {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processEncodedTxns(flatTxns, indexesToSign);
      }
      const client = this.client || await this.initializeClient();
      this.logger.debug("Sending processed transactions to wallet...", txnsToSign);
      const signTxnsResult = await client.algorand.signGroupTransactionV2(
        txnsToSign
      );
      this.logger.debug("Received signed transactions from wallet", signTxnsResult);
      const result = signTxnsResult.map((value) => {
        if (value === void 0) {
          return null;
        }
        return base64ToByteArray(value);
      });
      this.logger.debug("Transactions signed successfully", result);
      return result;
    } catch (error) {
      this.logger.error("Error signing transactions:", error.message);
      throw error;
    }
  };
};

// src/wallets/mnemonic.ts
import algosdk9 from "algosdk";
var LOCAL_STORAGE_MNEMONIC_KEY = `${LOCAL_STORAGE_KEY}_mnemonic`;
var ICON10 = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
  <rect fill="#525252" width="400" height="400" />
  <path fill="#FFFFFF" d="M309.2,309.3H275l-22.2-82.7l-47.9,82.7h-38.3l73.9-128l-11.9-44.5l-99.6,172.6H90.8L217.1,90.6 h33.5l14.7,54.3h34.6l-23.6,41L309.2,309.3z" />
</svg>
`)}`;
var MnemonicWallet = class extends BaseWallet {
  account = null;
  options;
  store;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    options,
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    const { persistToStorage = false } = options || {};
    this.options = { persistToStorage };
    this.store = store;
    if (this.options.persistToStorage) {
      this.logger.warn(
        "Persisting mnemonics to storage is insecure. Any private key mnemonics used should never hold real Algos (i.e., on MainNet). Use with caution!"
      );
    }
  }
  static defaultMetadata = {
    name: "Mnemonic",
    icon: ICON10
  };
  loadMnemonicFromStorage() {
    return StorageAdapter.getItem(LOCAL_STORAGE_MNEMONIC_KEY);
  }
  saveMnemonicToStorage(mnemonic) {
    StorageAdapter.setItem(LOCAL_STORAGE_MNEMONIC_KEY, mnemonic);
  }
  checkMainnet() {
    try {
      const network = this.activeNetwork;
      if (network === "mainnet" /* MAINNET */) {
        this.logger.warn(
          "The Mnemonic wallet provider is insecure and intended for testing only. Any private key mnemonics used should never hold real Algos (i.e., on MainNet)."
        );
        throw new Error("MainNet active network detected. Aborting.");
      }
    } catch (error) {
      this.disconnect();
      throw error;
    }
  }
  initializeAccount() {
    let mnemonic = this.loadMnemonicFromStorage();
    if (!mnemonic) {
      mnemonic = prompt("Enter 25-word mnemonic passphrase:");
      if (!mnemonic) {
        this.account = null;
        this.logger.error("No mnemonic provided");
        throw new Error("No mnemonic provided");
      }
      if (this.options.persistToStorage) {
        this.logger.warn("Mnemonic saved to localStorage.");
        this.saveMnemonicToStorage(mnemonic);
      }
    }
    const account = algosdk9.mnemonicToSecretKey(mnemonic);
    this.account = account;
    return account;
  }
  connect = async () => {
    this.checkMainnet();
    this.logger.info("Connecting...");
    const account = this.initializeAccount();
    const walletAccount = {
      name: `${this.metadata.name} Account`,
      address: account.addr
    };
    const walletState = {
      accounts: [walletAccount],
      activeAccount: walletAccount
    };
    addWallet(this.store, {
      walletId: this.id,
      wallet: walletState
    });
    this.logger.info("Connected successfully", walletState);
    return [walletAccount];
  };
  disconnect = async () => {
    this.logger.info("Disconnecting...");
    this.onDisconnect();
    this.account = null;
    this.logger.info("Disconnected");
  };
  resumeSession = async () => {
    this.checkMainnet();
    const state = this.store.state;
    const walletState = state.wallets[this.id];
    if (walletState) {
      this.logger.info("No session to resume, disconnecting...");
      this.disconnect();
    } else {
      this.logger.info("No session to resume");
    }
  };
  processTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txn, index) => {
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk9.encodeAddress(txn.from.publicKey);
      const canSignTxn = signer === this.account.addr;
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push(txn);
      }
    });
    return txnsToSign;
  }
  processEncodedTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txnBuffer, index) => {
      const txnDecodeObj = algosdk9.decodeObj(txnBuffer);
      const isSigned = isSignedTxn(txnDecodeObj);
      const txn = isSigned ? algosdk9.decodeSignedTransaction(txnBuffer).txn : algosdk9.decodeUnsignedTransaction(txnBuffer);
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk9.encodeAddress(txn.from.publicKey);
      const canSignTxn = !isSigned && signer === this.account.addr;
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push(txn);
      }
    });
    return txnsToSign;
  }
  signTransactions = async (txnGroup, indexesToSign) => {
    this.checkMainnet();
    try {
      this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
      let txnsToSign = [];
      if (isTransactionArray(txnGroup)) {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processTxns(flatTxns, indexesToSign);
      } else {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processEncodedTxns(flatTxns, indexesToSign);
      }
      const signedTxns = txnsToSign.map((txn) => txn.signTxn(this.account.sk));
      this.logger.debug("Transactions signed successfully", { signedTxns });
      return signedTxns;
    } catch (error) {
      this.logger.error("Error signing transactions:", error.message);
      throw error;
    }
  };
};

// src/wallets/pera.ts
import algosdk10 from "algosdk";
var ICON11 = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <rect fill="#FFEE55" width="200" height="200" />
  <path fill="#1C1C1C" d="M106.1,64.3c2.2,9.1,1.5,17-1.7,17.8c-3.1,0.8-7.4-6-9.6-15c-2.2-9.1-1.5-17,1.7-17.8 C99.6,48.5,103.9,55.2,106.1,64.3z" />
  <path fill="#1C1C1C" d="M142.2,72.1c-4.8-5.1-14.5-3.7-21.6,3.1c-7,6.9-8.8,16.6-4,21.7c4.8,5.1,14.5,3.7,21.6-3.1 C145.3,86.9,147.1,77.2,142.2,72.1z" />
  <path fill="#1C1C1C" d="M103.7,150.8c3.1-0.8,3.7-9.2,1.4-18.8c-2.3-9.6-6.7-16.8-9.8-16c-3.1,0.8-3.7,9.2-1.4,18.8 C96.2,144.3,100.6,151.5,103.7,150.8z" />
  <path fill="#1C1C1C" d="M72.1,76.8c9,2.6,15.5,7.3,14.6,10.3c-0.9,3.1-8.9,3.4-17.8,0.8s-15.5-7.3-14.6-10.3 C55.1,74.5,63.1,74.1,72.1,76.8z" />
  <path fill="#1C1C1C" d="M130.2,111.5c9.5,2.8,16.5,7.6,15.6,10.6c-0.9,3.1-9.3,3.3-18.8,0.5c-9.5-2.8-16.5-7.6-15.6-10.6 C112.2,108.9,120.7,108.7,130.2,111.5z" />
  <path fill="#1C1C1C" d="M82.1,105c-2.2-2.3-9.5,1-16.3,7.5c-6.8,6.4-10.4,13.5-8.2,15.8c2.2,2.3,9.5-1,16.3-7.5 C80.7,114.4,84.3,107.3,82.1,105z" />
</svg>
`)}`;
var PeraWallet = class extends BaseWallet {
  client = null;
  options;
  store;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    options = {},
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    this.options = options;
    this.store = store;
  }
  static defaultMetadata = {
    name: "Pera",
    icon: ICON11
  };
  async initializeClient() {
    this.logger.info("Initializing client...");
    const module = await import("@perawallet/connect");
    const PeraWalletConnect = module.default ? module.default.PeraWalletConnect : module.PeraWalletConnect;
    const client = new PeraWalletConnect(this.options);
    this.client = client;
    this.logger.info("Client initialized");
    return client;
  }
  connect = async () => {
    this.logger.info("Connecting...");
    const currentActiveWallet = this.store.state.activeWallet;
    if (currentActiveWallet && currentActiveWallet !== this.id) {
      this.manageWalletConnectSession("backup", currentActiveWallet);
    }
    const client = this.client || await this.initializeClient();
    const accounts = await client.connect();
    client.connector?.on("disconnect", this.onDisconnect);
    if (accounts.length === 0) {
      this.logger.error("No accounts found!");
      throw new Error("No accounts found!");
    }
    const walletAccounts = accounts.map((address, idx) => ({
      name: `${this.metadata.name} Account ${idx + 1}`,
      address
    }));
    const activeAccount = walletAccounts[0];
    const walletState = {
      accounts: walletAccounts,
      activeAccount
    };
    addWallet(this.store, {
      walletId: this.id,
      wallet: walletState
    });
    this.logger.info("Connected successfully", walletState);
    return walletAccounts;
  };
  disconnect = async () => {
    this.logger.info("Disconnecting...");
    const client = this.client || await this.initializeClient();
    const currentActiveWallet = this.store.state.activeWallet;
    if (currentActiveWallet && currentActiveWallet !== this.id) {
      this.manageWalletConnectSession("backup", currentActiveWallet);
      this.manageWalletConnectSession("restore", this.id);
      await client.disconnect();
      await new Promise((resolve) => setTimeout(resolve, 500));
      this.manageWalletConnectSession("restore", currentActiveWallet);
    } else {
      await client.disconnect();
    }
    this.onDisconnect();
    this.logger.info("Disconnected");
  };
  setActive = () => {
    this.logger.info(`Set active wallet: ${this.id}`);
    const currentActiveWallet = this.store.state.activeWallet;
    if (currentActiveWallet && currentActiveWallet !== this.id) {
      this.manageWalletConnectSession("backup", currentActiveWallet);
    }
    this.manageWalletConnectSession("restore");
    setActiveWallet(this.store, { walletId: this.id });
  };
  resumeSession = async () => {
    try {
      const state = this.store.state;
      const walletState = state.wallets[this.id];
      if (!walletState) {
        this.logger.info("No session to resume");
        return;
      }
      this.logger.info("Resuming session...");
      const client = this.client || await this.initializeClient();
      const accounts = await client.reconnectSession();
      if (accounts.length === 0) {
        this.logger.error("No accounts found!");
        throw new Error("No accounts found!");
      }
      const walletAccounts = accounts.map((address, idx) => ({
        name: `${this.metadata.name} Account ${idx + 1}`,
        address
      }));
      const match = compareAccounts(walletAccounts, walletState.accounts);
      if (!match) {
        this.logger.warn("Session accounts mismatch, updating accounts", {
          prev: walletState.accounts,
          current: walletAccounts
        });
        setAccounts(this.store, {
          walletId: this.id,
          accounts: walletAccounts
        });
      }
      this.logger.info("Session resumed successfully");
    } catch (error) {
      this.logger.error("Error resuming session:", error.message);
      this.onDisconnect();
      throw error;
    }
  };
  processTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txn, index) => {
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk10.encodeAddress(txn.from.publicKey);
      const canSignTxn = this.addresses.includes(signer);
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn });
      } else {
        txnsToSign.push({ txn, signers: [] });
      }
    });
    return txnsToSign;
  }
  processEncodedTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txnBuffer, index) => {
      const txnDecodeObj = algosdk10.decodeObj(txnBuffer);
      const isSigned = isSignedTxn(txnDecodeObj);
      const txn = isSigned ? algosdk10.decodeSignedTransaction(txnBuffer).txn : algosdk10.decodeUnsignedTransaction(txnBuffer);
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk10.encodeAddress(txn.from.publicKey);
      const canSignTxn = !isSigned && this.addresses.includes(signer);
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn });
      } else {
        txnsToSign.push({ txn, signers: [] });
      }
    });
    return txnsToSign;
  }
  signTransactions = async (txnGroup, indexesToSign) => {
    try {
      this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
      let txnsToSign = [];
      if (isTransactionArray(txnGroup)) {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processTxns(flatTxns, indexesToSign);
      } else {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processEncodedTxns(flatTxns, indexesToSign);
      }
      const client = this.client || await this.initializeClient();
      this.logger.debug("Sending processed transactions to wallet...", [txnsToSign]);
      const signedTxns = await client.signTransaction([txnsToSign]);
      this.logger.debug("Received signed transactions from wallet", signedTxns);
      const result = txnsToSign.reduce((acc, txn) => {
        if (txn.signers && txn.signers.length == 0) {
          acc.push(null);
        } else {
          const signedTxn = signedTxns.shift();
          if (signedTxn) {
            acc.push(signedTxn);
          }
        }
        return acc;
      }, []);
      this.logger.debug("Transactions signed successfully", result);
      return result;
    } catch (error) {
      this.logger.error("Error signing transactions:", error.message);
      throw error;
    }
  };
};

// src/wallets/pera2.ts
import algosdk11 from "algosdk";
var ICON12 = `data:image/svg+xml;base64,${btoa(`
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <rect fill="#FFEE55" width="200" height="200" />
  <path fill="#1C1C1C" d="M106.1,64.3c2.2,9.1,1.5,17-1.7,17.8c-3.1,0.8-7.4-6-9.6-15c-2.2-9.1-1.5-17,1.7-17.8 C99.6,48.5,103.9,55.2,106.1,64.3z" />
  <path fill="#1C1C1C" d="M142.2,72.1c-4.8-5.1-14.5-3.7-21.6,3.1c-7,6.9-8.8,16.6-4,21.7c4.8,5.1,14.5,3.7,21.6-3.1 C145.3,86.9,147.1,77.2,142.2,72.1z" />
  <path fill="#1C1C1C" d="M103.7,150.8c3.1-0.8,3.7-9.2,1.4-18.8c-2.3-9.6-6.7-16.8-9.8-16c-3.1,0.8-3.7,9.2-1.4,18.8 C96.2,144.3,100.6,151.5,103.7,150.8z" />
  <path fill="#1C1C1C" d="M72.1,76.8c9,2.6,15.5,7.3,14.6,10.3c-0.9,3.1-8.9,3.4-17.8,0.8s-15.5-7.3-14.6-10.3 C55.1,74.5,63.1,74.1,72.1,76.8z" />
  <path fill="#1C1C1C" d="M130.2,111.5c9.5,2.8,16.5,7.6,15.6,10.6c-0.9,3.1-9.3,3.3-18.8,0.5c-9.5-2.8-16.5-7.6-15.6-10.6 C112.2,108.9,120.7,108.7,130.2,111.5z" />
  <path fill="#1C1C1C" d="M82.1,105c-2.2-2.3-9.5,1-16.3,7.5c-6.8,6.4-10.4,13.5-8.2,15.8c2.2,2.3,9.5-1,16.3-7.5 C80.7,114.4,84.3,107.3,82.1,105z" />
</svg>
`)}`;
var PeraWallet2 = class extends BaseWallet {
  client = null;
  options;
  store;
  constructor({
    id,
    store,
    subscribe,
    getAlgodClient,
    options,
    metadata = {}
  }) {
    super({ id, metadata, getAlgodClient, store, subscribe });
    if (!options?.projectId) {
      this.logger.error("Missing required option: projectId");
      throw new Error("Missing required option: projectId");
    }
    this.options = options;
    this.store = store;
  }
  static defaultMetadata = {
    name: "Pera",
    icon: ICON12
  };
  async initializeClient() {
    this.logger.info("Initializing client...");
    const module = await import("@perawallet/connect-beta");
    const PeraWalletConnect = module.PeraWalletConnect || module.default.PeraWalletConnect;
    const client = new PeraWalletConnect(this.options);
    this.client = client;
    this.logger.info("Client initialized");
    return client;
  }
  connect = async () => {
    this.logger.info("Connecting...");
    const client = this.client || await this.initializeClient();
    const accounts = await client.connect();
    client.client?.on("session_delete", this.onDisconnect);
    if (accounts.length === 0) {
      this.logger.error("No accounts found!");
      throw new Error("No accounts found!");
    }
    const walletAccounts = accounts.map((address, idx) => ({
      name: `${this.metadata.name} Account ${idx + 1}`,
      address
    }));
    const activeAccount = walletAccounts[0];
    const walletState = {
      accounts: walletAccounts,
      activeAccount
    };
    addWallet(this.store, {
      walletId: this.id,
      wallet: walletState
    });
    this.logger.info("Connected successfully", walletState);
    return walletAccounts;
  };
  disconnect = async () => {
    this.logger.info("Disconnecting...");
    this.onDisconnect();
    const client = this.client || await this.initializeClient();
    await client.disconnect();
    this.logger.info("Disconnected");
  };
  resumeSession = async () => {
    try {
      const state = this.store.state;
      const walletState = state.wallets[this.id];
      if (!walletState) {
        this.logger.info("No session to resume");
        return;
      }
      this.logger.info("Resuming session...");
      const client = this.client || await this.initializeClient();
      const accounts = await client.reconnectSession();
      if (accounts.length === 0) {
        this.logger.error("No accounts found!");
        throw new Error("No accounts found!");
      }
      const walletAccounts = accounts.map((address, idx) => ({
        name: `${this.metadata.name} Account ${idx + 1}`,
        address
      }));
      const match = compareAccounts(walletAccounts, walletState.accounts);
      if (!match) {
        this.logger.warn("Session accounts mismatch, updating accounts", {
          prev: walletState.accounts,
          current: walletAccounts
        });
        setAccounts(this.store, {
          walletId: this.id,
          accounts: walletAccounts
        });
      }
      this.logger.info("Session resumed successfully");
    } catch (error) {
      this.logger.error("Error resuming session:", error.message);
      this.onDisconnect();
      throw error;
    }
  };
  processTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txn, index) => {
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk11.encodeAddress(txn.from.publicKey);
      const canSignTxn = this.addresses.includes(signer);
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn });
      } else {
        txnsToSign.push({ txn, signers: [] });
      }
    });
    return txnsToSign;
  }
  processEncodedTxns(txnGroup, indexesToSign) {
    const txnsToSign = [];
    txnGroup.forEach((txnBuffer, index) => {
      const txnDecodeObj = algosdk11.decodeObj(txnBuffer);
      const isSigned = isSignedTxn(txnDecodeObj);
      const txn = isSigned ? algosdk11.decodeSignedTransaction(txnBuffer).txn : algosdk11.decodeUnsignedTransaction(txnBuffer);
      const isIndexMatch = !indexesToSign || indexesToSign.includes(index);
      const signer = algosdk11.encodeAddress(txn.from.publicKey);
      const canSignTxn = !isSigned && this.addresses.includes(signer);
      if (isIndexMatch && canSignTxn) {
        txnsToSign.push({ txn });
      } else {
        txnsToSign.push({ txn, signers: [] });
      }
    });
    return txnsToSign;
  }
  signTransactions = async (txnGroup, indexesToSign) => {
    try {
      this.logger.debug("Signing transactions...", { txnGroup, indexesToSign });
      let txnsToSign = [];
      if (isTransactionArray(txnGroup)) {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processTxns(flatTxns, indexesToSign);
      } else {
        const flatTxns = flattenTxnGroup(txnGroup);
        txnsToSign = this.processEncodedTxns(flatTxns, indexesToSign);
      }
      const client = this.client || await this.initializeClient();
      this.logger.debug("Sending processed transactions to wallet...", [txnsToSign]);
      const signedTxns = await client.signTransaction([txnsToSign]);
      this.logger.debug("Received signed transactions from wallet", signedTxns);
      const result = txnsToSign.reduce((acc, txn) => {
        if (txn.signers && txn.signers.length == 0) {
          acc.push(null);
        } else {
          const signedTxn = signedTxns.shift();
          if (signedTxn) {
            acc.push(signedTxn);
          }
        }
        return acc;
      }, []);
      this.logger.debug("Transactions signed successfully", result);
      return result;
    } catch (error) {
      this.logger.error("Error signing transactions:", error.message);
      throw error;
    }
  };
};

// src/utils.ts
function createWalletMap() {
  return {
    ["biatec" /* BIATEC */]: BiatecWallet,
    ["custom" /* CUSTOM */]: CustomWallet,
    ["defly" /* DEFLY */]: DeflyWallet,
    ["exodus" /* EXODUS */]: ExodusWallet,
    ["kibisis" /* KIBISIS */]: KibisisWallet,
    ["kmd" /* KMD */]: KmdWallet,
    ["lute" /* LUTE */]: LuteWallet,
    ["magic" /* MAGIC */]: MagicAuth,
    ["mnemonic" /* MNEMONIC */]: MnemonicWallet,
    ["pera" /* PERA */]: PeraWallet,
    ["pera-beta" /* PERA2 */]: PeraWallet2,
    ["walletconnect" /* WALLETCONNECT */]: WalletConnect
  };
}
function compareAccounts(accounts, compareTo) {
  const addresses = new Set(accounts.map((account) => account.address));
  const compareAddresses = new Set(compareTo.map((account) => account.address));
  if (addresses.size !== compareAddresses.size) {
    return false;
  }
  for (const address of addresses) {
    if (!compareAddresses.has(address)) {
      return false;
    }
  }
  return true;
}
function base64ToByteArray(blob) {
  return stringToByteArray(atob(blob));
}
function byteArrayToBase64(array) {
  return btoa(byteArrayToString(array));
}
function stringToByteArray(str) {
  const array = new Uint8Array(str.length);
  for (let i = 0; i < str.length; i++) {
    array[i] = str.charCodeAt(i);
  }
  return array;
}
function byteArrayToString(array) {
  let result = "";
  for (let i = 0; i < array.length; i++) {
    result += String.fromCharCode(array[i]);
  }
  return result;
}
function isSignedTxn(txnDecodeObj) {
  return txnDecodeObj.txn !== void 0;
}
function isTransaction(item) {
  return item && typeof item === "object" && "genesisID" in item && typeof item.genesisID === "string";
}
function isTransactionArray(txnGroup) {
  if (!Array.isArray(txnGroup) || txnGroup.length === 0) {
    return false;
  }
  if (isTransaction(txnGroup[0])) {
    return true;
  }
  if (Array.isArray(txnGroup[0]) && txnGroup[0].length > 0 && isTransaction(txnGroup[0][0])) {
    return true;
  }
  return false;
}
function flattenTxnGroup(txnGroup) {
  return Array.isArray(txnGroup[0]) ? txnGroup.flat() : txnGroup;
}
function getPayloadId() {
  const date = Date.now() * Math.pow(10, 3);
  const extra = Math.floor(Math.random() * Math.pow(10, 3));
  return date + extra;
}
function formatJsonRpcRequest(method, params) {
  return {
    id: getPayloadId(),
    jsonrpc: "2.0",
    method,
    params
  };
}
function deepMerge(target, source) {
  const isObject = (obj) => obj && typeof obj === "object";
  if (!isObject(target) || !isObject(source)) {
    throw new Error("Target and source must be objects");
  }
  Object.keys(source).forEach((key) => {
    const targetValue = target[key];
    const sourceValue = source[key];
    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      target[key] = targetValue.concat(sourceValue);
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      target[key] = deepMerge(Object.assign({}, targetValue), sourceValue);
    } else {
      target[key] = sourceValue;
    }
  });
  return target;
}

// src/manager.ts
var WalletManager = class {
  _clients = /* @__PURE__ */ new Map();
  networkConfig;
  store;
  subscribe;
  options;
  logger;
  constructor({
    wallets = [],
    network = "testnet" /* TESTNET */,
    algod = {},
    options = {}
  } = {}) {
    this.logger = this.initializeLogger(options);
    this.logger.debug("Initializing WalletManager with config:", {
      wallets,
      network,
      algod,
      options
    });
    this.networkConfig = this.initNetworkConfig(network, algod);
    this.options = { resetNetwork: options.resetNetwork || false };
    const persistedState = this.loadPersistedState();
    const activeNetwork = this.options.resetNetwork ? network : persistedState?.activeNetwork || network;
    const algodClient = this.createAlgodClient(activeNetwork);
    const initialState = {
      ...defaultState,
      ...persistedState,
      activeNetwork,
      algodClient
    };
    this.store = new Store(initialState, {
      onUpdate: () => this.savePersistedState()
    });
    this.savePersistedState();
    this.subscribe = (callback) => {
      const unsubscribe = this.store.subscribe(() => {
        callback(this.store.state);
      });
      return unsubscribe;
    };
    this.initializeWallets(wallets);
  }
  // ---------- Logging ----------------------------------------------- //
  initializeLogger(options) {
    const logLevel = this.determineLogLevel(options);
    Logger.setLevel(logLevel);
    return logger.createScopedLogger("WalletManager");
  }
  determineLogLevel(options) {
    if (options?.debug) {
      return 0 /* DEBUG */;
    }
    return options?.logLevel !== void 0 ? options.logLevel : 2 /* WARN */;
  }
  // ---------- Store ------------------------------------------------- //
  get algodClient() {
    return this.store.state.algodClient;
  }
  set algodClient(algodClient) {
    this.store.setState((state) => ({
      ...state,
      algodClient
    }));
  }
  loadPersistedState() {
    try {
      const serializedState = StorageAdapter.getItem(LOCAL_STORAGE_KEY);
      if (serializedState === null) {
        return null;
      }
      const parsedState = JSON.parse(serializedState);
      if (!isValidState(parsedState)) {
        this.logger.warn("Parsed state:", parsedState);
        throw new Error("Persisted state is invalid");
      }
      return parsedState;
    } catch (error) {
      this.logger.error(`Could not load state from local storage: ${error.message}`);
      return null;
    }
  }
  savePersistedState() {
    try {
      const { wallets, activeWallet, activeNetwork } = this.store.state;
      const persistedState = { wallets, activeWallet, activeNetwork };
      const serializedState = JSON.stringify(persistedState);
      StorageAdapter.setItem(LOCAL_STORAGE_KEY, serializedState);
    } catch (error) {
      this.logger.error("Could not save state to local storage:", error);
    }
  }
  // ---------- Wallets ----------------------------------------------- //
  initializeWallets(walletsConfig) {
    this.logger.info("Initializing wallets...");
    for (const walletConfig of walletsConfig) {
      let walletId;
      let walletOptions;
      let walletMetadata;
      if (typeof walletConfig === "string") {
        walletId = walletConfig;
      } else {
        const { id, options, metadata } = walletConfig;
        walletId = id;
        walletOptions = options;
        walletMetadata = metadata;
      }
      const walletMap = createWalletMap();
      const WalletClass = walletMap[walletId];
      if (!WalletClass) {
        this.logger.error(`Wallet not found: ${walletId}`);
        continue;
      }
      const walletInstance = new WalletClass({
        id: walletId,
        metadata: walletMetadata,
        options: walletOptions,
        getAlgodClient: this.getAlgodClient,
        store: this.store,
        subscribe: this.subscribe
      });
      this._clients.set(walletId, walletInstance);
      this.logger.info(`\u2705 Initialized ${walletId}`);
    }
    const state = this.store.state;
    const connectedWallets = Object.keys(state.wallets);
    for (const walletId of connectedWallets) {
      if (!this._clients.has(walletId)) {
        this.logger.warn(`Connected wallet not found: ${walletId}`);
        removeWallet(this.store, { walletId });
      }
    }
    if (state.activeWallet && !this._clients.has(state.activeWallet)) {
      this.logger.warn(`Active wallet not found: ${state.activeWallet}`);
      setActiveWallet(this.store, { walletId: null });
    }
  }
  get wallets() {
    return [...this._clients.values()];
  }
  getWallet(walletId) {
    return this._clients.get(walletId);
  }
  async resumeSessions() {
    const promises = this.wallets.map((wallet) => wallet?.resumeSession());
    await Promise.all(promises);
  }
  async disconnect() {
    const promises = this.wallets.filter((wallet) => wallet.isConnected).map((wallet) => wallet?.disconnect());
    await Promise.all(promises);
  }
  // ---------- Network ----------------------------------------------- //
  initNetworkConfig(network, config) {
    this.logger.info("Initializing network...");
    let networkConfig = createDefaultNetworkConfig();
    if (isNetworkConfigMap(config)) {
      networkConfig = deepMerge(networkConfig, config);
    } else {
      networkConfig[network] = deepMerge(networkConfig[network], config);
    }
    this.logger.debug("Algodv2 config:", networkConfig);
    return networkConfig;
  }
  createAlgodClient(networkId) {
    this.logger.info(`Creating Algodv2 client for ${networkId}...`);
    const { token = "", baseServer, port = "", headers = {} } = this.networkConfig[networkId];
    return new algosdk12.Algodv2(token, baseServer, port, headers);
  }
  getAlgodClient = () => {
    return this.algodClient;
  };
  setActiveNetwork = async (networkId) => {
    if (this.activeNetwork === networkId) {
      return;
    }
    const algodClient = this.createAlgodClient(networkId);
    setActiveNetwork(this.store, { networkId, algodClient });
    this.logger.info(`\u2705 Active network set to ${networkId}.`);
  };
  get activeNetwork() {
    return this.store.state.activeNetwork;
  }
  // ---------- Active Wallet ----------------------------------------- //
  get activeWallet() {
    const state = this.store.state;
    const activeWallet = this.wallets.find((wallet) => wallet.id === state.activeWallet);
    if (!activeWallet) {
      return null;
    }
    return activeWallet;
  }
  get activeWalletAccounts() {
    if (!this.activeWallet) {
      return null;
    }
    return this.activeWallet.accounts;
  }
  get activeWalletAddresses() {
    if (!this.activeWallet) {
      return null;
    }
    return this.activeWallet.accounts.map((account) => account.address);
  }
  get activeAccount() {
    if (!this.activeWallet) {
      return null;
    }
    return this.activeWallet.activeAccount;
  }
  get activeAddress() {
    if (!this.activeAccount) {
      return null;
    }
    return this.activeAccount.address;
  }
  // ---------- Sign Transactions ------------------------------------- //
  get signTransactions() {
    if (!this.activeWallet) {
      this.logger.error("No active wallet found!");
      throw new Error("No active wallet found!");
    }
    return this.activeWallet.signTransactions;
  }
  get transactionSigner() {
    if (!this.activeWallet) {
      this.logger.error("No active wallet found!");
      throw new Error("No active wallet found!");
    }
    return this.activeWallet.transactionSigner;
  }
};
export {
  BaseWallet,
  CustomWallet,
  DeflyWallet,
  ExodusWallet,
  ICON6 as ICON,
  KIBISIS_AVM_WEB_PROVIDER_ID,
  KibisisWallet,
  KmdWallet,
  LOCAL_STORAGE_MNEMONIC_KEY,
  LogLevel,
  MagicAuth,
  MnemonicWallet,
  NetworkId,
  PeraWallet,
  SessionError,
  SignTxnsError,
  StorageAdapter,
  WalletConnect,
  WalletId,
  WalletManager,
  defaultState,
  isAVMWebProviderSDKError
};
//# sourceMappingURL=index.js.map